// Lazy-loaded locale: en
export default {
    translation: {
        "pricing": {
      "hero": {
        "badge": "Launch Special Offer",
        "title": "Invest in Your Future",
        "subtitle": "Select a plan to see how we can help you succeed."
      },
      "plans": {
        "labels": {
          "popular": "Most Popular"
        },
        "cycles": {
          "once": "once",
          "month": "month",
          "quarter": "3 months"
        },
        "free": {
          "name": "Free",
          "description": "Test the platform before you commit.",
          "features": [
            "1 Full Practice Exam",
            "Limited Access to Lessons",
            "Basic Grammar Overviews",
            "Restricted Wortschatz Access"
          ]
        },
        "monthly": {
          "name": "Monthly",
          "description": "Intensive preparation with Logami's AI support.",
          "features": [
            "Unlimited Access to All mock exams",
            "1 free consultation with a German examiner per month",
            "Instant Logami's AI Module Feedback",
            "Full Grammar & Vocab Exercises",
            "Module-Specific Pass Strategies",
            "Comprehensive Exam Lessons"
          ]
        },
        "quarterly": {
          "name": "3 Months",
          "description": "Maximum support for total confidence.",
          "features": [
            "Everything in 1-Month Plan",
            "3 free consultations with a German examiner (1 per month)",
            "Personalized Error Correction",
            "Extended Study Duration",
            "Priority Support Access"
          ]
        }
      },
      "cta": {
        "ready": "Ready to start with",
        "button": "Get Started Now"
      },
      "faq": {
        "title": "Common Questions",
        "all": "See All Questions",
        "cancel": {
          "q": "Can I get a refund?",
          "a": "Yes. If you're not satisfied, contact support within 7 days of purchase for a full refund, no questions asked."
        },
        "trial": {
          "q": "How does the Free Trial reminder work?",
          "a": "We send an email reminder 48 hours before your 7-day trial ends."
        }
      },
      "reviews": {
        "write": "Write a Review"
      },
      "consultation": {
        "title": "Book Consultation",
        "subtitle": "Schedule a personal consultation with our experts",
        "loading": "Loading consultation data...",
        "locked": "Consultation Locked",
        "requiresQuarterly": "Consultations are only available with the quarterly and monthly plans.",
        "viewPlans": "View Plans",
        "remaining": "Remaining Consultations",
        "notQuarterly": "You need a quarterly or monthly plan to book consultations.",
        "loadError": "Error loading consultation data",
        "slotsError": "Error loading available time slots",
        "pastDate": "You cannot book an appointment in the past",
        "unavailableDay": "Consultations are only available on Monday, Tuesday, and Thursday",
        "selectDateAndTime": "Please select a date and time",
        "noRemaining": "You have no remaining consultations",
        "bookingError": "Error booking appointment",
        "bookingSuccess": "Appointment booked successfully!",
        "emailVerification": "A confirmation email has been sent to you",
        "zoomMeeting": "Zoom meeting link has been created",
        "bookAppointment": "Book Appointment",
        "selectDate": "Select Date",
        "selectTime": "Select Time",
        "noSlotsAvailable": "No time slots available",
        "morningSlots": "Morning (10:00-12:00)",
        "afternoonSlots": "Afternoon (16:00-18:00)",
        "notes": "Notes",
        "notesPlaceholder": "Additional information or questions...",
        "booking": "Booking...",
        "bookNow": "Book Now",
        "myAppointments": "My Appointments",
        "noAppointments": "You haven't booked any appointments yet",
        "minutes": "minutes",
        "edit": "Edit",
        "delete": "Delete",
        "editAppointment": "Edit Appointment",
        "saving": "Saving...",
        "saveChanges": "Save Changes",
        "cannotEditLessThan24Hours": "Appointments can only be edited if more than 24 hours remain",
        "cannotDeleteLessThan24Hours": "Appointments can only be deleted if more than 24 hours remain",
        "confirmDelete": "Are you sure you want to delete this appointment?",
        "updateError": "Error updating appointment",
        "deleteError": "Error deleting appointment"
      }
    },

      // Aha Upsell Modal
      "aha.close": "Close",
      "aha.exam.headline": "Strong first step. Unlock the full exam library.",
      "aha.exam.subline": "You finished your first mock exam. Get full access to unlock all telc, Goethe and ÖSD mock exams and train with more confidence.",
      "aha.lesson.headline": "You are building momentum. Keep it going.",
      "aha.lesson.subline": "Get full access to continue with advanced practice and full exam-focused training.",
      "aha.lesen.headline": "Good reading. Unlock all tests to be exam-ready.",
      "aha.lesen.subline": "Free access covers Test 1 only. With full access you train with every reading test, each one a different exam-day scenario.",
      "aha.schreiben.headline": "Your writing is taking shape. Unlock all tasks.",
      "aha.schreiben.subline": "Free access covers Test 1 only. With full access you practise every Schreiben task type with full model answers.",
      "aha.horen.headline": "Your listening is improving. Unlock all audio tests.",
      "aha.horen.subline": "Free access covers Test 1 only. With full access you train with more recordings, different voices, accents and speaking speeds.",
      "aha.vocabulary.headline": "You've found a topic that matters. Unlock all of them.",
      "aha.vocabulary.subline": "Free access covers the first vocabulary deck only. With full access you practise every topic with spaced repetition, the fastest way to build exam-ready vocabulary.",
      "aha.redemittel.headline": "You know the phrases. Now use them to pass.",
      "aha.redemittel.subline": "You've practised the key expressions. With full access you get AI writing feedback on your Schreiben tasks and turn that phrase knowledge into real exam points.",
      "aha.cta.upgrade": "Get full access",
      "aha.cta.later": "Maybe later",
      "aha.plans.weekly.cycle": "per week",
      "aha.plans.monthly.cycle": "per month",
      "aha.plans.quarterly.cycle": "every 3 months",
      "aha.plans.weekly.features": [
        "3 full mock exams before your exam",
        "All lessons & essential tips",
        "Logami's AI analysis",
        "Proven strategies to score 100%"
      ],
      "aha.plans.monthly.features": [
        "Unlock all mock exams and variants",
        "Unlimited reading, listening, writing, and grammar training",
        "Detailed AI correction and scoring insights",
        "More repetition to build real exam confidence"
      ],
      "aha.plans.quarterly.features": [
        "Everything in Monthly",
        "Best value, go at your own pace",
        "Longer training runway with full Premium access",
        "Stay consistent until exam day"
      ],

      // Header & Navigation
      "nav.dashboard": "Dashboard",
      "nav.practice": "Practice",
      "nav.exam": "Exam",
      "nav.vocabulary": "Vocabulary",
      "nav.grammar": "Grammar",
      "nav.writing": "Writing",
      "nav.settings": "Settings",
      "nav.profile": "Profile",
      "nav.logout": "Logout",

      // Common buttons & actions
      "button.start": "Start",
      "button.continue": "Continue",
      "button.save": "Save",
      "button.cancel": "Cancel",
      "button.submit": "Submit",
      "button.next": "Next",
      "button.previous": "Previous",
      "button.finish": "Finish",
      "button.retry": "Retry",
      "button.reset": "Reset",
      "button.pause": "Pause",

      // Study Plan
      "studyPlan.loading": "Loading study plan...",
      "studyPlan.resetPlanLong": "Recreate plan",
      "studyPlan.resetPlanShort": "Recreate",
      "studyPlan.weekOverview": "Weekly overview",
      "studyPlan.week": "Week {{week}}",
      "studyPlan.adjustIntensity": "Adjust intensity",
      "studyPlan.intensity.relaxed": "Relaxed",
      "studyPlan.intensity.standard": "Standard",
      "studyPlan.intensity.intensive": "Intensive",
      "studyPlan.intensity.error": "Failed to update intensity. Please try again.",
      "studyPlan.current": "Current",
      "studyPlan.focusAreas": "Focus areas:",
      "studyPlan.yourTasks": "Your tasks:",
      "studyPlan.newBadge": "New",
      "studyPlan.structuredLessons.title": "Structured lessons",
      "studyPlan.structuredLessons.description": "Learn systematically with our lessons for week {{week}}",
      "studyPlan.progress.title": "Your progress",
      "studyPlan.progress.overall": "Overall progress",
      "studyPlan.progress.weeksCompleted": "Weeks completed",
      "studyPlan.progress.weeksRemaining": "Weeks remaining",
      "studyPlan.tip.title": "Tip of the week",
      "studyPlan.tip.text": "Use our structured lessons for optimal preparation. Combine theory with practical exercises for the best results.",
      "studyPlan.stats.title": "Your statistics",
      "studyPlan.stats.loading": "Loading statistics...",
      "studyPlan.stats.totalStudyTime": "Total study time",
      "studyPlan.stats.avgAccuracy": "Average accuracy",
      "studyPlan.stats.completedExercises": "Completed exercises",
      "studyPlan.lessons": "Lessons",
      "studyPlan.waitingForPlan": "Waiting for plan data...",
      "studyPlan.startOver": "Start Over",
      "studyPlan.noWeeksData": "No weeks data available. Please regenerate your plan.",
      "studyPlan.loadingWeek": "Loading week {{current}} of {{total}}...",
      "studyPlan.timelineRecommendation": "Timeline Recommendation",
      "studyPlan.timelineRecommendationDesc": "Based on your timeline, we recommend adjusting your study schedule for optimal results.",
      "studyPlan.more": "more",
      "studyPlan.error.loadFailed": "Failed to load study plan.",
      "studyPlan.premiumOnly": "Premium Only",
      "studyPlan.title.telc.b1": "Step-by-step Plan for TELC B1",
      "studyPlan.title.telc.b2": "Step-by-step Plan for TELC B2",
      "studyPlan.title.telc.c1": "Step-by-step Plan for TELC C1",
      "studyPlan.title.goethe.b1": "Step-by-step Plan for Goethe B1",
      "studyPlan.title.goethe.b2": "Step-by-step Plan for Goethe B2",
      "studyPlan.title.goethe.c1": "Step-by-step Plan for Goethe C1",
      "studyPlan.title.osd.b1": "Step-by-step Plan for ÖSD Certificate B1",
      "studyPlan.title.osd.b2": "Step-by-step Plan for ÖSD Certificate B2",
      "studyPlan.title.osd.c1": "Step-by-step Plan for ÖSD Certificate C1",
      "studyPlan.description.telc.b1": "Your personalized path to a successful TELC B1 exam. Follow this plan step by step to master all exam-relevant skills.",
      "studyPlan.description.telc.b2": "Your personalized path to a successful TELC B2 exam. Follow this plan step by step to master all exam-relevant skills.",
      "studyPlan.description.telc.c1": "Your personalized path to a successful TELC C1 exam. Follow this plan step by step to master all exam-relevant skills at the highest level.",
      "studyPlan.description.goethe.b1": "Your personalized path to a successful Goethe B1 exam. Follow this plan step by step to master all exam-relevant skills.",
      "studyPlan.description.goethe.b2": "Your personalized path to a successful Goethe B2 exam. Follow this plan step by step to master all exam-relevant skills.",
      "studyPlan.description.goethe.c1": "Your personalized path to a successful Goethe C1 exam. Follow this plan step by step to master all exam-relevant skills at the highest level.",
      "studyPlan.description.osd.b1": "Your personalized path to a successful ÖSD B1 exam. Follow this plan step by step to master all exam-relevant skills at B1 level.",
      "studyPlan.description.osd.b2": "Your personalized path to a successful ÖSD B2 exam. Follow this plan step by step to master all exam-relevant skills at B2 level.",
      "studyPlan.description.osd.c1": "Your personalized path to a successful ÖSD C1 exam. Follow this plan step by step to master all exam-relevant skills at C1 level.",
      
      // Study Plan Wizard
      "wizard.title": "Create Your Personalized Study Plan",
      "wizard.subtitle": "Answer a few questions to get a customized plan tailored to your certification goals.",
      "wizard.step": "Step {{current}} of {{total}}",
      "wizard.progress": "{{percent}}%",
      "wizard.back": "Back",
      "wizard.next": "Next",
      "wizard.createPlan": "Create My Plan",
      "wizard.checking": "Checking...",
      
      // Wizard Step 1: Weak Skills
      "wizard.weakSkills.title": "What would you like to work on more?",
      "wizard.weakSkills.subtitle": "Select your main focus areas. We will front-load your plan with targeted 'Lego Blocks' and exercises to close these specific gaps.",
      "wizard.weakSkills.reading": "Reading",
      "wizard.weakSkills.readingDesc": "Understanding texts faster and more accurately.",
      "wizard.weakSkills.listening": "Listening",
      "wizard.weakSkills.listeningDesc": "Better comprehension of audio content.",
      "wizard.weakSkills.writing": "Writing",
      "wizard.weakSkills.writingDesc": "Structured and error-free writing.",
      "wizard.weakSkills.speaking": "Speaking",
      "wizard.weakSkills.speakingDesc": "Fluent and confident speaking.",
      "wizard.weakSkills.grammar": "Grammar",
      "wizard.weakSkills.grammarDesc": "Applying structures correctly.",
      "wizard.weakSkills.vocabulary": "Vocabulary",
      "wizard.weakSkills.vocabularyDesc": "Activating new words faster.",
      
      // Wizard Step 2: Immersion
      "wizard.immersion.title": "How often are you exposed to German outside of studying?",
      "wizard.immersion.subtitle": "This helps us adjust your natural listening and vocabulary acquisition rates.",
      "wizard.immersion.rare": "Rarely",
      "wizard.immersion.rareDesc": "I mostly use English/my native language at work and home.",
      "wizard.immersion.frequent": "Frequently",
      "wizard.immersion.frequentDesc": "I hear/speak German at work, with friends, or daily.",
      
      // Wizard Step 3: Daily Schedule
      "wizard.schedule.title": "What does your daily schedule look like?",
      "wizard.schedule.subtitle": "This helps us optimize your content velocity and cognitive stamina training.",
      "wizard.schedule.commuter": "Busy Professional / Commuter",
      "wizard.schedule.commuterDesc": "Optimized for shorter, focused sessions during commutes and breaks.",
      "wizard.schedule.balanced": "Part-time student / Balanced schedule",
      "wizard.schedule.balancedDesc": "Regular study blocks with time for practice and review.",
      "wizard.schedule.intensive": "Full-time language learner / Sprint mode",
      "wizard.schedule.intensiveDesc": "Intensive preparation with extended study sessions.",
      
      // Wizard Step 4: Exam Matchmaker
      "wizard.examMatchmaker.title": "When it comes to writing and speaking, what is your style?",
      "wizard.examMatchmaker.subtitle": "This helps us match you with the exam format that suits your learning style.",
      "wizard.examMatchmaker.creative": "I prefer writing creatively from scratch.",
      "wizard.examMatchmaker.creativeDesc": "You enjoy expressing ideas in your own words and building original sentences.",
      "wizard.examMatchmaker.templates": "I prefer using predictable templates and memorized phrases.",
      "wizard.examMatchmaker.templatesDesc": "You prefer structured formats and learning ready-made phrases to combine.",
      
      // Wizard Step 5: Months
      "wizard.months.title": "When is exam day?",
      "wizard.months.subtitle": "We use this timeline to calculate your exact 'Content Velocity' and schedule your mandatory Mock Exams.",
      "wizard.months.label": "Study Duration (Months)",
      "wizard.months.month": "month",
      "wizard.months.months": "months",
      "wizard.months.oneMonth": "1 month",
      "wizard.months.sixMonths": "6 months",
        "grammar.exerciseGuide.title": "Exercise Practice Guide",
  "grammar.exerciseGuide.subtitle": "Learn how to interact with each exercise type",
  "grammar.exerciseGuide.progress": "Step {{current}} of {{total}}",

  // Navigation
  "grammar.exerciseGuide.previous": "Previous",
  "grammar.exerciseGuide.next": "Next",
  "grammar.exerciseGuide.startPracticing": "Start Practicing",
  "grammar.exerciseGuide.dontShowAgain": "Don't show this guide again",

  // Welcome step
  "grammar.exerciseGuide.welcome.title": "Welcome to Grammar Practice!",
  "grammar.exerciseGuide.welcome.description": "Learn how to interact with different exercise types and master grammar through practice.",
  "grammar.exerciseGuide.welcome.tip": "Each exercise type has unique interaction methods. We'll show you exactly how to use them!",

  // Multiple Choice
  "grammar.exerciseGuide.multipleChoice.title": "Multiple Choice Questions",
  "grammar.exerciseGuide.multipleChoice.description": "Click on the correct answer from the given options.",
  "grammar.exerciseGuide.multipleChoice.tip": "Selected answers are highlighted in blue. Click to select your answer.",

  // Fill in Blanks
  "grammar.exerciseGuide.fillInBlanks.title": "Fill in the Blanks",
  "grammar.exerciseGuide.fillInBlanks.description": "Type the missing words directly into the blank spaces.",
  "grammar.exerciseGuide.fillInBlanks.step1": "Click inside the blank field",
  "grammar.exerciseGuide.fillInBlanks.step2": "Type your answer",
  "grammar.exerciseGuide.fillInBlanks.step3": "Multiple blanks? Fill them all before submitting",

  // Sentence Building
  "grammar.exerciseGuide.sentenceBuilding.title": "Sentence Building",
  "grammar.exerciseGuide.sentenceBuilding.description": "Tap or click words to build the correct sentence in order.",
  "grammar.exerciseGuide.sentenceBuilding.wordBank": "Available Words:",
  "grammar.exerciseGuide.sentenceBuilding.sentence": "Your Sentence:",
  "grammar.exerciseGuide.sentenceBuilding.tapToStart": "Tap words above to build your sentence...",
  "grammar.exerciseGuide.sentenceBuilding.tip": "Tap a word in your sentence to move it back to the word bank!",

  // Error Correction
  "grammar.exerciseGuide.errorCorrection.title": "Error Correction",
  "grammar.exerciseGuide.errorCorrection.description": "Find and click the incorrect word, then type the correction.",
  "grammar.exerciseGuide.errorCorrection.step1": "Incorrect words are highlighted in red",
  "grammar.exerciseGuide.errorCorrection.step2": "Click the highlighted word to edit it",
  "grammar.exerciseGuide.errorCorrection.step3": "Type the correct form",

  // Matching Pairs
  "grammar.exerciseGuide.matchingPairs.title": "Matching Pairs",
  "grammar.exerciseGuide.matchingPairs.description": "Click items from both columns to create matching pairs.",
  "grammar.exerciseGuide.matchingPairs.tip": "Click one item from each column to create a pair. Matched pairs turn green!",

  // Action Buttons
  "grammar.exerciseGuide.actionButtons.title": "Action Buttons Explained",
  "grammar.exerciseGuide.actionButtons.description": "Every exercise has helpful buttons to guide your practice.",
  "grammar.exerciseGuide.actionButtons.check.title": "Check Answer",
  "grammar.exerciseGuide.actionButtons.check.description": "Submit your answer to see if it's correct. Get instant feedback with explanations!",
  "grammar.exerciseGuide.actionButtons.reset.title": "Reset / Try Again",
  "grammar.exerciseGuide.actionButtons.reset.description": "Clear your answer and start over. Practice makes perfect!",
  "grammar.exerciseGuide.actionButtons.next.title": "Next Exercise",
  "grammar.exerciseGuide.actionButtons.next.description": "Move to the next question after checking your answer.",
  "grammar.exerciseGuide.actionButtons.bookmark.title": "Bookmark Question",
  "grammar.exerciseGuide.actionButtons.bookmark.description": "Save challenging questions to review later from the floating tab bar!",

  // Success
  "grammar.exerciseGuide.success.title": "You're Ready to Practice!",
  "grammar.exerciseGuide.success.description": "You now know how to use all exercise types! Start practicing and improve your grammar skills.",
  "grammar.exerciseGuide.success.quickTips": "🎯 Quick Tips:",
  "grammar.exerciseGuide.success.tip1": "Read questions carefully before answering",
  "grammar.exerciseGuide.success.tip2": "Use the Reset button if you want to try again",
  "grammar.exerciseGuide.success.tip3": "Bookmark difficult questions for later review",
  "grammar.exerciseGuide.success.tip4": "Review your mistakes from the floating tab bar",
      // HomePage Content
      "home.hero.badge": "🎯 Germany's Leading Exam Preparation Platform",
      "home.hero.title": "Pass Your German Exam.",
      "home.hero.subtitle": "Simulated. Practiced. Certified.",
      "home.hero.description": "Practice with authentic real exam simulators that look and feel like the real TELC, Goethe, and ÖSD exams. Track your progress with Logami's AI-driven study plans, at home or on the go.",
      "home.hero.tryFree": "Take a Free Mock Exam",
      "home.hero.successStories": "Success Stories",

      // Platform Features
      "home.features.examSims.title": "Exam Simulators",
      "home.features.examSims.desc": "Real exam conditions with authentic feedback",
      "home.features.vocabGrammar.title": "Vocabulary & Grammar",
      "home.features.vocabGrammar.desc": "Daily exercises with Spaced Repetition System",
      "home.features.redemittel.title": "Phrase Training",
      "home.features.redemittel.desc": "Exam-relevant phrases and structures",
      "home.features.analytics.title": "Progress Analytics",
      "home.features.analytics.desc": "Detailed statistics and weakness identification",

      // 3 Ps Section
      "home.threeps.title": "Your Path to Exam Success",
      "home.threeps.subtitle": "Our proven <strong>3-P Method</strong> leads you systematically to success",
      "home.threeps.plan.title": "PLAN",
      "home.threeps.plan.subtitle": "Personalized Learning Plan",
      "home.threeps.plan.desc": "Intelligent analysis of your strengths and weaknesses creates a tailored learning path for optimal success.",
      "home.threeps.prepare.title": "PREPARE",
      "home.threeps.prepare.subtitle": "Effective Preparation",
      "home.threeps.prepare.desc": "Real exam simulations, daily vocabulary & grammar practice, phrase learning - all with immediate authentic feedback.",
      "home.threeps.pass.title": "PASS",
      "home.threeps.pass.subtitle": "Guaranteed Success",
      "home.threeps.pass.desc": "Detailed statistics show your progress, identify weak points and specifically optimize your exam preparation.",

      // Features List
      "home.features.adaptive": "Adaptive Learning Paths",
      "home.features.analysis": "Weakness Analysis",
      "home.features.goals": "Individual Goals",
      "home.features.simulations": "Exam Simulators",
      "home.features.daily": "Daily Exercises",
      "home.features.feedback": "Immediate Feedback",
      "home.features.tracking": "Progress Tracking",
      "home.features.focus": "Weakness Focus",

      // Learning Environment Section
      "home.environment.title": "Your Complete Learning Environment",
      "home.environment.path": "<strong>Learning Path:</strong> Structured lessons from basics to exam level",
      "home.environment.hub": "<strong>Practice Hub:</strong> Daily exercises for vocabulary, grammar and phrases",
      "home.environment.sims": "<strong>Exam Simulators:</strong> Original exam conditions with time limits",
      "home.environment.analytics": "<strong>Analytics:</strong> Detailed evaluation of your strengths and weaknesses",
      "home.environment.successRate": "Success rate of our users",
      "home.environment.usersCount": "Over 1000 successful exam candidates",

      // Exam Selection Section
      "home.examSelection.title": "Start Your Exam Preparation",
      "home.examSelection.subtitle": "Choose your certification provider and start immediately with the free test",
      "home.examSelection.providers": "Certification Providers",
      "home.examSelection.providersDesc": "All three providers are officially recognized. Choose the certification path that suits you.",
      "home.examSelection.provider": "Select Exam Provider",
      "home.examSelection.level": "Language Level",
      "home.examSelection.startButton": "🚀 Try Free & Register",
      "home.examSelection.selectPrompt": "Choose Provider and Level",
      "home.examSelection.noCard": "No credit card required • Immediate access",
      "home.examSelection.yourPath": "Your Path",
      "home.examSelection.lockedSubtitle": "Your exam selection is set. Continue your learning journey!",
      "home.examSelection.currentExam": "Your Current Exam",
      "home.examSelection.lockedMessage": "Your exam selection has been locked to ensure consistent progress tracking. Contact support if you need to change your exam.",
      "home.examSelection.continueLearning": "Continue Learning",

      // Provider Descriptions
      "home.providers.goethe.desc": "The globally recognized German language diploma",
      "home.providers.osd.desc": "Austrian German with European standards",
      "home.providers.telc.desc": "European language certificates for profession",

      // Provider Features
      "home.providers.goethe.feature1": "Globally recognized",
      "home.providers.goethe.feature2": "Official standard",
      "home.providers.goethe.feature3": "Valid for life",
      "home.providers.osd.feature1": "EU standard",
      "home.providers.osd.feature2": "Austrian German",
      "home.providers.osd.feature3": "International",
      "home.providers.telc.feature1": "Career focused",
      "home.providers.telc.feature2": "European standard",
      "home.providers.telc.feature3": "Practical",
        // Review System
"reviews.section.title": "What Our Learners Say",
"reviews.section.subtitle": "Real experiences from real users",
"reviews.section.verification": "All reviews are verified before publication",
"reviews.section.noReviews": "No reviews yet",
"reviews.section.beFirst": "Be the first to leave a review!",
"reviews.section.writeReview": "Write Review",
"reviews.section.loginToReview": "Login to Review",
"reviews.section.addYourReview": "Add Your Review",
"reviews.section.shareExperience": "Share your experience with the community",

// Review Stats
"reviews.stats.averageRating": "Based on {{count}} reviews",
"reviews.stats.distribution": "Rating Distribution",

// Review Filters
"reviews.filters.title": "Filter & Sort",
"reviews.filters.active": "Active filters:",
"reviews.filters.stars": "{{count}} Stars",
"reviews.filters.sortBy": "Sort by",
"reviews.filters.newest": "Newest first",
"reviews.filters.helpful": "Most helpful",
"reviews.filters.highest": "Highest rating",
"reviews.filters.lowest": "Lowest rating",
"reviews.filters.oldest": "Oldest first",
"reviews.filters.filterByRating": "Filter by rating",
"reviews.filters.allReviews": "All reviews",

// Review Actions
"reviews.actions.helpful": "Helpful",
"reviews.actions.report": "Report",
"reviews.actions.loadMore": "Load more reviews",
"reviews.actions.reported": "Review reported. Thank you!",

// Trust Indicators
"reviews.trust.verified": "Verified Reviews",
"reviews.trust.verifiedDesc": "Only from real users",
"reviews.trust.transparent": "Transparent Reviews",
"reviews.trust.transparentDesc": "Unfiltered opinions",
"reviews.trust.real": "Real Experiences",
"reviews.trust.realDesc": "From our community",
"reviews.trust.verifiedUser": "Verified User",

// Review Form
"reviewForm.title": "Write a Review",
"reviewForm.loginRequired": "Login Required",
"reviewForm.loginMessage": "Please log in to leave a review.",
"reviewForm.close": "Close",
"reviewForm.login": "Log In",
"reviewForm.alreadyReviewed": "Review Already Submitted",
"reviewForm.alreadyReviewedMessage": "You have already left a review. Thank you for your feedback!",
"reviewForm.successMessage": "Thank you for your review! It will be displayed shortly.",
"reviewForm.errorMessage": "Error submitting review. Please try again.",

// Form Fields
"reviewForm.ratingLabel": "How would you rate Logami? *",
"reviewForm.ratingVeryBad": "Very bad",
"reviewForm.ratingBad": "Bad",
"reviewForm.ratingAverage": "Average",
"reviewForm.ratingGood": "Good",
"reviewForm.ratingExcellent": "Excellent",
"reviewForm.titleLabel": "Title (optional)",
"reviewForm.titlePlaceholder": "Brief summary of your experience",
"reviewForm.titleCounter": "{{count}}/100 characters",
"reviewForm.commentLabel": "Your Experience *",
"reviewForm.commentPlaceholder": "Share your experience with Logami. What did you like? What could be improved?",
"reviewForm.commentMinLength": "At least 10 characters required",
"reviewForm.commentCounter": "{{count}}/500 characters",
"reviewForm.planLabel": "Which plan did you use? (optional)",
"reviewForm.planSelect": "Select plan",
"reviewForm.planMonthly": "Monthly",
"reviewForm.plan3Months": "3 Months",

// Form Buttons
"reviewForm.cancel": "Cancel",
"reviewForm.submit": "Submit Review",
"reviewForm.submitting": "Submitting...",

// Form Errors
"reviewForm.error.rating": "Please provide a rating",
"reviewForm.error.commentMin": "Your comment should be at least 10 characters long",
"reviewForm.error.commentMax": "Your comment must not exceed 500 characters",

// Privacy Note
"reviewForm.privacyNote": "<strong>Privacy:</strong> Your review will be displayed publicly. Personal data will not be disclosed. You can have your review deleted at any time by contacting us.",
      // Testimonials Section
      "home.testimonials.title": "Success Stories of Our Users",
      "home.testimonials.subtitle": "Over 1,000 successful exam candidates trust Logami",
      "home.testimonials.successRate": "Success Rate",
      "home.testimonials.successDesc": "Of our users pass their exam",
      "home.testimonials.improvement": "Point Improvement",
      "home.testimonials.improvementDesc": "Average increase",
      "home.testimonials.users": "Successful Users",
      "home.testimonials.usersDesc": "Have achieved their goals",

      // Final CTA
      "home.cta.title": "Ready for Your Exam Success?",
      "home.cta.subtitle": "Join thousands of successful learners",
      "home.cta.startNow": "Start Free Now",
      "home.cta.moreStories": "More Success Stories",

      // Homepage, nav, hero, timer, sections (hardcoded copy)
      "home.nav.goToDashboard": "Go to Dashboard",
      "home.nav.login": "Login",
      "home.nav.getStarted": "Get Started",
      "home.hero.headline1": "Fail Here for Free. Pass Your",
      "home.hero.headline2": "TELC, Goethe & ÖSD exams",
      "home.hero.headline3": "For Real.",
      "home.hero.intro": "logami is the only B1–C1 platform",
      "home.hero.builtByTeachers": "built by actual German teachers",
      "home.hero.passFirstTry": "pass on the first try",
      "home.hero.startFreeMockExam": "Start Your Free Prep Course",
      "home.hero.seeHowItWorks": "See How It Works",
      "home.hero.noCreditCard": "No credit card",
      "home.hero.teacherCertified": "Built by teachers, tested by students",
      "home.hero.subheadline": "The complete B1–C1 preparation course: section-by-section lessons, mock exams, grammar, vocabulary & Redemittel.",
      "home.hero.joinStudents": "Join 1,000+ Students",
      "home.hero.valueFirst.title": "In your first 15 minutes, you will:",
      "home.hero.valueFirst.point1": "Take a free baseline mock exam",
      "home.hero.valueFirst.point2": "See exactly which exam section is weakest",
      "home.hero.valueFirst.point3": "Get a personalized plan you can start today",
      "home.hero.valueFirst.cta": "Get My Free Score Baseline",
      "home.timer.remaining": "Remaining",
      "home.timer.score": "Score",
      "home.timer.passing": "Passing",
      "home.timer.words": "Words",
      "home.timer.readingText": "Reading text",
      "home.timer.answerSheet": "Answer sheet",
      "home.timer.markAnswer": "Mark your answer.",
      "home.timer.playback": "Playback 1 / 2",
      "home.timer.listeningPart1": "Listening comprehension · Part 1",
      "home.timer.playing": "Playing…",
      "home.timer.task": "Task",
      "home.timer.yourAnswer": "Your answer",
      "home.timer.questions3133": "Questions 31–33",
      "home.timer.correct": "Correct",
      "home.timer.incorrect": "Incorrect",
      "home.timer.certificateTitle": "TELC B2 CERTIFICATE",
      "home.timer.veryGood": "VERY GOOD",
      "home.timer.presentation": "Presentation",
      "home.timer.speaking": "Speaking",
      "home.offline.noConnection": "No Connection",
      "home.offline.appActive": "App Active",
      "home.videoCta.seeSimulatorAction": "See the Exam Simulator in Action",
      "home.cost.badge": "The Reality",
      "home.cost.title": "The Cost of Failure",
      "home.cost.description": "Failing isn't just a \"try again.\" It's losing the <1>exam fee</1>, a <2>6-month visa delay</2>, and potentially <3>extra intensive course costs</3>. One weak section costs you the entire certificate, and everything attached to it.",
      "home.cost.card1Label": "Non-Refundable Exam Fee",
      "home.cost.card1Desc": "Goethe, TELC, and ÖSD exams cost €239–€289 depending on level (B1–C1). Every failed attempt burns this, no exceptions, no refunds.",
      "home.cost.card2Label": "Visa Delay per Fail",
      "home.cost.card2Desc": "Exam slots are booked months out. One failure means 6 months without your visa extension, university admission, or job offer.",
      "home.cost.card3Label": "The \"Near Miss\" Gap",
      "home.cost.card3Desc": "Failing by just 5 points in Schreiben is the most common rejection. We identify that exact gap with Logami's AI teacher feedback based on real examiner rubrics.",
      "home.cost.card4Label": "Extra Course Costs",
      "home.cost.card4Desc": "A failed exam means another intensive course at €590–€1,190, on top of the retake fee. That's €1,500+ per failure.",
      "home.cost.findGapTitle": "Find Your 4.5-Point Gap. Fix It Before Exam Day.",
      "home.cost.findGapDesc": "logami's teacher-devised writing templates, the 45-Minute Writing Rule (7 min outline, 30 min writing, 8 min check), and Logami's AI teacher feedback based on real examiner rubrics, so you fail safely here, and pass confidently there.",
      "home.cost.getStrategyScore": "Get Your Exam Strategy Score",
      "home.cost.seeSimulator": "See the Simulator",
      "home.built.badgeTitle1": "Built by Teachers.",
      "home.built.badgeTitle2": "Tested by Students.",
      "home.built.examRoomMode": "Exam Room Mode",
      "home.built.examSimulator": "Exam Simulator",
      "home.built.examSimulatorDesc": "Strict countdown timers, no distractions, locked sections, exactly like the test center. Every mock is crafted by certified teachers and maps to official Goethe, TELC & ÖSD scoring rubrics.",
      "home.built.cefrAligned": "CEFR-Aligned",
      "home.built.examinerDevised": "Examiner-Devised",
      "home.built.rubricVerified": "Rubric-Verified",
      "home.built.curriculum": "Curriculum",
      "home.built.teachersPlaybook": "The Teacher's Playbook",
      "home.built.teachersPlaybookDesc": "General fluency takes years; passing the exam takes strategy. Our curriculum skips the simple textbook exercises and feeds you the specific Redemittel and Konnektoren needed to pass. Master the 45-Minute Writing Rule (7/30/8) and walk out of the test center knowing you secured your certificate.",
      "home.built.tagSchreiben": "Schreiben Structure",
      "home.built.tagRedemittel": "Redemittel",
      "home.built.tagPairSpeaking": "Pair-Speaking",
      "home.built.tagExamRoom": "Exam Room Mode",
      "home.built.practice": "Practice",
      "home.built.targetedPractice": "Targeted Practice",
      "home.built.targetedPracticeDesc": "Grammar and vocabulary drills aligned to exam topics. See exactly where you lose points, then eliminate those gaps.",
      "home.built.architecture": "Architecture",
      "home.built.offlineMastery": "Offline Mastery (PWA)",
      "home.built.offlineMasteryDesc": "Study on the U-Bahn without internet. Our PWA saves your progress, lessons, and audio files for 100% offline use. No connection required, your prep never stops.",
      "home.built.installAsApp": "Install as App, one tap on mobile",
      "home.built.nativeLanguageTip": "Don't struggle with German grammar explained in German, get expert tips in your native language.",
      "home.built.genericAppsTitle": "Generic apps teach you words. We teach you how to pass.",
      "home.built.genericAppsDesc": "Our content is devised by certified examiners to target the exact failure points of B1, B2, and C1 exams, from Schreiben structure to Sprechen Redemittel.",
      "home.built.meetTeachers": "Meet the teachers behind logami",
      "home.pricing.badge": "Pricing",
      "home.pricing.title": "Start free. Upgrade when ready.",
      "home.pricing.subtitle": "No credit card required. Take a full mock exam before you decide.",
      "home.pricing.planFree": "Free",
      "home.pricing.planWeekly": "1 Week",
      "home.pricing.planMonthly": "Monthly",
      "home.pricing.plan3Months": "3 Months",
      "home.pricing.cycleForever": "forever",
      "home.pricing.cycleWeek": "week",
      "home.pricing.cycleMonth": "month",
      "home.pricing.cycle3Months": "3 months",
      "home.pricing.popular": "Most Popular",
      "home.pricing.examReady": "Exam Ready",
      "home.pricing.startFree": "Start Free",
      "home.pricing.getStarted": "Get Started",
      "home.pricing.viewFullPricing": "View full pricing details",
      "home.pricing.featureFree1": "Grammar & vocabulary (A1–B1)",
      "home.pricing.featureFree2": "Basic progress dashboard",
      "home.pricing.featureFree3": "Offline mode (PWA)",
      "home.pricing.featureFree4": "Native language UI (6 languages)",
      "home.pricing.featureWeekly1": "3 full mock exams",
      "home.pricing.featureWeekly2": "All lessons & essential tips",
      "home.pricing.featureWeekly3": "Logami's AI analysis",
      "home.pricing.featureWeekly4": "Proven strategies to score 100%",
      "home.pricing.featureMonthly1": "Access to all mock exams",
      "home.pricing.featureMonthly2": "Full lessons & exam tips",
      "home.pricing.featureMonthly3": "Personalized learning plan",
      "home.pricing.featureMonthly4": "Logami's AI analysis",
      "home.pricing.featureMonthly5": "Full curriculum A1–C1",
      "home.pricing.feature3Mo1": "Everything in Monthly",
      "home.pricing.feature3Mo2": "Over 50% savings",

      "home.pricing.feature3Mo4": "Priority email support",
      "home.comparison.badge": "Real Cost Comparison (2026)",
      "home.comparison.title": "What Are You Really Paying?",
      "home.comparison.subtitle": "Authentic 2026 pricing from Goethe-Institut, TELC centres, and leading German language schools. See where your money actually goes.",
      "home.comparison.method": "Method",
      "home.comparison.hiddenCosts": "Hidden Costs (2026)",
      "home.comparison.feedbackSpeed": "Feedback Speed",
      "home.comparison.passConfidence": "Pass Confidence",
      "home.comparison.intensiveCourses": "Intensive Courses",
      "home.comparison.privateTutoring": "Private Tutoring",
      "home.comparison.standardBooks": "Standard Books",
      "home.comparison.logamiApp": "logami.app",
      "home.comparison.costIntensive": "€590 – €1,190",
      "home.comparison.costPrivate": "€48 – €75/hr",
      "home.comparison.costBooks": "€25 – €45",
      "home.comparison.costLogami": "From €29,99/mo (Save €560+)",
      "home.comparison.feedbackWeekly": "Weekly",
      "home.comparison.feedbackOneToOne": "1:1",
      "home.comparison.feedbackNone": "None",
      "home.comparison.feedbackInstant": "Instant Logami's AI Teacher",
      "home.comparison.successVaries": "Varies",
      "home.comparison.successHigh": "High",
      "home.comparison.successModerate": "Moderate",
      "home.comparison.successSimulated": "Simulated & Verified",
      "home.comparison.saveUpTo": "Save up to <1>€1,180/year</1> compared to intensive courses, with instant feedback and 24/7 access.",
      "home.reviews.badge": "Student Reviews",
      "home.reviews.title": "Trusted by exam candidates.",
      "home.reviews.subtitle": "Real feedback from students who passed their German certification with logami.",
      "home.reviews.anonymous": "Anonymous",
      "home.reviews.examFallback": "Goethe · TELC · ÖSD",
      "home.faq.badge": "FAQ",
      "home.faq.title": "Common Questions",
      "home.faq.q1": "Which German language exams and levels do you prepare for?",
      "home.faq.a1": "We provide authentic learning materials for the most recognized German language certifications: TELC, Goethe, and ÖSD. The content covers the B1, B2, and C1 levels, making it suitable for both intermediate and advanced learners aiming for certification or general fluency.",
      "home.faq.q2": "Is it possible to use the app offline?",
      "home.faq.a2": "Yes. As a Progressive Web App (PWA), logami uses Service Workers to cache key application resources. This means you can load the app and continue learning activities even when you have an unstable or no internet connection. Your progress syncs automatically when you're back online.",
      "home.faq.q3": "Are there any recurring charges?",
      "home.faq.a3": "No. All paid plans are one-time payments. You pay once and get full access for the duration of your chosen plan, no subscriptions, no auto-renewals.",
      "home.faq.q4": "Is there a free trial?",
      "home.faq.a4": "Yes! Every new account gets full access to the Free plan forever, including grammar & vocabulary practice, offline mode, and native language UI. No credit card required.",
      "home.faq.q5": "Can I practice specific sections of an exam?",
      "home.faq.a5": "Yes, this is a core function of the platform. You can train each part of the exam (Reading, Listening, Writing, Speaking) individually with our Exam Section Practice feature.",
      "home.faq.viewAll": "View All FAQs",
      "home.bottomCta.title1": "Your exam date is set.",
      "home.bottomCta.title2": "Don't lose another day.",
      "home.bottomCta.desc": "Every day without practice is a day closer to your exam without progress. Join students who passed their German certification on the first attempt.",
      "home.bottomCta.freeMockIncluded": "Free mock exam included",
      "home.bottomCta.keepProgress": "Keep your progress forever",
      "home.footer.privacy": "Privacy",
      "home.footer.terms": "Terms",
      "home.footer.contact": "Contact",
      "home.demo.tryItFree": "Try it free",
      "home.demo.nextRedemittel": "Next: Redemittel",
      "home.demo.backToLessons": "Back to Lessons",
      "home.demo.nextVocabulary": "Next: Vocabulary",
      "home.demo.backToGrammar": "Back to Grammar",
      "home.demo.closeDemo": "Close demo",
      "home.demo.subtitleSimulator": "Real timers, locked sections, official rubrics",
      "home.demo.subtitleLessons": "Lessons",
      "home.demo.subtitleRedemittel": "Redemittel",
      "home.demo.subtitleGrammar": "Grammar",
      "home.demo.subtitleVocabulary": "Vocabulary",

      // ─── Variant B Landing Page (Complete Course Messaging) ───
      "homeB.hero.builtByTeachers": "Built by certified German teachers",
      "homeB.hero.builtByTeachersShort": "Emir, Maria, Stefan & Anna, certified instructors",
      "homeB.hero.headlineBold": "Pass telc, Goethe or ÖSD",
      "homeB.hero.headlineAccent": "with the complete prep course.",
      "homeB.hero.subheadline": "Lessons, targeted practice, full mock exams and real feedback for B1, B2 and C1. Written by certified German teachers.",
      "homeB.hero.cta": "Start Your Free Prep Now",
      "homeB.hero.ctaTryExam": "Try a free exam",
      "homeB.hero.ctaMyExams": "Go to your exams",
      "tryExam.pageTitle": "Free German Mock Exam. TELC, Goethe & ÖSD | Logami",
      "tryExam.badge": "Free. No account needed.",
      "tryExam.title": "Try a full mock exam",
      "tryExam.subtitle": "The real exam format with authentic timing. Pick your exam and level. Your progress is saved on this device, so you can leave and come back anytime.",
      "tryExam.chooseProvider": "1 · Choose your exam",
      "tryExam.chooseMode": "3 · Paper or digital",
      "tryExam.chooseLevel": "2 · Choose your level",
      "tryExam.loadError": "Could not load this exam. Please try another combination.",
      "tryExam.startCta": "Start my free mock exam",
      "tryExam.chipFormat": "Authentic exam format",
      "tryExam.chipSections": "Reading · Listening · Writing",
      "tryExam.chipNoCard": "No credit card, no signup",
      "tryExam.loading": "Loading your exam",
      "tryExam.resultsBadge": "Your result",
      "tryExam.resultsTitle": "You finished the {{provider}} {{level}} exam!",
      "tryExam.overallScore": "Overall score",
      "tryExam.unlockBadge": "See what you got wrong",
      "tryExam.unlockText": "Create a free account to review every answer with explanations, get AI feedback on your writing, and unlock your personal study plan.",
      "tryExam.signupCta": "Create free account & see my answers",
      "tryExam.tryAnother": "Try another exam",
      "tryExam.gate.badge": "{{section}} complete",
      "tryExam.gate.title": "Unlock the full exam for free",
      "tryExam.gate.text": "Sign up to unlock {{section}} and every other part of the exam, see your complete results with explanations, and get AI feedback on your writing. Your free account takes a few seconds and you continue exactly where you left off.",
      "tryExam.gate.savedNote": "Your answers so far are saved on this device.",
      "tryExam.gate.cta": "Sign up free & continue my exam",
      "tryExam.dashboardText": "Head to your dashboard for your study plan, more mock exams, and AI writing feedback.",
      "tryExam.dashboardCta": "Go to my dashboard",
      "dashboard.continueExam.title": "Finish Your Mock Exam.",
      "dashboard.continueExam.subtitle": "Your {{exam}} exam is waiting with your answers saved. Pick up where you stopped and complete the remaining sections.",
      "dashboard.continueExam.cta": "Continue Exam",
      "tryExam.auth.title": "Create your free account",
      "tryExam.auth.signingIn": "Signing in…",
      "tryExam.auth.moreOptions": "Sign up with e-mail instead",
      "tryExam.haveAccount": "Already have an account?",
      "homeB.hero.chipNoCard": "Free to start",
      "homeB.hero.chipExams": "TELC · Goethe · ÖSD",
      "homeB.hero.chipLevels": "B1 · B2 · C1",

      "homeB.course.badge": "What you get today",
      "homeB.course.title": "A full course, not just mock exams.",
      "homeB.course.titleBefore": "A",
      "homeB.course.titleHighlight": "full course",
      "homeB.course.titleAfter": "instead of just mock exams.",
      "homeB.course.lesson.label": "Lessons",
      "homeB.course.lesson.title": "Step-by-Step Lessons",
      "homeB.course.lesson.desc": "Guided lessons for every exam section, built from real teachers' strategies, tips, and tricks that actually work on exam day.",
      "homeB.course.lesson.credential": "Written by Emir, Maria, Stefan & Anna, certified DaF/DaZ instructors",
      "homeB.course.mock.label": "Mock exams",
      "homeB.course.mock.title": "Full Mock Exams",
      "homeB.course.mock.desc": "Timed, realistic simulations with instant scoring and detailed feedback on every answer.",
      "homeB.course.practice.label": "Practice",
      "homeB.course.practice.title": "Targeted Section Practice",
      "homeB.course.practice.desc": "Drill any weak section (Reading, Listening, Writing, or Speaking) with exam-style tasks.",
      "homeB.course.skills.label": "Core skills",
      "homeB.course.skills.title": "Vocabulary, Grammar & Redemittel",
      "homeB.course.skills.desc": "Dedicated training for the building blocks: words, rules, and the exact phrases examiners expect to hear.",

      "homeB.howItWorks.badge": "How it works",
      "homeB.howItWorks.title": "Ready in 3 minutes.",
      "homeB.howItWorks.step1.title": "Pick your exam",
      "homeB.howItWorks.step1.desc": "Select TELC, Goethe, or ÖSD and your level. We build your personal study plan instantly.",
      "homeB.howItWorks.step2.title": "Learn & practice",
      "homeB.howItWorks.step2.desc": "Work through guided lessons, drill weak spots, and build vocabulary at your own pace.",
      "homeB.howItWorks.step3.title": "Take mock exams",
      "homeB.howItWorks.step3.desc": "Simulate real exam conditions, get your score, see what to fix, and retake until you're ready.",
      "homeB.howItWorks.featureListLabel": "Tap any feature to see it in action",

      "homeB.features.simulator": "Exam Simulator",
      "homeB.features.simulatorDesc": "Full timed mock exams with instant scoring and feedback",
      "homeB.features.lessons": "Guided Lessons",
      "homeB.features.lessonsDesc": "Step-by-step lessons for every exam section",
      "homeB.features.grammar": "Grammar Training",
      "homeB.features.grammarDesc": "Targeted grammar exercises by level and topic",
      "homeB.features.vocab": "Vocabulary Builder",
      "homeB.features.vocabDesc": "Level-specific vocabulary with spaced repetition",
      "homeB.features.redemittel": "Redemittel Phrases",
      "homeB.features.redemittelDesc": "The exact phrases examiners expect to hear",
      "homeB.features.watchDemo": "Watch demo",

      "homeB.proof.testimonialQuote": "I tried three apps before finding Logami. This is the only one that actually teaches you how the exam works, not just vocabulary lists.",
      "homeB.proof.testimonialName": "Maria S.",
      "homeB.proof.testimonialInitial": "M",
      "homeB.proof.testimonialExam": "Passed Goethe B2",
      "homeB.proof.stat1Value": "3,257",
      "homeB.proof.stat1Label": "Students who passed their exam",
      "homeB.proof.stat2Value": "Monthly",
      "homeB.proof.stat2Label": "New mock exams added",
      "homeB.proof.stat3Value": "10+",
      "homeB.proof.stat3Label": "Mock exams for every exam we cover",
      "homeB.proof.logosLabel": "Preparing for official exams from",

      "homeB.team.badge": "The people behind Logami",
      "homeB.team.title": "Built by people who've been in your seat.",
      "homeB.team.founderLabel": "Founder & Lead Instructor",
      "homeB.team.emir.credentials": "Germanistik Graduate · Certified German Teacher · Product Designer",
      "homeB.team.emir.bio": "I learned German as a foreign language, sat for these exams myself, and then spent years teaching hundreds of students how to pass them. I saw how scattered the preparation was, no single platform gave you lessons, practice, and realistic mocks in one place. So I built one, with the same methods I use in my own classroom.",
      "homeB.team.teamMaria": "DaF instructor · TELC examiner",
      "homeB.team.teamStefan": "DaZ instructor · Goethe certified",
      "homeB.team.teamAnna": "DaF instructor · ÖSD examiner",
      "homeB.team.personalNote": "I've sat where you're sitting. I've taken these exams. I know what works because I've lived it and taught it.",
      "homeB.team.readMore": "Read more about our team",

      "homeB.finalCta.title": "Your exam date is getting closer.",
      "homeB.finalCta.subtitle": "Start preparing today. It's free, instant, and built by certified German teachers.",
      "homeB.finalCta.trust": "Free forever plan · No credit card · One-time payment for paid plans",

      "homeB.sticky.cta": "Start Free Prep",

      // ─── Variant C Landing Page (Conversion-focused hero: outcome headline + exam selector) ───
      "homeC.hero.headlineLine1": "Pass TELC, Goethe or ÖSD",
      "homeC.hero.headlineLine2": "on the first try.",
      "homeC.hero.examSelector.label": "What exam are you preparing for?",
      "homeC.hero.examSelector.levelLabel": "Select your level",
      "homeC.hero.examSelector.ctaWithExam": "Start Free {{exam}} {{level}} Prep",
      "homeC.hero.examSelector.ctaDefault": "Start Free Prep",
      "homeC.hero.urgency": "Got an exam date? Most students see real improvement within 2–3 weeks of daily practice.",
      "homeC.hero.stat1Value": "1,000+",
      "homeC.hero.stat1Label": "Students",
      "homeC.hero.stat2Value": "95%",
      "homeC.hero.stat2Label": "Pass rate",
      "homeC.hero.stat3Value": "4.9★",
      "homeC.hero.stat3Label": "Rating",

      // Dashboard
      "dashboard.welcome": "Welcome back!",
      "dashboard.todayStats": "Today",
      "dashboard.weekStats": "This Week",
      "dashboard.totalStats": "Total",
      "dashboard.streak": "Study Streak",
      "dashboard.xp": "XP",
      "dashboard.level": "Level",

      // Practice & Exercises
      "exercise.correct": "Correct!",
      "exercise.incorrect": "Incorrect!",
      "exercise.tryAgain": "Try again",
      "exercise.wellDone": "Well done!",
      "exercise.completed": "Completed",
      "exercise.timeSpent": "Time: {{time}} seconds",
      "exercise.score": "Score: {{score}}/{{total}}",

      // Grammar specific
      "grammar.pillar": "Grammar Lesson",
      "grammar.exercise": "Exercise",
      "grammar.explanation": "Explanation",
      "grammar.practice": "Practice",
      "grammar.mastered": "Mastered",
      "grammar.progress": "Progress",

      // Settings
      "settings.language": "Language",
      "settings.notifications": "Notifications",
      "settings.profile": "Profile",
      "settings.account": "Account",
      "settings.privacy": "Privacy",

      // Common messages
      "message.loading": "Loading...",
      "message.error": "An error occurred",
      "message.success": "Success!",
      "message.noData": "No data available",
      "message.comingSoon": "Coming soon",
      "common.loading": "Loading...",
      "common.goBack": "Go Back",

      // No Exam Selected Safety Guard
      "exam.noExamSelected.title": "No Exam Selected",
      "exam.noExamSelected.description": "It looks like you haven't selected an exam yet, or your exam selection was not loaded properly. Please choose your exam provider and level to continue.",
      "exam.noExamSelected.selectExam": "Select Your Exam",
      "exam.noExamSelected.goToDashboard": "Go to Dashboard",
      "exam.noExamSelected.helpText": "If this issue persists, please try logging out and back in, or contact support.",
      "exam.desktopRecommendation": "We highly recommend using the desktop version for the best exam experience.",
      "exam.mobileWarning.title": "Desktop recommended",
      "exam.mobileWarning.body": "The mock exam is designed for larger screens. On mobile you may experience layout issues, so we recommend switching to a desktop or laptop for the best results.",
      "exam.mobileWarning.cta": "Continue anyway",
      "exam.mockVariantsTitle": "Mock Exam Variants",
      "exam.summaryDescription": "Comprehensive preparation with adaptive exercises and exam simulations.",
      "exam.minutesLabel": "Minutes",
      "exam.questionsLabel": "Questions",
      "exam.passLabel": "Pass Mark",
      "exam.defaultVariantName": "Mock Exam 1",
      "exam.defaultVariantDescription": "Complete exam simulation",
      "exam.historyTitle": "Exam History",
      "exam.loadingHistory": "Loading history...",
      "exam.modulesLabel": "modules",
      "exam.attemptLabel": "Attempt {{number}}",
      "exam.viewResults": "View Results",
      "exam.instructionsTitle": "Instructions",
      "exam.instructionsIntro": "Please read the instructions for each section carefully before you begin.",
      "exam.sectionsTitle": "Exam Sections",
      "exam.beginExam": "Start Exam",
      "exam.training.start": "Start Training",
      "exam.training.probeLabel": "Sample",
      "exam.training.previousProbe": "Previous Sample",
      "exam.training.nextProbe": "Next Sample",
      "exam.training.freeProbeOnly": "Only Sample 1 is available on the Free plan. Upgrade to Premium to unlock all samples.",
      "exam.training.partsCount": "{{count}} parts",
      "exam.training.listeningNav": "Listening",
      "exam.training.history": "History",
      "exam.training.historyTitle": "Practice History",
      "exam.training.noAttemptsYet": "No practice attempts yet.",
      "exam.training.correctionPending": "Correction in progress…",
      "exam.training.correctionPendingInfo": "Your text was submitted and is being corrected. Check back in a moment — the feedback will appear here.",
      "exam.training.correctionFailed": "Correction failed",
      "exam.training.correctionFailedInfo": "This correction could not be completed. Your text is saved — you can submit it again from the writing training.",
      "exam.training.yourSubmittedText": "Your submitted text",
      "exam.training.chooseSample": "Choose a sample",
      "exam.training.premiumOnly": "Premium",
      "exam.training.samplesCount": "{{count}} tests",
      "exam.training.continueTraining": "Continue",
      "exam.training.answeredCount": "{{count}} answered",
      "exam.training.draftSaved": "Draft",
      "exam.training.showExplanation": "Show explanation",
      "exam.training.hideExplanation": "Hide explanation",

      "examResults.title": "Exam Result",
      "examResults.examNameFallback": "Language Exam",
      "examResults.loadingSaved": "Loading saved results...",
      "examResults.loading": "Loading results...",
      "examResults.passed": "Passed!",
      "examResults.notPassed": "Not passed",
      "examResults.writingGrading": "Writing task is being graded...",
      "examResults.scoreUpdating": "Score updating",
      "examResults.noAnswer": "No answer",
      "infoTable.correctAnswer": "Correct: {{answer}}",
      "infoTable.gapLabel": "Gap {{n}}",
      "examResults.correct": "Correct",
      "examResults.incorrect": "Incorrect",
      "examResults.yes": "Yes",
      "examResults.no": "No",
      "examResults.answerTrue": "Richtig (true)",
      "examResults.answerFalse": "Falsch (false)",
      "examResults.answerNotStated": "Not stated in the text",
      "examResults.answerNoMatch": "None of the texts fits",
      "examResults.yourAnswer": "Your answer:",
      "examResults.correctAnswer": "Correct answer:",
      "examResults.correctionErrorTask": "Error correcting task {{n}}",
      "examResults.taskNumber": "Task {{n}}",
      "examResults.points": "Points",
      "examResults.totalScore": "Total score",
      "examResults.status": "Status",
      "examResults.yourTextWithCorrections": "Your text with corrections",
      "examResults.yourSubmittedText": "Your submitted text",
      "examResults.detailedFeedback": "Detailed feedback",
      "examResults.fullyCorrectedText": "Fully corrected text",
      "examResults.noCorrectionsForTask": "No corrections found for this task.",
      "examResults.noErrorsInText": "Well done! No errors were found in your text.",
      "examResults.criteriaTitle": "Scoring criteria",
      "examResults.achievementExamComplete": "Exam completed",
      "examResults.achievementExamCompleteDesc": "You have finished the exam",
      "examResults.achievementPerfectionist": "Perfectionist",
      "examResults.achievementPerfectionistDesc": "Over 90% achieved",
      "examResults.achievementPersistent": "Persistent",
      "examResults.achievementPersistentDesc": "All sections attempted",
      "examResults.tabOverview": "Overview",
      "examResults.tabProgress": "Progress",
      "examResults.allModulesPassed": "All modules passed successfully",
      "examResults.moduleNotPassed": "At least one module not passed",
      "examResults.modulesChecked": "Modules checked",
      "examResults.modulesPassed": "{{count}} modules passed",
      "examResults.modulesPassedOne": "1 module passed",
      "examResults.congratsPassedModules": "Congrats! Passed: {{modules}}",
      "examResults.congratsAllPassed": "Congrats! You passed all modules.",
      "examResults.keepPracticing": "Keep practicing – you've got this!",
      "examResults.sectionOverview": "Section overview",
      "examResults.aiGrading": "Logami's AI is grading...",
      "examResults.pleaseWait": "Please wait",
      "examResults.graded": "Graded",
      "examResults.noData": "No data",
      "examResults.writingNotYetEvaluated": "Not yet evaluated",
      "examResults.tabTitleSuffix": "Results",
      "examResults.achievements": "Achievements",
      "examResults.questionDetails": "Question details",
      "examResults.aiCorrecting": "Logami's AI correction in progress...",
      "examResults.evaluatingTitle": "Evaluation in progress",
      "examResults.evaluatingDesc": "Our specialized correction assistant is analyzing your text...",
      "examResults.goetheEvaluating": "Results are being determined",
      "examResults.goetheEvaluatingDesc": "Our intelligent grading system is analyzing your written performance.",
      "examResults.specializedEngine": "Correction in progress...",
      "examResults.specializedEngineDesc": "Our certified correction algorithm is evaluating vocabulary, grammar, and coherence.",
      "examResults.correctionFailed": "Correction failed",
      "examResults.textsSavedNoCorrection": "Your texts have been saved. Correction is not (yet) available.",
      "examResults.requestCorrection": "Request correction",
      "examResults.noWritingTasks": "No writing tasks found in this exam.",
      "examResults.speakingNotGraded": "Speaking tasks are not graded in this simulation.",
      "examResults.speakingRealExamNote": "In the real exam you will be assessed orally by examiners.",
      "examResults.noTasksForSection": "No tasks for this section in this exam.",
      "examResults.backToDashboard": "Back to dashboard",
      "examResults.criteria.taskFulfillment": "Task fulfillment",
      "examResults.criteria.coherence": "Coherence",
      "examResults.criteria.vocabulary": "Vocabulary",
      "examResults.criteria.structures": "Structures",
      "examResults.criteria.content": "Content",
      "examResults.criteria.communicativeDesign": "Communicative design",
      "examResults.criteria.language": "Language",
      "examResults.criteria.taskAchievement": "Task achievement",
      "examResults.criteria.textStructure": "Text structure",
      "examResults.criteria.fulfillmentOfNorms": "Fulfillment of norms",
      "examResults.criteria.communicativeAppropriateness": "Communicative appropriateness",
      "examResults.criteria.cohesion": "Cohesion",
      "examResults.criteria.formalCorrectness": "Formal correctness",
      "examResults.correctionStartFailed": "Correction could not be started.",
      "examResults.correctionFetchError": "Error fetching the correction.",
      "examResults.correctionSubmitError": "Error submitting texts for correction.",

      // Results story (corrected-exam view, ResultsStory.jsx)
      "examResults.story.title": "Your exam, corrected.",
      "examResults.story.waitingForWriting": "Your writing is being corrected. Your total appears as soon as it is done.",
      "examResults.story.passedStamp": "PASSED",
      "examResults.story.notYetStamp": "NOT YET",
      "examResults.story.passMark": "Pass mark {{points}} ({{pct}}%)",
      "examResults.story.aboveMark": "{{n}} points above the pass mark.",
      "examResults.story.belowMark": "{{n}} points to the pass mark — you can win them back.",
      "examResults.story.goethe.modules": "modules passed",
      "examResults.story.goethe.rule": "Goethe marks every module on its own: a module is passed from {{pct}} of 100 points.",
      "examResults.story.goethe.toPass": "{{n}} points to pass {{name}} — you can win them back.",
      "examResults.story.goethe.allPassed": "Every module is above the pass mark.",
      "examResults.story.comment": "Strong {{strong}}! {{focus}} cost you the most points.",
      "examResults.story.commentNotYet": "{{strong}} is already solid. {{focus}} is where your points are.",
      "examResults.story.commentClean": "Clean work — {{strong}} especially. No pattern in your mistakes.",
      "examResults.story.strongSection": "{{section}} is your strongest section.",
      "examResults.story.gainTitle": "Win these points back:",
      "examResults.story.strong": "✓ strong",
      "examResults.story.noFocus": "No mistake repeats often enough to call it a pattern. Review the single ones below.",
      "examResults.story.focusSub": "{{wrong}} of {{items}} wrong · {{sections}}",
      "examResults.story.seeWhy": "See why",
      "examResults.story.gainNote": "Points you can still win in this paper, if you fix these.",
      "examResults.story.sheetTitle": "Your answer sheet",
      "examResults.story.sheetIntro": "Every question at a glance. Tap a square to see why.",
      "examResults.story.legendRight": "Correct",
      "examResults.story.legendWrong": "Wrong",
      "examResults.story.legendFlagged": "You flagged it",
      "examResults.story.squareRight": "Question {{n}}, correct",
      "examResults.story.squareWrong": "Question {{n}}, wrong",
      "examResults.story.teil": "Teil {{n}}",
      "examResults.story.sectionsTitle": "Section by section",
      "examResults.story.passLine": "{{pct}} % · pass",
      "examResults.story.aboveLine": "+{{n}} above",
      "examResults.story.toGo": "{{n}} to go",
      "examResults.story.trapsTitle": "The traps that caught you",
      "examResults.story.trapsIntro": "Exam writers use the same tricks again and again. Knowing them is half the work.",
      "examResults.story.nextTime": "Next time:",
      "examResults.story.avoided": "Traps you avoided:",
      "examResults.story.sinceTitle": "Since your last attempt",
      "examResults.story.pointsDelta": "{{n}} points",
      "examResults.story.total": "Total",
      "examResults.story.lastTime": "Last time",
      "examResults.story.today": "Today",
      "examResults.story.closeTitle": "{{count}} mistakes, {{count}} lessons.",
      "examResults.story.closeText": "Your confident mistakes come first — those are the ones you learn most from.",
      "examResults.story.reviewCta": "Review my mistakes",
      "examResults.story.retryCta": "Retry them in 2 days · Premium",
      "examResults.story.whichHeading": "Which heading fits text {{n}}?",
      "examResults.story.whichStatement": "Which statement fits speaker {{n}}?",
      "examResults.story.paragraph": "Paragraph {{id}}",
      "examResults.story.youWereSure": "You were sure",
      "examResults.story.youFlagged": "You flagged it",
      "examResults.story.textSays": "The text says:",
      "examResults.story.tip": "Tip:",
      "examResults.story.premium": "Premium",
      "examResults.story.flaggedRight": "Unsure, but right: worth a second look so it sticks.",
      "examResults.story.right": "Correct — nothing to fix here.",
      "examResults.story.cause.otherKeyLabel": "Belongs elsewhere",
      "examResults.story.cause.otherKey": "Your answer is the right answer to question {{n}} — each option is used only once.",
      "examResults.story.cause.unrelatedLabel": "Different topic",
      "examResults.story.cause.unrelated": "Your choice is about something else: {{gist}}.",
      "examResults.story.cause.slipLabel": "A slip",
      "examResults.story.cause.slip": "The text says this almost word for word — a slip, not a gap in your German.",
      "examResults.story.cause.skippedLabel": "No answer",
      "examResults.story.cause.skipped": "You left this one empty. In the exam, always mark something — a guess can still score.",
      "examResults.story.practice.rule": "Read the rule",
      "examResults.story.practice.basics": "Refresh the basics",
      "examResults.story.practice.exercises": "Practise this",
      "examResults.story.practice.strategy": "Strategy lesson",
      "examResults.story.reviewTitle": "Review my mistakes",
      "examResults.story.reviewIntro": "Confident mistakes come first: the ones you were sure about stick best once you see what fooled you.",
      "examResults.story.reviewIntroPaper": "Every mistake, with the trap behind it and what to do next time.",
      "examResults.story.close": "Close",
      "examResults.story.filterAll": "All",
      "examResults.story.filterLabel": "Filter mistakes",
      "examResults.story.retry.title": "Retry my mistakes",
      "examResults.story.retry.kickerReady": "Your retry set is ready",
      "examResults.story.retry.kickerOn": "Your retry set opens {{date}}",
      "examResults.story.retry.note_one": "1 question, ready on {{date}}.",
      "examResults.story.retry.note": "{{count}} questions, ready on {{date}}.",
      "examResults.story.retry.unlock": "Unlock my retry set · Premium",
      "examResults.story.retry.start_one": "Retry 1 question",
      "examResults.story.retry.start": "Retry {{count}} questions",
      "examResults.story.retry.dashTitle_one": "1 question from your {{exam}} exam is waiting",
      "examResults.story.retry.dashTitle": "{{count}} questions from your {{exam}} exam are waiting",
      "examResults.story.retry.why": "A mistake sticks when you meet the same question again after a pause and get it right.",
      "examResults.story.retry.notYet_one": "1 question waits for you — it opens on {{date}}.",
      "examResults.story.retry.notYet": "{{count}} questions wait for you — they open on {{date}}.",
      "examResults.story.retry.allDone": "All done — every mistake from this exam is fixed.",
      "examResults.story.retry.loading": "Loading your retry set…",
      "examResults.story.retry.notFound": "This retry set could not be found.",
      "examResults.story.retry.again": "Second try",
      "examResults.story.retry.readText": "Read the text again",
      "examResults.story.retry.right": "Right — this one stuck!",
      "examResults.story.retry.wrong": "Not yet — it comes back in 7 days.",
      "examResults.story.retry.next": "Next question",
      "examResults.story.retry.finish": "Finish",
      "examResults.story.retry.doneRight_one": "1 mistake fixed.",
      "examResults.story.retry.doneRight": "{{count}} mistakes fixed.",
      "examResults.story.retry.comeBack_one": "1 question comes back on {{date}}.",
      "examResults.story.retry.comeBack": "{{count}} questions come back on {{date}}.",
      "examResults.story.retry.play": "Play the clip",
      "examResults.story.retry.noClip": "No recording for this one — answer from what you remember.",
      "examResults.story.retry.pause": "Pause",
      "examResults.story.peer.rankHand": "Better than {{pct}} %",
      "examResults.story.peer.rankText": "of the {{students}} other {{exam}} students on Logami.",
      "examResults.story.peer.family": "Catches other students {{pct}} % of the time too — not just you.",
      "examResults.story.peer.hardRight": "Only {{pct}} % of students got this one right — you did.",
      "examResults.story.peer.commonMiss": "{{pct}} % of students miss this one too.",
      "examResults.story.sureLook": "You were sure — look closely",
      "examResults.story.questionN": "Question {{n}}",
      "examResults.story.free": "free",
      "examResults.story.closeTitle_one": "1 mistake, 1 lesson.",
      "examResults.story.overview.tab": "Overview",
      "examResults.story.overview.tabsLabel": "Result sections",
      "examResults.story.overview.comingSoon": "coming soon",
      "examResults.story.overview.partsTitle": "Your {{count}} parts",
      "examResults.story.overview.partsIntro": "Open a part for its answer sheet, the traps in it and every mistake explained.",
      "examResults.story.overview.openPart": "Open {{name}}",
      "examResults.story.overview.partBest": "Your strongest part.",
      "examResults.story.overview.partClean": "Every answer right. Nothing to fix here.",
      "examResults.story.overview.partTrap": "{{count}}× „{{what}}“ cost you {{points}} points.",
      "examResults.story.overview.partFew_one": "1 mistake, no repeating pattern.",
      "examResults.story.overview.partFew": "{{count}} mistakes, no repeating pattern.",
      "examResults.story.overview.writingWaiting": "Your text is being corrected right now.",
      "examResults.story.overview.writingTop": "Most corrections: {{what}} ({{count}}×).",
      "examResults.story.overview.writingOpen": "Your text, corrected line by line.",
      "examResults.story.overview.reviewKicker": "Your mistakes, ready to learn from",
      "examResults.story.overview.reviewAll_one": "Review my 1 mistake",
      "examResults.story.overview.reviewAll": "Review all {{count}} mistakes",
      "examResults.story.overview.grewMost": "{{name}} grew most (+{{n}} %).",
      "examResults.story.part.solid": "{{what}}: solid.",
      "examResults.story.part.noteRepeat": "„{{what}}“ caught you {{count}} times — that is where the points went.",
      "examResults.story.part.noteSingle_one": "Only 1 mistake here.",
      "examResults.story.part.noteSingle": "{{count}} single mistakes, no repeating pattern.",
      "examResults.story.part.noteClean": "Every answer right. Nothing to fix here.",
      "examResults.story.part.above": "+{{n}} above {{pct}} %",
      "examResults.story.part.toGo": "{{n}} to {{pct}} %",
      "examResults.story.part.teileTitle": "Teil by Teil",
      "examResults.story.part.teileIntro": "Hover a square for the question. Click it and it opens right below.",
      "examResults.story.part.fooledTitle": "What fooled you here",
      "examResults.story.part.heldTitle": "What held up",
      "examResults.story.part.reviewKicker_one": "1 to look at",
      "examResults.story.part.reviewKicker": "{{count}} to look at",
      "examResults.story.part.reviewTitle": "Review my {{name}} mistakes",
      "examResults.story.part.reviewText": "Every mistake corrected — your answer, the trap behind it and what to do next time. Confident mistakes first.",
      "examResults.story.part.mistakes_one": "1 mistake",
      "examResults.story.part.mistakes": "{{count}} mistakes",
      "examResults.story.part.openReview": "Open review",
      "examResults.story.part.nothingToFix": "No mistakes in {{name}} — nothing to fix here.",
      "examResults.story.aha.lost": "{{what}} cost you {{points}} points",
      "examResults.story.aha.strategyTitle": "Strategy lesson: {{what}}",
      "examResults.story.aha.pattern": "{{wrong}} of {{all}} wrong — fix the pattern",
      "examResults.story.teilWhat.matching-headings": "The main point of short texts",
      "examResults.story.teilWhat.multiple-choice": "Details in one longer text",
      "examResults.story.teilWhat.matching-situations": "Match people to the right ad",
      "examResults.story.teilWhat.cloze-multiple-choice": "Gaps with 3 options each",
      "examResults.story.teilWhat.cloze-word-bank-click": "Gaps from a word bank",
      "examResults.story.teilWhat.short-texts": "Main point of short messages",
      "examResults.story.teilWhat.conversation": "Details in a long conversation",
      "examResults.story.teilWhat.short-texts-announcements": "Times, places and changes",
      "examResults.story.writing.name": "Schreiben",
      "examResults.story.writing.note": "Your text, corrected like the examiners do.",
      "examResults.story.writing.noteTop": "Most of your corrections are {{what}} ({{count}}×). Fix that pattern and the rest follows.",
      "examResults.story.writing.noteSame": "{{what}} slip here too — the same pattern as in Sprachbausteine.",
      "examResults.story.writing.typesTitle": "Your errors by type",
      "examResults.story.writing.samePattern": "Same pattern as Sprachbausteine gap {{gaps}}",
      "examResults.story.writing.correctedTitle": "Your text, corrected",
      "examResults.story.writing.teacherKicker": "Want a second opinion?",
      "examResults.story.writing.teacherTitle": "Let a real teacher correct your text",
      "examResults.story.writing.teacherText": "A German teacher marks your text the way the examiners do and writes you a personal note. Premium includes 10 teacher corrections.",
      "examResults.story.writing.teacherCta": "Send to a teacher · Premium",
      "examResults.story.writing.ruleKicker": "Fix the pattern, not just the text",

      // Premium messages
      "premium.required.title": "Premium Feature",
      "premium.required.description": "Personalized study plans are only available on a premium plan. Upgrade now to view and use your customized learning plan.",
      "premium.required.descriptionLessons": "Advanced lessons and modules are only available on a premium plan. Upgrade now to access all learning content.",
      "premium.required.descriptionExams": "Additional exam variants are only available on a premium plan. Upgrade now to access all exam variants.",
      "premium.required.mockExam.title": "Do not risk exam day",
      "premium.required.mockExam.body": "Practice complete {{provider}} {{level}} mock exams first. Go into the real exam prepared.",
      "premium.required.mockExam.subtext": "Timed variants + score prediction",
      "premium.required.mockExam.cta": "Unlock mock exams",
      "premium.required.mockExam.secondary": "Maybe later",
      "premium.required.mockExam.attemptUsedTitle": "Your free attempt is used",
      "premium.required.mockExam.attemptUsedBody": "The free plan includes one full mock exam attempt. Upgrade to Premium for unlimited {{provider}} {{level}} mock exams and variants.",
      "premium.required.vocabulary.title": "Build exam-ready vocabulary faster",
      "premium.required.vocabulary.body": "Advanced vocabulary decks and spaced repetition are available only on a Premium plan. Upgrade now to unlock all vocabulary topics.",
      "premium.required.vocabulary.cta": "Unlock vocabulary decks",
      "premium.required.grammar.title": "Master German grammar with confidence",
      "premium.required.grammar.body": "Advanced grammar lessons and exercises are available only on a Premium plan. Upgrade now to unlock all grammar modules.",
      "premium.required.grammar.cta": "Unlock grammar lessons",
      "premium.required.grammar.attemptUsedTitle": "Your free grammar pass is used",
      "premium.required.grammar.attemptUsedBody": "The free plan includes one pass of the first grammar module. Upgrade to Premium for unlimited access to all grammar lessons and exercises.",
      "premium.required.reading.title": "Master all reading task types",
      "premium.required.reading.body": "Want to enter your exam with confidence? Premium unlocks all reading samples: each one is a different {{provider}} {{level}} exam. You will see every text type and task format before exam day.",
      "premium.required.reading.cta": "Start unlimited reading practice",
      "premium.required.listening.title": "Improve listening in 30 days",
      "premium.required.listening.body": "82% of Premium members report more confidence in listening within 4 weeks. With Premium for {{provider}} {{level}}, you train with multiple samples, different voices, accents, and speaking speeds.",
      "premium.required.listening.cta": "Activate Premium today",
      "premium.required.writing.title": "Write like a pro and pass like an expert",
      "premium.required.writing.body": "The quality of your writing directly affects your exam score and future opportunities. Premium for {{provider}} {{level}} unlocks all writing tasks, from formal correspondence to argumentative texts.",
      "premium.required.writing.cta": "Start Premium writing training",
      "premium.required.secondary": "Maybe later",
      "premium.required.upgrade": "Get Premium Now",
      "premium.required.back": "Back to Dashboard",
      "premium.required.backLessons": "Back to Lessons",
      "premium.required.close": "Close",
      "premium.required.button": "Premium Required",
      "premium.only": "Premium Only",
    // About Us Page
     // About Us Page

"about.hero.title": "About Us",
"about.hero.subtitle": "From Passion to Platform: Building Logami",

"about.chapter1.number": "Our Story",
"about.chapter1.title": "Why Logami Exists",
"about.chapter1.year": "",
"about.chapter1.text": "Logami was born from a simple observation: exam preparation shouldn't require expensive private tutoring or exclusive access to resources. Too many learners struggle not because they lack ability, but because they lack structure, focused practice, and clear guidance. We built Logami to change that, combining expert teaching methodology with modern technology to create an app that makes German exam preparation structured, accessible, and effective for everyone.",
"about.chapter1.quote": "Quality exam preparation should be accessible to everyone, not just those who can afford private classes.",

// Chapter 2: The Football Match
"about.chapter2.number": "The Spark",
"about.chapter2.title": "The Football Match",
"about.chapter2.text": "The 2013 Champions League Final: Bayern Munich versus Borussia Dortmund. On the screen, Emir saw the words 'Echte Liebe' for the first time. That phrase, the passion of the players, and the energy of Dortmund's Gelbe Wand (Yellow Wall) sparked an obsession that set him on a new path of learning German. What began as a football fan's fascination soon turned into a lifelong relationship with the language and culture.",
// Chapter 3: Building Logami (REVISED - More about the solution)
"about.chapter3.number": "The Solution",
"about.chapter3.title": "Building Logami",
"about.chapter3.text": "After years of teaching German to hundreds of students preparing for exams like Goethe, telc, and TestDaF, the patterns became clear: students needed three things to succeed: a clear study plan, focused practice materials, and consistent feedback. Traditional apps were too gamified and unfocused. Private tutoring was too expensive. Logami bridges this gap by offering exam-specific preparation with the structure of a professional course at a fraction of the cost.",
"about.chapter3.highlight": "Logami combines professional teaching methodology with the convenience and affordability of a mobile app.",

// Meet the Founder Section (REVISED - Personal credentials & expertise)
"about.founder.number": "The Founder",
"about.founder.title": "Meet Emir Safari",
"about.founder.role": "Founder & Lead Instructor",
"about.founder.credentials": "Germanistik Graduate • Certified German Teacher • Product Designer",
"about.founder.bio1": "With a degree in Germanistik and years of teaching experience both abroad and in Germany, Emir understands the German language from both academic and practical perspectives. He has prepared hundreds of students for German proficiency exams, helping them achieve their goals and move forward in their careers and lives.",
"about.founder.bio2": "His unique background combines linguistic expertise with product design skills, allowing him to create not just educational content, but a complete learning experience. Every feature in Logami is informed by real classroom experience and direct feedback from students who have successfully passed their exams.",
"about.founder.bio3": "As someone who learned German as a foreign language himself, Emir knows firsthand the challenges learners face. This empathy, combined with professional teaching qualifications, makes Logami uniquely positioned to help you succeed.",
"about.founder.quote": "I've sat where you're sitting. I've taken these exams. I know what works because I've lived it and taught it.",
"about.founder.portfolioLink": "See Emir's full portfolio",
"founderPortfolio.loading": "Loading the portfolio…",
"founderPortfolio.openLink": "Open Emir's portfolio",

// Chapter 4: Vision and Mission
"about.chapter4.number": "Our Mission",
"about.chapter4.title": "Vision and Mission",
"about.chapter4.text": "Our mission is simple: to help students prepare effectively and pass their German exams. You shouldn't need expensive or exclusive classes to succeed. You just need a clear plan, the right practice, and a supportive community.",

// Mission Cards
"about.mission.plan.title": "Plan",
"about.mission.plan.text": "Follow a clear roadmap tailored to your specific German exam.",
"about.mission.practice.title": "Practice",
"about.mission.practice.text": "Access focused, engaging practice materials and courses for exams such as Goethe, telc, or TestDaF, all in one easy-to-use app.",
"about.mission.pass.title": "Pass",
"about.mission.pass.text": "Enter your exam with confidence and achieve your goal.",

// Chapter 5: The Team
"about.chapter5.number": "Our Team",
"about.chapter5.title": "Growing Together",
"about.chapter5.text": "We are a growing team of passionate German instructors and tech enthusiasts, working together to build a platform that evolves every day with your feedback at its heart. Together, we're redefining what effective exam preparation looks like, one update, one student, and one success at a time.",
  "about.cta.title": "Join our growing community",
  "about.cta.description": "With your support we grow every day, on a mission to create the best place in the world to learn, and above all practise. German.",
  "about.cta.button": "Start your journey",
        "about.team.title": "Meet the Core Team",

      "about.team.member1.name": "Team Member 1",
      "about.team.member1.role": "Founder & CEO",
      "about.team.member1.bio": "Experienced language education professional with expertise in curriculum development and educational technology.",

      "about.team.member2.name": "Team Member 2",
      "about.team.member2.role": "Head of Curriculum",
      "about.team.member2.bio": "Certified language examiner specializing in test preparation and assessment standards for German proficiency exams.",

      "about.team.member3.name": "Team Member 3",
      "about.team.member3.role": "Lead Developer",
      "about.team.member3.bio": "Software architect focused on creating user-friendly educational platforms with modern web technologies.",
      // Pricing Page
      "pricing.header.badge": "Pricing",
      "pricing.header.title": "The Perfect Plan for Your Success",
      "pricing.header.subtitle": "Start today and achieve your exam goal with our comprehensive preparation. Flexible and risk-free.",

      // Plans, shared keys used by PricingPage, OnboardingModal, etc.
      "pricing.plans.free.name": "Free",
      "pricing.plans.free.headline": "See if Logami is right for you",
      "pricing.plans.free.description": "No commitment. No credit card. Ever.",
      "pricing.plans.free.benefits": [
        "Try 1 real mock exam",
        "Browse lessons & grammar overviews",
        "Cancel nothing, ever"
      ],
      "pricing.plans.free.trustLine": "No credit card required",
      "pricing.plans.free.features": [
        "1 full mock exam",
        "Grammar & vocabulary (A1–B1)",
        "Basic progress dashboard"
      ],

      "pricing.plans.weekly.name": "1 Week",
      "pricing.plans.weekly.price": "€9,99",
      "pricing.plans.weekly.cycle": "/week",
      "pricing.plans.weekly.headline": "Exam next week? You're not too late.",
      "pricing.plans.weekly.description": "7 days of focused, high-impact prep.",
      "pricing.plans.weekly.benefits": [
        "3 full mock exams, the real formats",
        "Know scoring tricks before you sit down",
        "AI analysis of your exact weak spots"
      ],
      "pricing.plans.weekly.trustLine": "One-time payment · 7 days of access",
      "pricing.plans.weekly.features": [
        "3 full mock exams",
        "All lessons & essential exam tips",
        "Logami's AI analysis",
        "Proven strategies to score 100%"
      ],

      "pricing.plans.monthly.name": "Monthly",
      "pricing.plans.monthly.price": "€29,99",
      "pricing.plans.monthly.cycle": "/month",
      "pricing.plans.monthly.headline": "Full access. No long commitment.",
      "pricing.plans.monthly.description": "Same power as 3 months, stop when you're ready.",
      "pricing.plans.monthly.benefits": [
        "Access to all mock exams & full lessons",
        "One payment, full access for 30 days",
        "Start today, access valid for 30 days"
      ],
      "pricing.plans.monthly.trustLine": "One-time payment · 30 days of access",
      "pricing.plans.monthly.features": [
        "Access to all mock exams",
        "Full lessons & exam tips",
        "Personalized learning plan",
        "Logami's AI analysis",
        "Full curriculum A1–C1"
      ],

      "pricing.plans.quarterly.name": "3 Months",
      "pricing.plans.quarterly.price": "€49,99",
      "pricing.plans.quarterly.cycle": "/3 months",
      "pricing.plans.quarterly.headline": "Everything. For less than your exam fee.",
      "pricing.plans.quarterly.description": "The complete path from prep to pass.",
      "pricing.plans.quarterly.benefits": [
        "Full access to every tool, lesson & exam",
        "3 sessions with a real German examiner",
        "AI tracks your weak spots week by week"
      ],
      "pricing.plans.quarterly.trustLine": "Best value · 50% off · one-time payment",
      "pricing.plans.quarterly.features": [
        "Everything in Monthly",
        "Over 50% savings",
        "Priority email support"
      ],
      "pricing.plans.popular": "Most Popular",
      "pricing.plans.labels.popular": "Most Popular",

      "pricing.plans.cycles.once": "forever",
      "pricing.plans.cycles.week": "week",
      "pricing.plans.cycles.month": "month",
      "pricing.plans.cycles.quarter": "3 months",

      // Features (legacy keys)
      "pricing.features.allExercises": "All exercises & practice exams",
      "pricing.features.videoExplanations": "Video explanations",
      "pricing.features.personalizedPlan": "Personalized learning plan",
      "pricing.features.aiAnalysis": "Logami's AI analysis",
      "pricing.features.allBenefits": "All benefits of monthly plan",
      "pricing.features.savings": "Over 50% savings",

      "pricing.features.support": "Priority email support",

      // Buttons
      "pricing.selectPlan": "Select Plan",
      "pricing.writeReview": "Write Review",

      // FAQs
      "pricing.faq.title": "Frequently Asked Questions",

      // Payment FAQ, shared between PricingPage and FaqPage
      "faq.questions.paymentOneTime": "Is this a one-time payment or a subscription?",
      "faq.answers.paymentOneTime": "One-time payment only. You pay once for the plan duration you choose, no auto-renewals, no recurring charges, ever.",

      "faq.questions.paymentAccess": "How long does my access last?",
      "faq.answers.paymentAccess": "Weekly gives you 7 days, Monthly gives you 30 days, and Quarterly gives you 90 days. Once your period ends, you can simply repurchase, no automatic charges.",

      "faq.questions.paymentFree": "Is there a free option?",
      "faq.answers.paymentFree": "Yes. You can use Logami for free with access to basic features and a limited number of practice sessions. Upgrade anytime when you're ready.",

      "faq.questions.paymentMethods": "What payment methods do you accept?",
      "faq.answers.paymentMethods": "We accept all major credit and debit cards (Visa, Mastercard, American Express), as well as Apple Pay and Google Pay.",

      "faq.questions.paymentRefund": "Can I get a refund?",
      "faq.answers.paymentRefund": "All purchases are final. However, if a technical issue prevents you from accessing the platform and remains unresolved after 48 hours of contacting our support, we will issue a full refund.",

      "faq.questions.telcVsGoethe": "Is telc easier than Goethe, and which German exam should I choose?",
      "faq.answers.telcVsGoethe": "Both exams test the same CEFR level and both are officially recognized in Germany, so neither is easier in terms of content. The scoring works differently, though. In the telc B1/B2 written exam, a strong reading or listening result can make up for a weaker writing score. Goethe requires **at least 60% in every module separately**. Goethe certificates are often preferred for international university applications, while telc is very common for work and residence purposes in Germany. Check which certificate your university, employer, or authority accepts, then prepare for exactly that format.",
      "faq.questions.mockSimilarity": "How similar are Logami mock exams to the real telc, Goethe and ÖSD exams?",
      "faq.answers.mockSimilarity": "Our mock exams follow the **official exam format**: the same sections, the same task types, the same number of questions, and the same time limits as the real telc, Goethe, and ÖSD papers. The simulator runs on real exam timing, and your writing is scored against criteria modelled on the official examiner rubric. Each exam includes several complete practice papers, so you can repeat full simulations with fresh content.",
      "faq.questions.mocksEnough": "Are mock exams enough to pass, and how many should I take?",
      "faq.answers.mocksEnough": "If you are already close to the target level, mock exams are the most effective preparation tool available. They train your timing, familiarize you with every task format, and build the stamina a long exam day demands. We recommend **3 to 5 full timed simulations** before exam day, combined with focused practice in your weakest section. Most candidates lose points to unfamiliar task formats and time pressure rather than to gaps in their German.",
      "faq.questions.prepTime": "How long does it take to prepare for a German B1, B2 or C1 exam?",
      "faq.answers.prepTime": "As a rough guideline, total learning time from zero is about **350 to 650 hours for B1, 600 to 800 hours for B2, and 800 to 1,000 hours for C1**. If you have already reached the target level, focused exam preparation typically takes **4 to 8 weeks**: learning the format, completing timed mock exams, and strengthening your weakest section. This exam-specific phase matters more than most people expect, because knowing the format is worth real points.",
      "faq.questions.passScore": "What score do I need to pass telc, Goethe or ÖSD exams?",
      "faq.answers.passScore": "The passing threshold is **60%** at all three providers, but it is applied differently. **Goethe** requires at least 60 of 100 points in each module (reading, listening, writing, speaking) separately. In the **telc B1/B2** written exam you need 60% overall, and the sections can compensate for each other; the oral exam is scored separately and also requires 60%. At **ÖSD B1** (ZDÖ B1) it works like telc: you need 135 of the 225 written points with no minimum per section, and the oral exam is scored separately. At **ÖSD B2 and C1** you need 42 of 70 written points plus a minimum in reading, listening and writing. Your preparation strategy should match the scoring rules of your specific exam.",
      "faq.questions.failedModule": "What happens if I fail one part of the exam?",
      "faq.answers.failedModule": "You usually do not have to repeat everything. At **Goethe**, modules can be retaken individually as often as needed, and passed modules combine into a full certificate within one year. At **telc**, a passed written or oral part can be credited, so you only retake the failed part within twelve months. At **ÖSD**, failed parts can generally be repeated within a year. Rules can vary between exam centres, so confirm the details with yours before booking a retake.",
      "faq.questions.schreibenScoring": "How is the Schreiben (writing) section graded?",
      "faq.answers.schreibenScoring": "Examiners grade your text against fixed criteria: **task fulfilment** (did you address all required points?), **structure and coherence**, **range of vocabulary**, and **grammatical accuracy**. The exact weighting depends on the provider. Formal elements count as well; a missing subject line or greeting costs points immediately. Logami AI writing feedback scores your text against criteria modelled on the official rubric and shows you exactly where points were lost.",
      "faq.questions.selfStudy": "Can I pass a German exam with online self-study, without a preparation course?",
      "faq.answers.selfStudy": "Yes, many candidates pass this way in every exam round. What a preparation course really provides is structure, knowledge of the format, and feedback. All three can be replicated online: a study plan gives you structure, full mock exams teach you the format, and AI-scored writing practice gives you feedback. A course is mainly worth it if you need external accountability. If your German is at the target level, focused self-study with realistic simulations is a proven path.",
      "faq.questions.freeMock": "Can I try a free German mock exam online?",
      "faq.answers.freeMock": "Yes. You can start a **full mock exam for free without creating an account**, with the real exam format and real timing for telc, Goethe, or ÖSD at levels B1 to C1. If you then create a free account, you unlock the full scored breakdown of your answers and can track your progress across attempts.",
      "faq.questions.examForGoal": "Which German exam do I need for university, work or citizenship?",
      "faq.answers.examForGoal": "For **university admission** in Germany or Austria you usually need C1; telc C1 Hochschule, the Goethe-Zertifikat C1, and ÖSD C1 are all widely accepted. For **German citizenship** or a settlement permit, a B1 certificate is generally required, and both telc and Goethe are accepted. For **work**, B2 is the common threshold for qualified positions, and regulated professions such as healthcare often require B2 or C1 with specific certificates. Each institution sets its own requirements, so confirm them before you register and then prepare for that exact exam.",
      "pricing.cta.ready": "Ready for",
      "pricing.cta.title": "Ready to pass your exam?",
      "pricing.cta.description": "Choose your plan and get full access to practice materials, the exam simulator, and personalised study plans.",
      "pricing.cta.button": "Get Started",
      "pricing.reviews.write": "Write Review",
      
      // Checkout Page
      "checkout.title": "Complete Payment",
      "checkout.subtitle": "Secure payment with Stripe",
      "checkout.backToPricing": "Back to Pricing",
      "checkout.backToOnboarding": "Back to onboarding",
      "checkout.continueWithFree": "You can continue with the free plan and complete your setup.",
      "checkout.continueWithFreeLink": "Continue with free plan",
      "checkout.orderSummary": "Order Summary",
      "checkout.total": "Total",
      "checkout.loading": "Preparing payment...",
      "checkout.processing": "Processing...",
      "checkout.payButton": "Pay {amount} Now",
      "checkout.securityNotice": "Your payment is securely processed by Stripe. We do not store credit card information.",
      "checkout.success.title": "Payment Successful!",
      "checkout.success.message": "Payment complete! Your premium access is now active. Redirecting to dashboard...",
      "checkout.error.title": "Payment Error",
      "checkout.error.paymentFailed": "Payment could not be processed. Please try again.",
      "checkout.error.redirectFailed": "Your payment was not completed and you have not been charged. Please try again or choose another payment method.",
      "checkout.error.initializationFailed": "Payment could not be initialized. Please try again later.",
      "checkout.error.retry": "Retry",
      "checkout.discountCode": "Discount Code",
      "checkout.discountCode.placeholder": "Enter discount code",
      "checkout.discountCode.apply": "Apply",
      "checkout.discountCode.applied": "Discount Applied",
      "checkout.discountCode.remove": "Remove discount",
      "checkout.discount": "Discount",
      "checkout.verify.title": "Verify your email before upgrading",
      "checkout.verify.description": "For account security, please verify your email first. After verification, you can complete payment here.",
      "checkout.verify.sent": "Verification email sent. Check your inbox and spam folder.",
      "checkout.verify.sendButton": "Send verification email",
      "checkout.verify.sending": "Sending verification email...",
      "checkout.verify.refreshButton": "I've verified, continue",
      "checkout.verify.checking": "Checking verification...",
      "checkout.verify.error.sendFailed": "Could not send verification email. Please try again.",
      "checkout.verify.error.notVerifiedYet": "Email is not verified yet. Check your inbox and spam folder, then try again.",
      "checkout.verify.error.refreshFailed": "Could not refresh verification status. Please try again.",
      "appLayout.verifyBanner.title": "Verify your email",
      "appLayout.verifyBanner.description": "We sent a verification link to {{email}}. You can continue using Logami now, but please verify your email soon.",
      "appLayout.verifyBanner.sent": "Verification email sent. Check your inbox and spam folder.",
      "appLayout.verifyBanner.sendButton": "Send verification email",
      "appLayout.verifyBanner.sending": "Sending...",
      "appLayout.verifyBanner.refreshButton": "I've verified",
      "appLayout.verifyBanner.refreshing": "Checking...",
      "appLayout.verifyBanner.close": "Close verification banner",
      "appLayout.verifyBanner.error.sendFailed": "Could not send verification email. Please try again.",
      "appLayout.verifyBanner.error.notVerifiedYet": "Email is not verified yet. Please check your inbox and spam folder.",
      "appLayout.verifyBanner.error.refreshFailed": "Could not refresh verification status. Please try again.",
      
      // Subscription Management Page
      "subscription.title": "My Plan",
      "subscription.subtitle": "Manage your plan and purchase history",
      "subscription.loading": "Loading plan details...",
      "subscription.back": "Back",
      "subscription.syncIssue.title": "Plan Sync Issue Detected",
      "subscription.syncIssue.refresh": "Refresh Plan Status",
      "subscription.free.title": "Free Plan",
      "subscription.free.status": "Free",
      "subscription.free.currentStatus": "Your current account status",
      "subscription.free.features.title": "Free Plan Features",
      "subscription.free.feature1": "Access to first exam variant for each exam type",
      "subscription.free.feature2": "Basic study materials and lessons",
      "subscription.free.feature3": "Progress tracking and dashboard",
      "subscription.free.upgrade.title": "Upgrade to Premium",
      "subscription.free.upgrade.description": "Unlock all exam variants, premium features, and exclusive content with a Premium plan.",
      "subscription.free.upgrade.button": "View Premium Plans",
      "subscription.noActive.title": "No Active Plan",
      "subscription.noActive.description": "You don't have an active plan.",
      "subscription.noActive.viewPlans": "View Plans",
      "subscription.premium.title": "Premium Plan",
      "subscription.premium.active": "Active",
      "subscription.purchaseDate": "Purchase Date",
      "subscription.expiresOn": "Expires On",
      "subscription.daysRemaining": "{{count}} day remaining",
      "subscription.daysRemaining_plural": "{{count}} days remaining",
      "subscription.paymentMethod.title": "Payment Method",
      "subscription.paymentMethod.loadFromStripe": "Load from Stripe",
      "subscription.paymentMethod.loading": "Loading payment method...",
      "subscription.paymentMethod.notAvailable": "Payment method information not available",
      "subscription.paymentMethod.stripeInfo": "Payment method is saved in Stripe. Click \"Load from Stripe\" to retrieve it.",
      "subscription.paymentMethod.stripeDetails": "Card details are stored in Stripe. Click \"Load from Stripe\" to show the card used for your last purchase.",
      "subscription.paymentMethod.expires": "Expires",
      "subscription.paymentMethod.amount": "Amount",
      "subscription.purchaseHistory.title": "Purchase History",
      "subscription.purchaseHistory.purchaseDate": "Purchase Date",
      "subscription.purchaseHistory.expires": "Expires",
      "subscription.purchaseHistory.amount": "Amount",
      "subscription.purchaseHistory.discountApplied": "Discount Applied",
      "subscription.purchaseHistory.adminAssigned": "Admin Assigned",
      "subscription.status.active": "Active",
      "subscription.status.cancelled": "Cancelled",
      "subscription.status.expired": "Expired",
      "subscription.status.completed": "Completed",
      "subscription.cancel.title": "Cancel Plan",
      "subscription.cancel.description": "Cancelling will end your premium access early. You'll retain access to all premium features until {{date}}.",
      "subscription.cancel.button": "Cancel Plan",
      "subscription.cancel.confirm": "Hold the button to confirm cancellation",
      "subscription.cancel.holdToCancel": "Hold to Cancel",
      "subscription.cancel.holdToCancelProgress": "Hold to Cancel ({{progress}}%)",
      "subscription.cancel.cancelling": "Cancelling...",
      "subscription.cancel.keepHolding": "Keep holding... {{progress}}%",
      "subscription.cancel.cancelButton": "Cancel",
      "subscription.cancel.success": "Your plan has been cancelled. You will retain access until {{date}}.",
      "subscription.cancel.error": "Failed to cancel plan. Please try again or contact support.",
      "subscription.error.loadFailed": "Failed to load subscription details. Please try again.",
      
      // Additional Navigation
      "nav.home": "Home",
      "nav.blog": "Blog",
      "nav.about": "About",
        "nav.faq": "FAQ",
        // FAQ Page translations - ADD THESE TO YOUR ENGLISH TRANSLATION OBJECT IN src/i18n/index.js
// Copy and paste these key-value pairs into your English translations object

"faq.title": "Frequently Asked Questions",
"faq.subtitle": "Find answers to common questions about our platform.",
"faq.contactMessage": "Can't find the answer you're looking for? Feel free to reach out to us on our Contact page.",

// FAQ Questions
"faq.questions.appPurpose": "What is Logami and who is it for?",
"faq.questions.examTypes": "Which German language exams and levels do you prepare for?",
"faq.questions.languages": "Is the app's interface available in languages other than German?",
"faq.questions.features": "What are the main features of the platform?",
"faq.questions.studyPlan": "How does the personalized study plan work?",
"faq.questions.gamification": "What is \"Gamification\" and how does it help with learning?",
"faq.questions.examSections": "Can I practice specific sections of an exam, like just the reading or writing part?",
"faq.questions.download": "Do I need to download anything from the App Store or Google Play?",
"faq.questions.devices": "Can I use the app on my phone, tablet, and computer?",
"faq.questions.offline": "Is it possible to use the app offline?",
"faq.questions.account": "Do I need to create an account to use the app?",
"faq.questions.progress": "How do you track my learning progress?",
"faq.questions.mission": "What's the story and mission behind the app?",

// FAQ Answers
"faq.answers.appPurpose": "Logami is an exam preparation platform for German language learners targeting official certifications. It covers TELC, Goethe, and ÖSD exams at B1, B2, and C1 levels. You get a full mock exam simulator, section-by-section practice, structured lessons, and AI-powered writing feedback, everything in one place, accessible from any browser.",
"faq.answers.examTypes": "We provide authentic learning materials for the most recognized German language certifications: TELC, Goethe, and ÖSD. The content covers the B1, B2, and C1 levels, making it suitable for both intermediate and advanced learners aiming for certification or general fluency.",
"faq.answers.languages": "Yes, absolutely. The entire user interface is available in multiple languages to ensure a comfortable learning experience for everyone. You can choose from English, Deutsch, Français, Español, Türkçe, and Русский. You can change your preferred language at any time in the settings.",
"faq.answers.features": "Logami gives you a complete toolkit for exam preparation: a full mock exam simulator with real exam conditions, Reading and Listening section training, a Writing lab with AI feedback on your essays, Grammar exercises for B1 to C1, Vocabulary flashcards, a Redemittel (key phrases) trainer, and structured lessons built around your personalized study plan.",
"faq.answers.studyPlan": "After you select your target exam and level, Logami generates a personalized study plan broken down by skill and topic. It guides you through lessons in a structured order, covering Reading, Listening, Writing, Grammar, and Vocabulary, so you always know what to study next and nothing falls through the cracks.",
"faq.answers.gamification": "Gamification is a powerful learning tool we are integrating into the platform, which will be available in a future update. It makes learning more fun and motivating by adding game-like elements. You'll be able to earn XP for completing exercises, maintain a daily practice streak, and unlock achievements and badges for your progress.",
"faq.answers.examSections": "Yes. You can train each exam section individually. Reading (Lesen), Listening (Hören), Writing (Schreiben), Grammar, Vocabulary, and Redemittel. Each section has dedicated exercises and materials tailored to your chosen exam and level.",
"faq.answers.download": "No, not at this time. This is a Progressive Web App (PWA), which gives you an app-like experience directly in your web browser. For quick access, you can add it to your home screen on any phone, tablet, or computer. We are planning to develop native mobile apps in the future.",
"faq.answers.devices": "Yes. The application is fully responsive and designed with a mobile-first approach, ensuring a seamless experience whether you are on a desktop computer, a tablet, or your smartphone.",
"faq.answers.offline": "Yes, to a certain extent. As a Progressive Web App (PWA), it uses Service Workers to cache key application resources. This means you can load the app and continue some learning activities even when you have an unstable or no internet connection.",
"faq.answers.account": "Yes, a free account is required. This allows the platform to save all your learning data, track your progress in grammar and vocabulary, and sync your achievements across all your devices.",
"faq.answers.progress": "Your dashboard tracks performance across every section, grammar topics mastered, vocabulary learned, mock exam scores, and writing submissions. You can see your study streaks, activity history, and a breakdown of your strengths and weak areas so you always know where to focus next.",
"faq.answers.mission": "The app was founded out of a direct, personal need for a better way to prepare for German language exams. Our founder realized there wasn't a single platform that brought everything a learner needed into one place. Our mission is to fill that gap and offer a clear, supportive, and effective path to language certification, guided by our motto: **Plan, Practice, Pass**.",

      "nav.pricing": "Pricing",
      "nav.lessons": "Lessons",
      "nav.login": "Login",
      "nav.getStarted": "Get Started",
      "nav.menu": "Menu",
      "nav.installApp": "Install App",
      "nav.shareApp": "Share App",
     // Sidebar Navigation - ENGLISH
"sidebar.dashboard": "Dashboard",
"sidebar.examMocks": "Exam Mocks",
"sidebar.lessons": "Lessons",
"sidebar.practiceHub": "Practice Hub",
"sidebar.lernpfad": "Learning Path",
"sidebar.examSimulator": "Exam Simulator",
"sidebar.writingLab": "Writing Lab",
"sidebar.stats": "Profile",
"sidebar.settings": "Settings",
"sidebar.emailVerification.notVerified": "Not verified",
"sidebar.admin": "Admin Dashboard",
"sidebar.badge.soon": "Soon",
"sidebar.badge.premium": "Premium",
"sidebar.badge.pro": "Pro",
"sidebar.upgradeToPremium": "Upgrade to Premium",

// Secondary Navigation - ENGLISH
"sidebar.more": "More",
"sidebar.showLess": "Show less",
"sidebar.resources": "Resources",
"sidebar.blog": "Blog",
"sidebar.aboutUs": "About Us",
"sidebar.pricing": "Pricing",

// Account Section - ENGLISH
"sidebar.account": "Account",
"sidebar.profile": "Profile",

// App Features - ENGLISH
"sidebar.appFeatures": "App Features",
"sidebar.shareApp": "Share App",
"sidebar.installApp": "Install App",
      "sidebar.logout": "Logout",
      "sidebar.consultations": "Consultations",
      
      // Consultation Booking
      "consultation.title": "Book Consultation",
      "consultation.subtitle": "Book a 20-minute consultation with an examiner",
      "consultation.remaining": "Remaining Consultations",
      "consultation.bookAppointment": "Book Appointment",
      "consultation.selectDate": "Select Date",
      "consultation.selectTime": "Select Time",
      "consultation.notes": "Notes",
      "consultation.notesPlaceholder": "Let us know how we can help you...",
      "consultation.bookNow": "Book Now",
      "consultation.booking": "Booking...",
      "consultation.bookingSuccess": "Appointment booked successfully!",
      "consultation.emailVerification": "A verification email will be sent to you.",
      "consultation.zoomMeeting": "The meeting will be held via Zoom.",
      "consultation.bookingError": "Error booking appointment. Please try again.",
      "consultation.selectDateAndTime": "Please select a date and time.",
      "consultation.noRemaining": "You have no remaining consultations.",
      "consultation.noSlotsAvailable": "No available time slots for this date.",
      "consultation.pastDate": "Please select a future date.",
      "consultation.loadError": "Error loading data.",
      "consultation.slotsError": "Error loading available time slots.",
      "consultation.loading": "Loading...",
      "consultation.locked": "Premium Feature",
      "consultation.requiresQuarterly": "This feature is only available with the 3-month plan.",
      "consultation.viewPlans": "View Plans",
      "consultation.myAppointments": "My Appointments",
      "consultation.noAppointments": "You haven't booked any appointments yet.",
      "consultation.minutes": "minutes",
      "consultation.notQuarterly": "You need the 3-month plan to book consultations.",
      "consultation.availableDays": "Available Days",
      "consultation.monday": "Monday",
      "consultation.tuesday": "Tuesday",
      "consultation.thursday": "Thursday",
      "consultation.timeRange": "10:00 AM - 12:00 PM & 4:00 PM - 6:00 PM",
      "consultation.morningSlots": "Morning",
      "consultation.afternoonSlots": "Afternoon",
      "consultation.unavailableDay": "Consultations are only available on Monday, Tuesday, and Thursday.",
      "common.back": "Back",
      "common.optional": "Optional",
      
      // Dashboard

      "dashboard.loading": "Loading dashboard...",
      "dashboard.subtitle": "Your path to {{examName}} starts here.",
    "dashboard.examSuccess": "exam success",

      // Stats Cards
      "dashboard.stats.predictedScore": "Predicted Score",
      "dashboard.stats.overallProgress": "Overall Progress",
      "dashboard.stats.currentStreak": "Current Streak",
      "dashboard.stats.days": "Days",
      "dashboard.stats.completed": "Completed",

      // Performance Section
      "dashboard.performance.title": "Performance & Progress",
      "dashboard.performance.subtitle": "Track your improvement over time",

      // Weak Areas
      "dashboard.weakAreas.title": "Weak Areas",
      "dashboard.weakAreas.subtitle": "Areas that need attention",
      "dashboard.weakAreas.none": "No weak areas identified.",

      // Suggested Lessons
      "dashboard.lessons.title": "Suggested Lessons",
      "dashboard.lessons.subtitle": "Based on your performance",

      // Achievements
      "dashboard.achievements.title": "Achievements",
      "dashboard.achievements.subtitle": "Your recent accomplishments",
      "dashboard.achievements.viewAll": "View All",
      "dashboard.achievements.none": "No achievements unlocked yet.",

      // Quick Actions
      "dashboard.quickActions.title": "Quick Actions",
      "dashboard.quickActions.startExam": "Take your mock exam",
      "dashboard.quickActions.viewStudyPlan": "View Study Plan",
      "dashboard.quickActions.continueLearning": "Continue Learning",

      // Milestones
      "dashboard.milestone.congratulations": "Congratulations!",
      "dashboard.milestone.achieved": "Milestone Achieved",

      // Welcome Messages
      "dashboard.welcome.morning": "Good Morning!",
      "dashboard.welcome.afternoon": "Good Afternoon!",
      "dashboard.welcome.evening": "Good Evening!",
      "dashboard.welcome.readyToStudy": "Ready to study?",

      // Progress Indicators
      "dashboard.progress.onTrack": "On Track",
      "dashboard.progress.needsWork": "Needs Work",
      "dashboard.progress.excellent": "Excellent",
      // General Dashboard
      "dashboard.learner": "Learner",
      "dashboard.noExamSelected": "No exam selected",
      "dashboard.changeExam": "Change",

      // Skills (for chart data)
      "skills.reading": "Reading",
      "skills.listening": "Listening",
      "skills.writing": "Writing",
      "skills.speaking": "Speaking",

      // Stats and Progress
      "dashboard.stats.basedOnExercises": "Based on your exercises",
      "dashboard.stats.studyPlanCompleted": "of your study plan completed",
      "dashboard.stats.questionsAnswered": "questions answered",
      "dashboard.stats.accuracy": "Accuracy",
      "dashboard.stats.day": "Day",
      "dashboard.stats.studyStreak": "Study Streak",

      // Encouragement Messages
      "dashboard.encouragement.keepGoing": "Keep it up!",
      "dashboard.encouragement.incredible": "Incredible! 🔥",

      // Lesson Suggestions
      "dashboard.lessons.improvement": "Improvement",
      "dashboard.lessons.focusOn": "Focus on",
      "dashboard.lessons.recommendedLessons": "Recommended Lessons",

      // Weak Areas Details
      "dashboard.weakAreas.greatNoWeakAreas": "Great! No weak areas identified.",

      // Quick Actions - Additional
      "dashboard.quickActions.practiceExam": "Take your mock exam",

      // Button Labels
      "button.change": "Change",
      // Loading States
      "stats.loading.title": "Loading statistics...",
      "stats.loading.description": "Your activity data is being initialized. This may take a moment.",

      // Main Stats Labels
      "stats.main.studyTime": "Study Time",
      "stats.main.streakDays": "Day Streak",
      "stats.main.lessons": "Lessons",
      "stats.main.exams": "Exams",

      // Learning Progress Section
      "stats.learning.title": "Learning Progress",
      "stats.learning.vocabularyLearned": "Vocabulary learned",
      "stats.learning.grammarTopics": "Grammar topics",
      "stats.learning.practiceSessions": "Practice sessions",
      "stats.learning.overallAccuracy": "Overall accuracy",

      // Achievements Section
      "stats.achievements.title": "Achievements",
      "stats.achievements.unlocked": "Achievements unlocked",
      "stats.achievements.totalPoints": "Total points",
      "stats.achievements.longestStreak": "Longest streak",
      "stats.achievements.bestExamScore": "Best exam score",
      "stats.achievements.days": "Days",

      // Skills Overview Section
      "stats.skills.title": "Skills Overview",
      "stats.skills.listening": "Listening",
      "stats.skills.reading": "Reading",
      "stats.skills.writing": "Writing",
      "stats.skills.speaking": "Speaking",

      // Recent Activity Section
      "stats.activity.title": "Recent Activities",
      "stats.activity.completed": "Completed",
      "stats.activity.inProgress": "In Progress",
      "stats.activity.minutes": "min",

      // Recent Achievements Section
      "stats.recentAchievements.title": "Recent Achievements",
      "stats.recentAchievements.points": "Points",

      // Welcome Section for New Users
      "stats.welcome.title": "Welcome to Logami!",
      "stats.welcome.description": "Start your learning journey and track your progress here. The more you learn, the more detailed your statistics become.",
      "stats.welcome.firstLesson": "Start First Lesson",
      "stats.welcome.firstLessonDesc": "Begin learning",
      "stats.welcome.practiceExam": "Practice Exam",
      "stats.welcome.practiceExamDesc": "Test your knowledge",
      "stats.welcome.learnVocabulary": "Learn Vocabulary",
      "stats.welcome.learnVocabularyDesc": "Expand your vocabulary",

      // Activity Types
      "stats.activityType.exam": "exam",
      "stats.activityType.lesson": "lesson",
      "stats.activityType.practice": "practice",
      "stats.activityType.vocabulary": "vocabulary",
      // === PRACTICE PAGE ADDITIONS ===

      // Page Title & Navigation
      "practice.title": "Practice Mode",
      "practice.backButton": "Back",
      "practice.noExamWarning": "Please select an exam first",

      // Practice Options - Main Categories
      "practice.options.vocabulary.title": "Vocabulary",
      "practice.options.vocabulary.description": "Systematically expand your German vocabulary.",
      "practice.options.vocabulary.descriptionShort": "Systematic vocabulary building",

      "practice.options.grammar.title": "Grammar",
      "practice.options.grammar.description": "Practice German grammar rules and structures.",
      "practice.options.grammar.descriptionShort": "Grammar rules and structures",

      "practice.options.redemittel.title": "Useful Phrases",
      "practice.options.redemittel.description": "Learn useful phrases for writing and speaking.",
      "practice.options.redemittel.descriptionShort": "Useful phrases & expressions",

      // Exam Skills Options
      "practice.options.reading.title": "Reading Comprehension",
      "practice.options.reading.description": "Train reading skills for your exam.",
      "practice.options.reading.descriptionShort": "Reading comprehension training",

      "practice.options.listening.title": "Listening Comprehension",
      "practice.options.listening.description": "Improve your listening skills.",
      "practice.options.listening.descriptionShort": "Listening comprehension training",

      "practice.options.writing.title": "Written Expression",
      "practice.options.writing.description": "Practice writing texts.",
      "practice.options.writing.descriptionShort": "Writing training",

      "practice.options.speaking.title": "Oral Expression",
      "practice.options.speaking.description": "Prepare for the oral exam.",
      "practice.options.speaking.descriptionShort": "Speaking training",

      // Section Headers
      "practice.sections.skillBased": "Core Skills",
      "practice.sections.examBased": "Exam Skills",
      "practice.sections.progress": "Your Progress",

      // Progress & Stats
      "practice.stats.completed": "Completed",
      "practice.stats.inProgress": "In Progress",
      "practice.stats.notStarted": "Not Started",
      "practice.stats.accuracy": "Accuracy",
      "practice.stats.exercises": "Exercises",
      "practice.stats.minutes": "Minutes",

      // Buttons & Actions
      "practice.buttons.startPractice": "Start Practice",
      "practice.buttons.continuePractice": "Continue Practice",
      "practice.buttons.reviewProgress": "Review Progress",
      "practice.buttons.selectExam": "Select Exam",

      // Error Messages
      "practice.errors.noExamSelected": "No exam selected",
      "practice.errors.loadingError": "Loading error",
      "practice.errors.noContent": "No content available",

      // Loading States
      "practice.loading.options": "Loading practice options...",
      "practice.loading.progress": "Loading progress...",

      // Difficulty Levels
      "practice.difficulty.beginner": "Beginner",
      "practice.difficulty.intermediate": "Intermediate",
      "practice.difficulty.advanced": "Advanced",

      // Time & Duration
      "practice.time.minutes": "Min",
      "practice.time.hours": "Hrs",
      "practice.time.estimated": "Estimated Duration",

      // Achievement Messages
      "practice.achievements.wellDone": "Well done!",
      "practice.achievements.keepGoing": "Keep going!",
      "practice.achievements.improvement": "Improvement detected!",
      // === ADDITIONAL PRACTICE PAGE TRANSLATIONS ===


      // Exam Selection Messages
      "practice.noExamSelected": "Select an exam first",
      "practice.examWarning": "For exam-specific exercises, please first select an exam on the dashboard.",
      "practice.selectExamFirst": "Select an exam first",

      // Stats Cards
      "practice.stats.todayLearned": "Learned today",
      "practice.stats.lessons": "Lessons",
      "practice.stats.studyStreak": "Study Streak",
      "practice.stats.days": "Days",
      "practice.stats.weeklyXP": "XP this week",
      "practice.stats.points": "Points",
      "practice.stats.totalSessions": "Total Sessions",

      // Section Headers
      "practice.sections.languageSkills": "Language Skills",
      "practice.sections.examParts": "Exam Parts",

      // Recommended session banner (study-plan–based to-do)
      "practice.recommendedBanner.title": "This week",
      "practice.recommendedBanner.recommendedForThisWeek": "Recommended for this week",
      "practice.recommendedBanner.weekPhase": "Week {{week}} • {{phase}} Phase",
      "practice.recommendedBanner.weekOfTotal": "Week {{week}} of {{total}}",
      "practice.recommendedBanner.showMore": "{{count}} more",
      "practice.recommendedBanner.showLess": "Show less",
      "practice.recommendedBanner.phase.intro": "Introduction",
      "practice.recommendedBanner.phase.foundation": "Foundation",
      "practice.recommendedBanner.phase.intensive": "Intensive",
      "practice.recommendedBanner.phase.final": "Final",
      "practice.recommendedBanner.thisWeekFocus": "This Week's Focus",
      "practice.recommendedBanner.weeklyProgress": "Weekly Progress",
      "practice.recommendedBanner.tasksCount": "{{completed}} of {{total}} tasks",
      "practice.recommendedBanner.percentComplete": "{{percent}}% Complete",
      "practice.recommendedBanner.recommendedNext": "Recommended Next Step",
      "practice.recommendedBanner.startNow": "Start Now",
      "practice.recommendedBanner.otherTasksThisWeek": "Other Tasks This Week",
      "practice.recommendedBanner.taskType.vocabulary": "Vocabulary",
      "practice.recommendedBanner.taskType.grammar": "Grammar",
      "practice.recommendedBanner.taskType.exercises": "Exercises",
      "practice.recommendedBanner.taskType.redemittel": "Redemittel",
      "practice.recommendedBanner.taskType.lessons": "Lessons",
      "practice.recommendedBanner.taskType.simulation": "Simulation",
      "practice.recommendedBanner.taskType.lesen": "Reading Practice",
      "practice.recommendedBanner.taskType.horen": "Listening Practice",
      "practice.recommendedBanner.taskType.schreiben": "Writing Practice",
      "practice.recommendedBanner.chooseBelow": "Choose an activity from Language Skills or Exam Sections below.",

      "schreiben": {
        "title": "Schreiben",
        "subtitle": "Written Expression",
        "selectExercise": "Choose an exercise",
        "selectTask": "Choose a task",
        "words": "words",
        "points": "points",
        "minutes": "min",
        "instructions": "Instructions",
        "loading": "Loading writing training data...",
        "errorNoData": "No writing training files available for this exam level yet.",
        "errorLoadFailed": "The selected writing file could not be loaded.",
        "probeLabel": "Test",
        "previousProbe": "Previous test",
        "nextProbe": "Next test",
        "freeProbeOnly": "Only Test 1 is available on Free plan. Upgrade to unlock all writing tests.",
        "partLabel": "Part",
        "partsLabel": "parts",
        "startPart": "Start training",
        "chooseTopic": "Choose one topic first",
        "chooseTopicHint": "This part contains multiple topic options. Select one and start writing with guided structure blocks.",
        "topicLabel": "Topic",
        "startThisTopic": "Start this topic",
        "chooseAnotherTopic": "Choose another topic",
        "examPrompt": "Exam prompt",
        "guidingPoints": "Guiding points",
        "structureBuilder": "Structured writing builder",
        "structureBuilderTitle": "Write step by step with helper labels",
        "structureBuilderHint": "Each block has context-aware Redemittel. Open a block helper to copy phrase ideas and keep your text structured.",
        "showRedemittel": "Show Redemittel",
        "hideRedemittel": "Hide Redemittel",
        "loadingRedemittel": "Loading Redemittel...",
        "noMatchingRedemittel": "No matching Redemittel available for this block yet.",
        "livePreview": "Live draft preview",
        "wordCountLabel": "Word count",
        "emptyDraftHint": "Start filling the blocks above to build your draft.",
        "contentPointLabel": "Content point",
        "contentPointPlaceholderPrefix": "Address this point:",
        "defaultContentPointHint": "Cover this required content point clearly.",
        "defaultContentPointPlaceholder": "Write this required point...",
        "wordGoalDetailed": "Detailed response expected",
        "wordGoalMin": "At least {{count}} words",
        "wordGoalTarget": "Around {{count}} words",
        "wordGoalRange": "{{min}}-{{max}} words",
        "aiCorrection": "Logami's AI Correction",
        "aiCorrectionResult": "Logami's AI Correction",
        "correctionPending": "Correction pending...",
        "correctionAvailable": "Correction available",
        "correctionInProgress": "Logami's AI is analysing your text...",
        "correctionInProgressHint": "Evaluating vocabulary, grammar, coherence and style against exam criteria.",
        "correctionFailed": "Logami's AI correction failed. Please try again.",
        "submitForCorrection": "Submit for Logami's AI Correction",
        "writeLonger": "Write at least 20 words to submit",
        "resubmit": "Re-submit for Logami's AI correction",
        "retry": "Retry",
        "locked": "Premium required",
        "placeholder": "Writing editor coming soon"
      },

  // === VOCABULARY PAGE - COMPLETE TRANSLATIONS ===

      // Page Title & Navigation
      "vocabulary.title": "Vocabulary",
      "vocabulary.backButton": "Back",

      // Loading & Error States
      "vocabulary.loading": "Loading vocabulary...",
      "vocabulary.error": "Error loading",
      "vocabulary.noData": "No data available",

      // SessionStats Component
      "vocabulary.session.completed": "Session completed!",
      "vocabulary.session.cardsStudied": "Cards studied",
      "vocabulary.session.successRate": "Success rate",
      "vocabulary.session.again": "Again:",
      "vocabulary.session.hard": "Hard:",
      "vocabulary.session.good": "Good:",
      "vocabulary.session.easy": "Easy:",
      "vocabulary.session.continueStudying": "Continue studying",

      // DeckEditor Component
      "vocabulary.deck.deckName": "Deck name",
      "vocabulary.deck.icon": "Icon",
      "vocabulary.deck.cards": "Cards",
      "vocabulary.deck.create": "Create new deck",
      "vocabulary.deck.edit": "Edit deck",
      "vocabulary.deck.save": "Save",
      "vocabulary.deck.cancel": "Cancel",

      // Card Editor Fields
      "vocabulary.card.front": "Front (German)",
      "vocabulary.card.frontPlaceholder": "e.g. der Tisch",
      "vocabulary.card.back": "Back (Translation)",
      "vocabulary.card.backPlaceholder": "e.g. table",
      "vocabulary.card.examples": "Examples",
      "vocabulary.card.germanExample": "German example sentence",
      "vocabulary.card.englishTranslation": "English translation",
      "vocabulary.card.addExample": "Add example",
      "vocabulary.card.addCard": "Add card",
      "vocabulary.card.removeCard": "Remove card",

      // VocabularyCard Component
      "vocabulary.card.tapForTranslation": "Tap for translation",
      "vocabulary.card.noExamples": "No examples available",
      "vocabulary.card.showAnswer": "Show answer",
      "vocabulary.card.hideAnswer": "Hide answer",

      // Study Session Interface
      "vocabulary.study.start": "Start studying",
      "vocabulary.study.continue": "Continue learning",
      "vocabulary.study.pause": "Pause",
      "vocabulary.study.stop": "Stop",
      "vocabulary.study.restart": "Restart",
      "vocabulary.study.finished": "Done for today!",
      "vocabulary.study.nextCard": "Next card",
      "vocabulary.study.previousCard": "Previous card",
      "vocabulary.study.remainingCards": "Remaining cards",

      // SRS Rating Buttons
      "vocabulary.rating.again": "Again",
      "vocabulary.rating.hard": "Hard",
      "vocabulary.rating.good": "Good",
      "vocabulary.rating.easy": "Easy",
      "vocabulary.rating.againDesc": "< 1 min",
      "vocabulary.rating.hardDesc": "< 6 min",
      "vocabulary.rating.goodDesc": "< 10 min",
      "vocabulary.rating.easyDesc": "4 days",

      // Level Selection
      "vocabulary.level.select": "Select level",
      "vocabulary.level.beginner": "Beginner",
      "vocabulary.level.intermediate": "Intermediate",
      "vocabulary.level.advanced": "Advanced",
      "vocabulary.level.b1": "B1 - Intermediate I",
      "vocabulary.level.b2": "B2 - Intermediate II",
      "vocabulary.level.c1": "C1 - Advanced I",
      "vocabulary.level.c2": "C2 - Advanced II",

      // Categories & Topics
      "vocabulary.category.all": "All categories",
      "vocabulary.category.recent": "Recently learned",
      "vocabulary.category.favorites": "Favorites",
      "vocabulary.category.difficult": "Difficult words",
      "vocabulary.category.mastered": "Mastered",
      "vocabulary.category.new": "New words",

      // Progress & Statistics
      "vocabulary.stats.totalWords": "Total words",
      "vocabulary.stats.learned": "Learned",
      "vocabulary.stats.mastered": "Mastered",
      "vocabulary.stats.newToday": "New today",
      "vocabulary.stats.reviewToday": "Review today",
      "vocabulary.stats.accuracy": "Accuracy",
      "vocabulary.stats.streak": "Streak",
      "vocabulary.stats.timeSpent": "Time spent",
      "vocabulary.stats.sessionsCompleted": "Sessions completed",

      // Deck Management
      "vocabulary.deck.createNew": "Create new deck",
      "vocabulary.deck.import": "Import deck",
      "vocabulary.deck.export": "Export deck",
      "vocabulary.deck.share": "Share deck",
      "vocabulary.deck.delete": "Delete deck",
      "vocabulary.deck.duplicate": "Duplicate deck",
      "vocabulary.deck.rename": "Rename deck",

      // Confirmation Dialogs
      "vocabulary.confirm.deleteCard": "Really delete card?",
      "vocabulary.confirm.deleteDeck": "Really delete deck?",
      "vocabulary.confirm.resetProgress": "Reset progress?",
      "vocabulary.confirm.yes": "Yes",
      "vocabulary.confirm.no": "No",

      // Notifications & Messages
      "vocabulary.message.cardAdded": "Card added",
      "vocabulary.message.cardDeleted": "Card deleted",
      "vocabulary.message.deckSaved": "Deck saved",
      "vocabulary.message.sessionComplete": "Session completed!",
      "vocabulary.message.noMoreCards": "No more cards for today",
      "vocabulary.message.wellDone": "Well done!",
      "vocabulary.message.keepPracticing": "Keep practicing!",

      // Settings & Options
      "vocabulary.settings.autoPlay": "Auto-play audio",
      "vocabulary.settings.showTimer": "Show timer",
      "vocabulary.settings.newCardsPerDay": "New cards per day",
      "vocabulary.settings.reviewLimit": "Review limit",
      "vocabulary.settings.cardOrder": "Card order",
      "vocabulary.settings.random": "Random",
      "vocabulary.settings.chronological": "Chronological",

      // Import/Export
      "vocabulary.import.selectFile": "Select file",
      "vocabulary.import.uploading": "Uploading...",
      "vocabulary.import.success": "Successfully imported",
      "vocabulary.import.error": "Import error",
      "vocabulary.export.downloading": "Downloading...",
      "vocabulary.export.success": "Successfully exported",
      "vocabulary.trainer": "Vocabulary Trainer",

      // Search & Filter
      "vocabulary.search.placeholder": "Search words...",
      "vocabulary.filter.all": "All",
      "vocabulary.filter.learning": "Learning",
      "vocabulary.filter.review": "Review",
      "vocabulary.filter.mastered": "Mastered",
      "vocabulary.filter.difficult": "Difficult",

    "vocabulary.level.selectYourLevel": "Choose your level",
      "vocabulary.topic.selectTopic": "Choose a topic",
    "vocabulary.level.current": "Level",
      "vocabulary.deck.createCustom": "Create custom deck",
    "vocabulary.deck.custom": "Custom deck",
    "vocabulary.topic.selectSubtopic": "Choose a subtopic",

    "vocabulary.card.tapToFlip": "Tap to flip",
      // === PROFILE PAGE TRANSLATIONS ===

      // Page Headers
      "profile.title": "Profile",
      "profile.subtitle": "Manage your profile and track your progress.",

      // User Profile Section
      "profile.unknown": "Unknown",
      "profile.memberSince": "Member since",
      "profile.editProfile": "Edit profile",
      "profile.emailVerification.verified": "Email verified",
      "profile.emailVerification.unverified": "Email not verified",
      "profile.emailVerification.verifiedShort": "Verified",
      "profile.emailVerification.unverifiedShort": "Not verified",
      "profile.emailVerification.modal.title": "Verify your email",
      "profile.emailVerification.modal.subtitle": "Protect your account",
      "profile.emailVerification.modal.description": "Please verify {{email}} to secure your account and avoid upgrade/payment issues later.",
      "profile.emailVerification.modal.sendButton": "Send verification email",
      "profile.emailVerification.modal.sending": "Sending...",
      "profile.emailVerification.modal.refreshButton": "I've verified",
      "profile.emailVerification.modal.refreshing": "Checking...",
      "profile.emailVerification.modal.sent": "Verification email sent. Check inbox and spam.",
      "profile.emailVerification.modal.verified": "Email verified successfully.",
      "profile.emailVerification.modal.errorSend": "Could not send verification email. Please try again.",
      "profile.emailVerification.modal.errorNotVerifiedYet": "Email is not verified yet. Please check your inbox and spam folder.",
      "profile.emailVerification.modal.errorRefresh": "Could not refresh verification status. Please try again.",
      "profile.emailVerification.modal.close": "Close verification dialog",

      // Admin Section
      "profile.admin.rights": "You have administrator rights for this application.",
      "profile.admin.openDashboard": "Open admin dashboard",

      // Statistics
      "profile.stats.title": "Your Statistics",
      "profile.stats.completedExercises": "Completed Exercises",
      "profile.stats.averageGrade": "Average Grade",
      "profile.stats.totalStudyTime": "Total Study Time",
      "profile.stats.longestStreak": "Longest Streak",
      "profile.stats.hours": "Hrs",
      "profile.stats.days": "Days",

      // Activities
      "profile.activities.title": "Recent Activities",
      "profile.activities.unknown": "Unknown Activity",
      "profile.activities.general": "General",
      "profile.activities.passed": "Passed",
      "profile.activities.failed": "Failed",
      "profile.activities.completed": "Completed",
      "profile.activities.inProgress": "In Progress",
      "profile.activities.daysAgo": "{{count}} days ago",
      "profile.activities.recently": "Recently",
      "profile.activities.noActivities": "No activities yet",
      "profile.activities.startFirst": "Start your first exercise",
      "profile.activities.readyToLearn": "Ready to learn!",
      "profile.activities.now": "Now",
       // Header


      // Profile Tab
      "settings.profile.editTitle": "Edit Profile",
      "settings.profile.avatar": "Profile Picture",
      "settings.profile.changeAvatar": "Change profile picture",
      "settings.profile.avatarRequirements": "JPG, PNG or GIF (max. 5MB)",

      "settings.profile.emailAddress": "Email Address",


      // Account Tab
      "settings.account.infoTitle": "Account Information",

      "settings.account.yes": "Yes",
      "settings.account.no": "No",

      "settings.account.confirmNewPassword": "Confirm New Password",



      "settings.notifications.exercises.title": "Exercise Notifications",
      "settings.notifications.exercises.desc": "Get notified about new exercises and progress",
      "settings.notifications.reminders.title": "Study Reminders",
      "settings.notifications.reminders.desc": "Daily reminders to keep learning",
      "settings.notifications.emails.title": "Email Notifications",
      "settings.notifications.emails.desc": "Important updates and announcements by email",
      "settings.notifications.progress.title": "Progress Reports",
      "settings.notifications.progress.desc": "Weekly summaries of your learning progress",
      "settings.notifications.schedule.title": "Schedule",
      "settings.notifications.schedule.preferredTime": "Preferred time for reminders",
      "settings.notifications.schedule.timeZone": "Time Zone",

      // Timezones
      "settings.timezones.berlin": "Europe/Berlin",
      "settings.timezones.vienna": "Europe/Vienna",
      "settings.timezones.zurich": "Europe/Zurich",

      // Alerts & Status Messages
      "settings.alerts.selectImageFile": "Please select an image file.",
      "settings.alerts.passwordsMismatch": "Passwords do not match.",
      "settings.alerts.passwordTooShort": "Password must be at least 6 characters long.",
      "settings.alerts.wrongPassword": "Current password is incorrect.",

      // Status Messages
      "settings.status.avatarSuccess": "Avatar updated successfully!",
      "settings.status.profileUpdating": "Updating profile...",
      "settings.status.profileSuccess": "Profile updated successfully!",
      "settings.status.profileError": "Error updating profile.",
      "settings.status.passwordChanging": "Changing password...",
      "settings.status.passwordSuccess": "Password changed successfully!",
      "settings.status.passwordError": "Error changing password.",
      "settings.status.dataExportSuccess": "Data exported successfully!",
      "settings.status.dataExportError": "Error exporting data.",
      "settings.status.notificationSuccess": "Notification settings saved!",

      // Buttons & Actions
      "button.saveChanges": "Save Changes",
      "button.saving": "Saving...",
      "settings.account.notSet": "Not set",
    "lesson.facts.points": "Points",
"lesson.facts.time": "Time",
"lesson.facts.method": "Method",
"lesson.practice.answer": "Answer:",
"lesson.practice.audioTranscript": "Audio transcript:",
"lesson.practice.correctAnswers": "Correct answers:",
"lesson.step.example": "Example:",
"lesson.header.steps": "Steps",
      "lesson.header.step": "Step",
"lesson.step.completed": "Completed",
"lesson.step.markDone": "Mark as done",
"lesson.loader.loading": "Loading lesson strategies...",
"lesson.error.title": "Lesson content not found",
"lesson.error.description": "There was a problem loading the lesson.",
"lesson.error.instruction": "Please go back to your study plan and try again.",
"lesson.error.backButton": "Back to study plan",
"lesson.hero.subtitle": "Master the strategies and techniques you need to excel in this part of the exam",
"lesson.hero.progress": "Your progress",
      // Grammar Module Translations
"grammar.title": "Grammar Workshop",
"grammar.subtitle": "Master German grammar systematically",
"grammar.back": "Back",
// Level Selection
"grammar.levels.title": "Choose your level",
"grammar.levels.a2": "A2 – Elementary",
"grammar.levels.b1": "B1 – Lower-Intermediate",
"grammar.levels.b2": "B2 – Upper-Intermediate",
"grammar.levels.c1": "C1 – Advanced",
"grammar.levels.description.a2": "Basic grammar structures",
"grammar.levels.description.b1": "Extended structures and sentence linking",
"grammar.levels.description.b2": "Complex grammar and stylistic variation",
"grammar.levels.description.c1": "Subtleties and academic structures",
"grammar.levels.available": "Available",
"grammar.levels.comingSoon": "Coming soon",
"grammar.levels.locked": "Locked",
"c": "Exercises for this topic. Lesson coming soon!",
"grammar.pillars.noTopics": "No grammar topics available for level {{level}}.",
"grammar.pillars.checkData": "Make sure the lesson and exercise files are available.",
"grammar.summary.title": "Level Summary",
"grammar.summary.connectedTopics": "Connected topics",
"grammar.summary.withLessons": "With lessons",
"grammar.summary.withPractice": "With exercises",
"grammar.backToPath": "Back to learning path",
"grammar.stats.performance": "Performance",
        "comingSoon.badge": "Coming Soon",
"comingSoon.whatToExpect": "What to Expect",
"comingSoon.timeline.title": "Launch Timeline",
"comingSoon.timeline.description": "We're working hard to bring you this feature. Stay tuned for updates on our launch date!",
"comingSoon.notify.title": "Get Notified",
"comingSoon.notify.description": "Be the first to know when this feature goes live. Enter your email below.",
"comingSoon.notify.placeholder": "Enter your email",
"comingSoon.notify.button": "Notify Me",
"comingSoon.notify.success": "Thanks! We'll notify you when this feature launches.",
"comingSoon.otherFeatures": "Other Upcoming Features",
"comingSoon.meanwhile.title": "In the Meanwhile",
"comingSoon.meanwhile.description": "Continue improving your skills with our currently available features",
"comingSoon.meanwhile.practiceButton": "Go to Practice",
"comingSoon.meanwhile.dashboardButton": "Back to Dashboard",

// Feature Descriptions
"comingSoon.features.learningPath.title": "Learning Path",
"comingSoon.features.learningPath.description": "Structured lessons that take you from basics to exam mastery with personalized learning paths.",
"comingSoon.features.learningPath.benefit1": "Progressive curriculum designed by exam experts",
"comingSoon.features.learningPath.benefit2": "Interactive lessons with instant feedback",
"comingSoon.features.learningPath.benefit3": "Track your progress through each learning module",

"comingSoon.features.examSimulator.title": "Exam Simulator",
"comingSoon.features.examSimulator.description": "Practice under real exam conditions with full-length simulations and detailed performance analytics.",
"comingSoon.features.examSimulator.benefit1": "Authentic exam format and timing",
"comingSoon.features.examSimulator.benefit2": "Comprehensive scoring and feedback",
"comingSoon.features.examSimulator.benefit3": "Identify weak areas before the real exam",

"comingSoon.features.writingLab.title": "Writing Lab",
"comingSoon.features.writingLab.description": "Logami's AI writing practice with detailed feedback on grammar, structure, and style.",
"comingSoon.features.writingLab.benefit1": "Logami's AI writing assistant with instant feedback",
"comingSoon.features.writingLab.benefit2": "Practice all exam writing tasks",
"comingSoon.features.writingLab.benefit3": "Improve vocabulary and grammar in context",

"comingSoon.features.studyPlan.title": "Personalized Study Plan",
"comingSoon.features.studyPlan.description": "Logami's AI study plans tailored to your exam date, current level, and learning goals.",
"comingSoon.features.studyPlan.benefit1": "Custom schedule based on your availability",
"comingSoon.features.studyPlan.benefit2": "Adaptive plan that adjusts to your progress",
"comingSoon.features.studyPlan.benefit3": "Daily tasks to keep you on track",
// Pillar View
"grammar.pillars.title": "{{level}} Grammar Lessons",
"grammar.pillars.exercises": "{{count}} exercises",
"grammar.pillars.duration": "{{time}} min",
"grammar.pillars.difficulty": "Difficulty",
"grammar.pillars.progress": "Progress",
"grammar.pillars.completed": "Completed",
"grammar.pillars.mastered": "Mastered",
"grammar.pillars.startPractice": "Start practice",
"grammar.pillars.continuePractice": "Continue practice",
"grammar.pillars.reviewMistakes": "Review mistakes",
"grammar.pillars.linkedLesson": "Go to lesson",
// Exercise View
"grammar.exercise.title": "Exercise {{current}} of {{total}}",
"grammar.exercise.instruction": "Instruction",
"grammar.exercise.yourAnswer": "Your answer",
"grammar.exercise.submit": "Check answer",
"grammar.exercise.next": "Next exercise",
"grammar.exercise.skip": "Skip",
"grammar.exercise.showHint": "Show hint",
"grammar.exercise.correct": "Correct!",
"grammar.exercise.incorrect": "Not quite right",
"grammar.exercise.tryAgain": "Try again",
"grammar.exercise.showSolution": "Show solution",
"grammar.exercise.correctAnswer": "Correct answer",
// Progress Tracker
"grammar.progress.title": "Your progress",
"grammar.progress.overall": "Overall progress",
"grammar.progress.currentLevel": "Current level",
"grammar.progress.exercisesCompleted": "Exercises completed",
"grammar.progress.mistakesToReview": "Mistakes to review",
"grammar.progress.streak": "Learning streak",
"grammar.progress.lastSession": "Last session",
"grammar.progress.timeSpent": "Time spent",
"grammar.progress.accuracy": "Accuracy",
"grammar.progress.continueFromLast": "Continue from last position",
"grammar.progress.startNew": "Start fresh",
// Mistake Review
"grammar.mistakes.title": "Mistake Review",
"grammar.mistakes.noMistakes": "No mistakes to review!",
"grammar.mistakes.reviewAll": "Review all mistakes",
"grammar.mistakes.reviewByTopic": "Review by topic",
"grammar.mistakes.clearMistakes": "Clear mistakes",
"grammar.mistakes.mistakeCount": "mistake(s)",
"grammar.mistakes.lastMistake": "Last mistake",
// Settings & Preferences
"grammar.settings.title": "Settings",
"grammar.settings.autoSave": "Auto-save progress",
"grammar.settings.showTimer": "Show timer",
"grammar.settings.showHints": "Enable hints",
"grammar.settings.mistakeLimit": "Max stored mistakes",
"grammar.settings.resetProgress": "Reset progress",
"grammar.settings.confirmReset": "Really reset?",
// Statistics
"grammar.stats.totalExercises": "Total exercises",
"grammar.stats.correctAnswers": "Correct answers",
"grammar.stats.incorrectAnswers": "Incorrect answers",
"grammar.stats.averageTime": "Average time",
"grammar.stats.bestStreak": "Best streak",
"grammar.stats.weakAreas": "Weak areas",
// Connection Messages
"grammar.connection.lessonAvailable": "Lesson available",
"grammar.connection.practiceLinked": "Linked to practice",
"grammar.connection.goToLesson": "Go to lesson",
"grammar.connection.goToPractice": "Go to practice",
"grammar.connection.unlockWithLesson": "Unlock with lesson",
"grammar.connection.connected": "Connected",
"grammar.connection.lessons": "Lessons",
"grammar.connection.practice": "Practice",
// Topics Counter
"grammar.topicsAvailable": "{{count}} topics available",
// Grammar Hub Features
"grammar.hub.featuresTitle": "Grammar Workshop Features",
"grammar.hub.connectedDesc": "<1>Connected:</1> study the lesson, then practise",
"grammar.hub.lessonOnlyDesc": "<1>Lesson only:</1> theory and examples",
"grammar.hub.practiceOnlyDesc": "<1>Practice only:</1> exercises available",
// Mistakes Label
"grammar.mistakes.label": "Mistakes",
// Connection Info Tooltips
"grammar.connection.info.connected": "Lesson and exercise available",
"grammar.connection.info.lessonOnly": "Theory and examples only",
"grammar.connection.info.practiceOnly": "Practice tasks only",
// Mistake Review
"grammar.mistakes.reviewed": "Reviewed",
"grammar.mistakes.review": "Review",
// Loading & Error Messages
"grammar.loading": "Loading {{level}} grammar content...",
"grammar.error.title": "Grammar data unavailable",
"grammar.error.message": "The {{level}} grammar content could not be loaded.",
// Default Title & Description
"grammar.defaultTitle": "Interactive {{level}} Grammar Master Course",
"grammar.defaultDescription": "Your complete, interactive path to {{level}} grammar confidence for the exam.",
"grammar.progress.continue": "Continue",
      "grammar.progress.tabs.overview": "Overview",
  "grammar.progress.tabs.mistakes": "Mistakes",
  "grammar.progress.tabs.statistics": "Statistics",
  "grammar.connection.lessonOnly": "Lesson Only",
  "grammar.connection.practiceOnly": "Practice Only",
       "grammar.exercise.bookmark": "Bookmark question",
  "grammar.exercise.removeBookmark": "Remove bookmark",
  "grammar.progress.tabs.bookmarks": "Bookmarks",
  "grammar.bookmarks.title": "Bookmarked Questions",
  "grammar.bookmarks.noBookmarks": "You haven't bookmarked any questions yet.",
  "grammar.bookmarks.review": "Review Question",

      "vocabulary.guide.title": "Vocabulary Learning Guide",
  "vocabulary.guide.subtitle": "Master German vocabulary with our intelligent spaced repetition system",

  // Navigation
  "vocabulary.guide.previous": "Previous",
  "vocabulary.guide.next": "Next",
  "vocabulary.guide.startPracticing": "Start Practicing",
  "vocabulary.guide.dontShowAgain": "Don't show this guide again",

  // Welcome step
  "vocabulary.guide.welcome.title": "Welcome to Smart Vocabulary Learning!",
  "vocabulary.guide.welcome.description": "Learn German vocabulary efficiently with our scientifically-proven spaced repetition system. We'll show you exactly when to review each word for maximum retention.",
  "vocabulary.guide.welcome.ready": "Ready to become a vocabulary master?",
  "vocabulary.guide.welcome.subtitle": "Let's take a quick interactive tour!",

  // Card basics step
  "vocabulary.guide.cardBasics.title": "How Vocabulary Cards Work",
  "vocabulary.guide.cardBasics.description": "Each card shows a German word on the front and its translation on the back. Click or tap to flip the card and see the answer, along with example sentences.",

  // Rating system step
  "vocabulary.guide.ratingSystem.title": "Rate Your Knowledge",
  "vocabulary.guide.ratingSystem.description": "After seeing the answer, rate how well you knew the word. Your rating determines when you'll see this card again - this is the magic of spaced repetition!",
  "vocabulary.guide.rateThis": "How well did you know this word?",

  // SRS explanation step
  "vocabulary.guide.srsExplanation.title": "The Science Behind Spaced Repetition",
  "vocabulary.guide.srsExplanation.description": "Based on your rating, cards return at scientifically optimized intervals. Hard words appear sooner, easy words appear later. This maximizes your learning efficiency!",

  // Timeline
  "vocabulary.guide.timeline.title": "Your Review Schedule",
  "vocabulary.guide.timeline.description": "Watch how your rating affects when you'll see this word again",

  // Practice tip step
  "vocabulary.guide.practiceTip.title": "Pro Learning Tips",
  "vocabulary.guide.practiceTip.description": "Study consistently for best results! Even 10 minutes daily is better than cramming. Focus on understanding, not just memorizing.",

  // Tips
  "vocabulary.guide.tip.title": "🎯 Success Tip",
  "vocabulary.guide.tip.description": "Be honest with your ratings! The system works best when you accurately assess your knowledge. Don't worry about getting words wrong - that's how you learn!",

  // Rating explanations (enhanced)
  "vocabulary.guide.rating.again.explanation": "You forgot this word completely. It will return in 1 minute for immediate review.",
  "vocabulary.guide.rating.hard.explanation": "You knew it but struggled. It will return in 6 minutes for reinforcement.",
  "vocabulary.guide.rating.good.explanation": "You knew it well! It will return in 10 minutes, then graduate to longer intervals.",
  "vocabulary.guide.rating.easy.explanation": "Too easy! This word will return in 4 days, jumping ahead in the schedule.",

  // Additional helpful messages
  "vocabulary.guide.importance.title": "Why This Matters",
  "vocabulary.guide.importance.description": "Studies show spaced repetition can improve retention by up to 200% compared to traditional study methods. You're using the most effective learning technique available!",

  "vocabulary.guide.examples.title": "Learn Through Examples",
  "vocabulary.guide.examples.description": "Pay attention to the example sentences - they show you how words are used in real German. This context helps you remember and use vocabulary naturally.",
  "vocabulary.guide.help": "Help",
  "vocabulary.guide.showGuide": "Show learning guide",
  "vocabulary.guide.watchTutorial": "Watch tutorial",

  // First-time user messages
  "vocabulary.guide.firstTimeHint": "New to vocabulary learning? Click any category to get started with our interactive guide!",
  "vocabulary.guide.newUserTip.title": "🎯 First time here?",
  "vocabulary.guide.newUserTip.description": "Our interactive guide will show you exactly how to use the spaced repetition system for maximum learning efficiency. It takes just 2 minutes!",
 "vocabulary.deck.subtopics_one": "{{count}} subtopic",
  "vocabulary.deck.subtopics_other": "{{count}} subtopics",
  // Enhanced descriptions for better UX
  "vocabulary.guide.buttonExplanations.title": "Understanding the Rating Buttons",
  "vocabulary.guide.buttonExplanations.description": "Each button affects when you'll see this word again. Be honest with your ratings for optimal learning!",

  // Examples section
  "vocabulary.guide.examples.importance": "💡 Pay attention to example sentences - they show you how words are used in real German conversations!",
  "vocabulary.guide.examples.context": "Context is key to remembering vocabulary naturally.",

  // Progress motivation
  "vocabulary.guide.progress.title": "Track Your Progress",
  "vocabulary.guide.progress.description": "Watch your vocabulary grow! The system tracks your learning and shows you exactly what needs review.",

  // Learning science
  "vocabulary.guide.science.title": "Why Spaced Repetition Works",
  "vocabulary.guide.science.description": "This method is based on the 'forgetting curve' - reviewing words just before you forget them strengthens long-term memory.",

  // Success tips
  "vocabulary.guide.success.consistency": "Study a little every day rather than cramming",
  "vocabulary.guide.success.honesty": "Be honest with your ratings - the system learns your patterns",
  "vocabulary.guide.success.examples": "Read example sentences out loud to practice pronunciation",
  "vocabulary.guide.success.patience": "Trust the process - some words take time to stick",
      // Demo card translations
  "vocabulary.guide.demo.translation": "the dog",
  "vocabulary.guide.demo.exampleTranslation": "The dog barks loudly.",
      "vocabulary.guide.clickToFlip": "Click to flip",
      "vocabulary.guide.timeline.firstTry": "First try",
"vocabulary.guide.timeline.after1Day": "After 1 day",
"vocabulary.guide.timeline.after3Days": "After 3 days",
"vocabulary.guide.timeline.after10Days": "After 10 days",
"vocabulary.guide.timeline.after15Days": "After 15 days",
"vocabulary.guide.timeline.nextReview1Day": "Next review: 1 day",
"vocabulary.guide.timeline.nextReview3Days": "Next review: ~3 days",
"vocabulary.guide.timeline.nextReview10Days": "Next review: ~10 days (Easy bonus!)",
"vocabulary.guide.timeline.nextReview15Days": "Next review: ~15 days (Small increase)",
"vocabulary.guide.timeline.nextReview1Min": "Next review: 1 min (Lapse penalty!)",
      "vocabulary.deck.noCardsDue": "No cards due! Next card in {{hours}}h {{minutes}}m.",
      "vocabulary.deck.allCardsLearned": "All cards learned! 🎉",
      "vocabulary.deck.noCardsInDeck": "This deck contains no cards.",
  "vocabulary.deck.cards_one": "{{count}} card",
  "vocabulary.deck.cards_other": "{{count}} cards",
  "vocabulary.flashcard.cardNumber": "Card {{number}}",
"vocabulary.deck.addAtLeastOneCard": "Please add at least one valid card.",
      "vocabulary.flashcard.flipToRateHint": "Flip card to rate",
        "grammar.renderer.seeInAction": "See {{title}} in Action",
"grammar.renderer.story.description": "Start with a short story to see how this grammar concept is used in a real conversation.",
"grammar.renderer.story.start": "Start Story",
"grammar.renderer.story.rerun": "Rerun Story",
"grammar.renderer.section.story": "Story in Action",
"grammar.renderer.section.importance": "Why This Matters",
"grammar.renderer.section.practice": "Practice Exercises",
"grammar.renderer.practice.description": "Test your understanding with these exercises.",
"grammar.content.rule": "Rule:",
"grammar.content.formationTable": "Formation Table",
"grammar.content.conjugation": "Conjugation",
"grammar.content.examplesAndCases": "Examples & Cases",
"grammar.content.usage": "Usage:",
"grammar.content.connectors": "Connectors:",
"grammar.content.articleTable": "Article Table",
"grammar.content.pronounTable": "Pronoun Table",
"grammar.content.notes": "Notes:",
"grammar.content.memoryTrick": "Memory Trick:",
"grammar.content.keyPoint": "Key Point:",
"grammar.content.corePrinciple": "Core Principle:",
"grammar.content.unknownSection": "Unknown section type",
        "grammar.content.advancedConnectors": "Advanced Two-Part Connectors",
"grammar.content.function": "Function",
"grammar.content.rhetoricalUse": "Rhetorical Use",
"grammar.content.emphasisTechniques": "Emphasis Techniques",
"grammar.content.effect": "Effect",
"grammar.content.basic": "Basic",
"grammar.content.advanced": "Advanced",
"grammar.content.analysis": "Analysis",
"grammar.content.dativeExamples": "Dative Examples (Wo? - Location)",
"grammar.content.accusativeExamples": "Accusative Examples (Wohin? - Direction)",
"grammar.content.active": "Active",
"grammar.content.passive": "Passive",
"grammar.content.structure": "Structure",
"grammar.content.priceExamples": "Price Examples",
"grammar.content.measurementExamples": "Measurement Examples",
"grammar.content.politenessLevels": "Levels of Politeness",
"grammar.content.note": "Note",
"grammar.content.prepositionMeanings": "Preposition Meanings",
"grammar.content.verbsWith": "Verbs with {{preposition}}",
"grammar.content.verbPairs": "Verb Pairs: Action vs. State",
"grammar.content.action": "ACTION (Wohin?)",
"grammar.content.state": "STATE (Wo?)",
"grammar.content.commonPrefixes": "Common Prefixes",
"grammar.content.conjunctionsDetail": "Conjunctions in Detail",
"grammar.content.passiveAlternatives": "Passive Alternatives - The Elegance Tools",
"grammar.content.insteadOf": "Instead of",
"grammar.content.conjunctionTypes": "Conjunction Types",
"grammar.content.registerMatrix": "Stylistic Register Matrix",
"grammar.content.context": "Context",
"grammar.content.modalParticles": "Modal Particles",
"grammar.content.nvv": "NVV (Functional Verbs)",
"grammar.content.prepositions": "Prepositions",
"grammar.content.overallTone": "Overall Tone",
"grammar.content.objectHierarchy": "Object Placement Hierarchy (TE-KA-MO-LO)",
"grammar.content.principle": "Principle",
"grammar.content.order": "Order",
"grammar.content.esFunctions": "The Three Functions of 'Es'",
"grammar.content.examples": "Examples",
"grammar.content.transformation": "Transformation",
"grammar.content.worCompounds": "WO(R)- Compounds (Relative Adverbs)",
"grammar.content.general": "General",
"grammar.content.formationPattern": "Formation Pattern",
"grammar.content.modalVerbForms": "Modal Verb Forms",
"grammar.content.spatialLogic": "Spatial Logic of Two-Way Prepositions",
"grammar.content.concept": "Concept",
"grammar.content.contactType": "Contact Type",
"grammar.content.caseFunction": "Case/Function",
"grammar.content.commonIrregulars": "Common Irregular Verbs",
"grammar.content.pattern": "Pattern",
"grammar.content.commonVerbsCase": "Common Verbs for this Case",
        "grammar.guide.title": "Grammar Learning Guide",
  "grammar.guide.subtitle": "Master German grammar with our interactive lesson and practice system",

  // Navigation
  "grammar.guide.previous": "Previous",
  "grammar.guide.next": "Next",
  "grammar.guide.startLearning": "Start Learning",
  "grammar.guide.dontShowAgain": "Don't show this guide again",
  "grammar.guide.help": "Help",
  "grammar.guide.showGuide": "Show learning guide",
    "comingSoon.features.redemittel.benefit1": "Master essential phrases for every exam situation",
"comingSoon.features.redemittel.benefit2": "Contextual examples and practice exercises",
"comingSoon.features.redemittel.benefit3": "Build natural fluency with common expressions",
  // Welcome step
  "grammar.guide.welcome.title": "Welcome to Interactive Grammar Learning!",
  "grammar.guide.welcome.description": "Learn German grammar efficiently with our structured lesson and practice system. We'll guide you through lessons, exercises, and smart progress tracking.",
  "grammar.guide.welcome.ready": "Ready to master grammar?",
  "grammar.guide.welcome.subtitle": "Let's take a quick tour!",

  // Lesson types step
  "grammar.guide.lessonTypes.title": "Three Types of Learning Paths",
  "grammar.guide.lessonTypes.description": "Our grammar workshop offers different learning experiences based on the topic:",
  "grammar.guide.lessonTypes.connected": "Connected: Study the lesson first, then practice with exercises",
  "grammar.guide.lessonTypes.lessonOnly": "Lesson Only: Pure theory and examples for understanding",
  "grammar.guide.lessonTypes.practiceOnly": "Practice Only: Jump straight into exercises",
  "grammar.guide.lessonTypes.tip": "Look for the connection badges on each topic card!",

  // Floating tab bar step
  "grammar.guide.floatingTab.title": "Your Progress Dashboard",
  "grammar.guide.floatingTab.description": "Access powerful learning tools anytime with the floating tab bar on the right side of your screen:",
  "grammar.guide.floatingTab.overview": "Overview: See your overall progress and continue learning",
  "grammar.guide.floatingTab.mistakes": "Mistakes: Review all incorrect answers grouped by topic",
  "grammar.guide.floatingTab.bookmarks": "Bookmarks: Access questions you've flagged for later",
  "grammar.guide.floatingTab.statistics": "Statistics: Track accuracy, time spent, and weak areas",
  "grammar.guide.floatingTab.mobile": "On mobile, tap any icon to open the full panel!",

  // Mistakes review step
  "grammar.guide.mistakes.title": "Smart Mistake Review",
  "grammar.guide.mistakes.description": "Every incorrect answer is automatically saved and organized by topic. This helps you focus on areas that need improvement.",
  "grammar.guide.mistakes.features": "Mistakes are grouped by grammar topic for easy review",
  "grammar.guide.mistakes.review": "Click any mistake to see the question again with the correct answer",
  "grammar.guide.mistakes.mark": "Mark mistakes as 'reviewed' to track your progress",
  "grammar.guide.mistakes.tip": "💡 Review your mistakes regularly - it's the fastest way to improve!",

  // Bookmarks step
  "grammar.guide.bookmarks.title": "Bookmark Challenging Questions",
  "grammar.guide.bookmarks.description": "Found a tricky question? Bookmark it for later review!",
  "grammar.guide.bookmarks.how": "Click the bookmark icon on any exercise question",
  "grammar.guide.bookmarks.access": "Access all bookmarked questions from the floating tab",
  "grammar.guide.bookmarks.remove": "Remove bookmarks when you've mastered the concept",
  "grammar.guide.bookmarks.tip": "Perfect for flagging questions you want to revisit before exams!",

  // Progress tracking step
  "grammar.guide.progress.title": "Track Your Progress",
  "grammar.guide.progress.description": "Stay motivated by watching your grammar skills grow!",
  "grammar.guide.progress.features": "Overall progress across all grammar topics",
  "grammar.guide.progress.stats": "Detailed statistics: accuracy rate, time spent, best streak",
  "grammar.guide.progress.weak": "Identify weak areas that need more practice",
  "grammar.guide.progress.continue": "Continue feature picks up where you left off",

  // Pro tips step
  "grammar.guide.tips.title": "Pro Learning Tips",
  "grammar.guide.tips.consistency": "📅 Practice daily - even 15 minutes helps!",
  "grammar.guide.tips.mistakes": "🎯 Review mistakes regularly - they show what needs focus",
  "grammar.guide.tips.bookmarks": "🔖 Bookmark challenging concepts for exam preparation",
  "grammar.guide.tips.lessons": "📚 Complete lessons before practice for better understanding",
  "grammar.guide.tips.statistics": "📊 Check statistics weekly to track improvement",

  // Success message
  "grammar.guide.success.title": "You're All Set!",
  "grammar.guide.success.description": "You now know how to use all the powerful features of the grammar workshop. Start with any topic that interests you!",
  "grammar.guide.success.reminder": "Remember: You can always access this guide again from the Help button.",

  // First-time user messages
  "grammar.guide.firstTimeHint": "New to grammar learning? Click the help button for a quick tour!",
  "grammar.guide.newUserTip.title": "🎯 First time here?",
  "grammar.guide.newUserTip.description": "Take our 2-minute interactive tour to learn how to use the grammar workshop effectively!",

        "grammar.reveal.sectionOf": "Section {{current}} of {{total}}",
"grammar.reveal.percentComplete": "{{percent}}% Complete",
"grammar.reveal.yourProgress": "Your Progress",
"grammar.reveal.sectionsComplete": "{{completed}} of {{total}} sections complete",
"vocabulary.card.hideTranslation": "Hide Translation",
        "grammar.exercise.sentenceBuilder.tapInstruction": "👆 Tap on words to build your sentence",
"grammar.exercise.sentenceBuilder.availableWords": "Available words:",
"grammar.exercise.sentenceBuilder.allWordsUsed": "All words have been used ✓",
"grammar.exercise.sentenceBuilder.shuffle": "Shuffle",


  "gamification.achievements.title": "Achievements",
"gamification.achievements.earned": "earned",
"gamification.achievements.progress": "Progress",
"gamification.achievements.unlocked": "Unlocked!",
"gamification.achievements.specialRequirement": "Special requirement",

// Unlock Modal
"gamification.achievements.modal.title": "Achievement Unlocked!",
"gamification.achievements.modal.button": "Awesome!",

// ==========================================
// CATEGORY NAMES
// ==========================================
"gamification.achievements.categories.vocabulary": "Vocabulary",
"gamification.achievements.categories.grammar": "Grammar",
"gamification.achievements.categories.review": "Reviews",
"gamification.achievements.categories.streak": "Streaks",

// ==========================================
// VOCABULARY ACHIEVEMENTS
// ==========================================
"gamification.achievements.vocabulary.wordStarter.name": "Word Starter",
"gamification.achievements.vocabulary.wordStarter.description": "Master 50 words",

"gamification.achievements.vocabulary.wordCollector.name": "Word Collector",
"gamification.achievements.vocabulary.wordCollector.description": "Master 100 words",

"gamification.achievements.vocabulary.wordScholar.name": "Word Scholar",
"gamification.achievements.vocabulary.wordScholar.description": "Master 500 words",

"gamification.achievements.vocabulary.wordMaster.name": "Word Master",
"gamification.achievements.vocabulary.wordMaster.description": "Master 1,000 words",

"gamification.achievements.vocabulary.wordLegend.name": "Word Legend",
"gamification.achievements.vocabulary.wordLegend.description": "Master 2,000 words",

// ==========================================
// GRAMMAR ACHIEVEMENTS
// ==========================================
"gamification.achievements.grammar.grammarNovice.name": "Grammar Novice",
"gamification.achievements.grammar.grammarNovice.description": "Complete your first grammar topic",

"gamification.achievements.grammar.caseChampion.name": "Case Champion",
"gamification.achievements.grammar.caseChampion.description": "Master all German cases with 80%+ accuracy",

"gamification.achievements.grammar.tenseMaster.name": "Tense Master",
"gamification.achievements.grammar.tenseMaster.description": "Master all tenses with 80%+ accuracy",

"gamification.achievements.grammar.grammarGuru.name": "Grammar Guru",
"gamification.achievements.grammar.grammarGuru.description": "Achieve 90%+ mastery across all grammar topics",

// ==========================================
// REVIEW ACHIEVEMENTS
// ==========================================
"gamification.achievements.review.reviewRookie.name": "Review Rookie",
"gamification.achievements.review.reviewRookie.description": "Complete 50 review sessions",

"gamification.achievements.review.reviewRegular.name": "Review Regular",
"gamification.achievements.review.reviewRegular.description": "Complete 200 review sessions",

"gamification.achievements.review.reviewChampion.name": "Review Champion",
"gamification.achievements.review.reviewChampion.description": "Complete 1,000 review sessions",

"gamification.achievements.streak.gettingStarted.name": "Getting Started",
"gamification.achievements.streak.gettingStarted.description": "Maintain a 3-day streak",

"gamification.achievements.streak.weekWarrior.name": "Week Warrior",
"gamification.achievements.streak.weekWarrior.description": "Maintain a 7-day streak",

"gamification.achievements.streak.twoWeekChampion.name": "Two Week Champion",
"gamification.achievements.streak.twoWeekChampion.description": "Maintain a 14-day streak",

"gamification.achievements.streak.monthlyMaster.name": "Monthly Master",
"gamification.achievements.streak.monthlyMaster.description": "Maintain a 30-day streak",

"gamification.achievements.streak.centuryClub.name": "Century Club",
"gamification.achievements.streak.centuryClub.description": "Maintain a 100-day streak",

"gamification.achievements.streak.yearLegend.name": "Year Legend",
"gamification.achievements.streak.yearLegend.description": "Maintain a 365-day streak",
        // ==========================================
// ACTION ZONE - ENGLISH TRANSLATIONS
// Add these to your en: { translation: { ... } } object in src/i18n/index.js
// ==========================================

// Section Header
"dashboard.actionZone.title": "What to Study Next",
"dashboard.actionZone.cardCounter": "{{current}} of {{total}}",

// Accessibility Labels
"dashboard.actionZone.previousRecommendation": "Previous recommendation",
"dashboard.actionZone.nextRecommendation": "Next recommendation",
"dashboard.actionZone.goToRecommendation": "Go to recommendation {{number}}",

// Urgency Badge Labels
"dashboard.actionZone.urgency.urgent": "Urgent",
"dashboard.actionZone.urgency.important": "Important",
"dashboard.actionZone.urgency.continue": "Continue",
"dashboard.actionZone.urgency.achievement": "Achievement",
"dashboard.actionZone.urgency.welcomeBack": "Welcome Back",

// Time Estimate
"dashboard.actionZone.timeEstimate": "{{time}} min",

// Action Button
"dashboard.actionZone.startNow": "Start Now",

// ==========================================
// RECOMMENDATION TYPES
// ==========================================

// 1. Critical - Due Reviews
"dashboard.actionZone.dueReview.title": "Review {{count}} Words Due Today",
"dashboard.actionZone.dueReview.description": "Keep your vocabulary fresh! These words need review based on spaced repetition.",

// 2. Continue Grammar Lesson
"dashboard.actionZone.continueGrammar.title": "Continue: {{topicName}}",
"dashboard.actionZone.continueGrammar.description": "Pick up where you left off in your {{level}} grammar lesson{{exerciseInfo}}.",
"dashboard.actionZone.continueGrammar.exerciseInfo": " (Exercise {{number}})",

// 3. Weak Grammar Areas
"dashboard.actionZone.weakArea.title": "Practice: {{topicName}}",
"dashboard.actionZone.weakArea.description": "Your accuracy is below 70%. Let's strengthen this topic!",

// 4. Milestone - Close to Achievement
"dashboard.actionZone.milestone.title": "{{remaining}} More to {{name}}!",
"dashboard.actionZone.milestone.description": "You're so close! Complete {{remaining}} more {{type}} to unlock this achievement.",

// 5. Comeback - After Absence
"dashboard.actionZone.comeback.title": "Welcome Back! Easy Review",
"dashboard.actionZone.comeback.description": "Let's ease back in with a quick review of what you've learned.",

// 6. Normal - Continue Learning
"dashboard.actionZone.dailyGoal.title": "{{remaining}} Sessions to Daily Goal",
"dashboard.actionZone.dailyGoal.title_plural": "{{remaining}} Session to Daily Goal",
"dashboard.actionZone.dailyGoal.description": "Keep your learning streak going! Practice vocabulary or grammar.",

// 7. Fallback - All Caught Up
"dashboard.actionZone.allCaughtUp.title": "Great Job! All Caught Up",
"dashboard.actionZone.allCaughtUp.description": "You've completed your daily goal. Keep practicing to maintain your streak!",

// Fallback for topic names
"dashboard.actionZone.fallbackTopic": "Grammar Topic",
        "dashboard.calendarHeatmap.title": "30-Day Activity",
"dashboard.calendarHeatmap.activeDays": "{{count}} active days",
"dashboard.calendarHeatmap.activeDays_plural": "{{count}} active days",

// Tooltip
"dashboard.calendarHeatmap.tooltip.minutes": "{{minutes}} minutes",

// Legend
"dashboard.calendarHeatmap.legend.less": "Less",
"dashboard.calendarHeatmap.legend.more": "More",
"dashboard.calendarHeatmap.legend.average": "Avg:",
"dashboard.calendarHeatmap.legend.minPerDay": "min/day",

// Activity Intensity Labels
"dashboard.calendarHeatmap.intensity.noActivity": "No activity",
"dashboard.calendarHeatmap.intensity.lessThan10": "< 10 min",
"dashboard.calendarHeatmap.intensity.10to20": "10-20 min",
"dashboard.calendarHeatmap.intensity.20to30": "20-30 min",
"dashboard.calendarHeatmap.intensity.moreThan30": "30+ min",

// Stats Summary
"dashboard.calendarHeatmap.stats.activeDays": "Active Days",
"dashboard.calendarHeatmap.stats.totalMinutes": "Total Minutes",
"dashboard.calendarHeatmap.stats.consistency": "Consistency",
        "dashboard.grammarGrid.title": "Grammar Mastery - {{level}}",
"dashboard.grammarGrid.mastered": "{{count}} / {{total}} mastered",

// Legend Labels
"dashboard.grammarGrid.legend.mastered": "Mastered (80%+)",
"dashboard.grammarGrid.legend.learning": "Learning (60-79%)",
"dashboard.grammarGrid.legend.needsWork": "Needs Work (<60%)",
        "dashboard.mistakes.title": "Grammar Weak Points",
"dashboard.mistakes.totalMistakes": "{{count}} total mistakes",
"dashboard.mistakes.totalMistakes_plural": "{{count}} total mistakes",

// Recent Mistakes Section
"dashboard.mistakes.recentTitle": "Recent Mistakes",

// Topic Card
"dashboard.mistakes.topicCard.mistakes": "mistakes",
"dashboard.mistakes.topicCard.accuracy": "Accuracy:",

// Action Button
"dashboard.mistakes.practiceButton": "Practice Weak Topics",

// No Mistakes State
"dashboard.mistakes.noMistakes.title": "Excellent Work!",
"dashboard.mistakes.noMistakes.description": "No major weak points detected.",

// Time Ago Helper
"dashboard.mistakes.timeAgo.minutesAgo": "{{count}}m ago",
"dashboard.mistakes.timeAgo.hoursAgo": "{{count}}h ago",
"dashboard.mistakes.timeAgo.daysAgo": "{{count}}d ago",
        // ==========================================
// WEEKLY PROGRESS - ENGLISH TRANSLATIONS
// Add these to your en: { translation: { ... } } object in src/i18n/index.js
// ==========================================

// Main Header
"dashboard.weeklyProgress.title": "This Week's Activity",
"dashboard.weeklyProgress.daysActive": "{{count}} days active",
"dashboard.weeklyProgress.daysActive_plural": "{{count}} days active",
"dashboard.weeklyProgress.daysActiveLabel": "Days Active",

// Day Names (Short form)
"dashboard.weeklyProgress.days.mon": "Mon",
"dashboard.weeklyProgress.days.tue": "Tue",
"dashboard.weeklyProgress.days.wed": "Wed",
"dashboard.weeklyProgress.days.thu": "Thu",
"dashboard.weeklyProgress.days.fri": "Fri",
"dashboard.weeklyProgress.days.sat": "Sat",
"dashboard.weeklyProgress.days.sun": "Sun",

// Tooltip
"dashboard.weeklyProgress.tooltip.lessons": "{{count}} lessons",
"dashboard.weeklyProgress.tooltip.lessons_plural": "{{count}} lessons",
"dashboard.weeklyProgress.tooltip.minutes": "{{count}} min",

// Legend
"dashboard.weeklyProgress.legend.goalMet": "Goal Met",
"dashboard.weeklyProgress.legend.active": "Active",
"dashboard.weeklyProgress.legend.missed": "Missed",
// ==========================================
// VOCABULARY CATEGORIES - ENGLISH TRANSLATIONS
// Add these to your en: { translation: { ... } } object in src/i18n/index.js
// ==========================================

// Main Header
"dashboard.vocabularyCategories.title": "Vocabulary by Category",
"dashboard.vocabularyCategories.totalWords": "{{count}} total words",

// Status Labels
"dashboard.vocabularyCategories.status.mastered": "Mastered",
"dashboard.vocabularyCategories.status.learning": "Learning",
"dashboard.vocabularyCategories.status.new": "New",

// Mistake Words Section
"dashboard.vocabularyCategories.mistakeWords.title": "Words Needing Review",
"dashboard.vocabularyCategories.mistakeWords.count": "({{count}})",
"dashboard.vocabularyCategories.mistakeWords.mistakes": "{{count}} mistakes",
"dashboard.vocabularyCategories.mistakeWords.viewAll": "View all {{count}} words →",

// No Data State
"dashboard.vocabularyCategories.noData": "No vocabulary data yet. Start learning to see your progress!",

// Category Card
"dashboard.vocabularyCategories.card.words": "{{count}} words",
"dashboard.vocabularyCategories.card.progress": "Progress",
"dashboard.vocabularyCategories.card.new": "New:",
"dashboard.vocabularyCategories.card.learning": "Learning:",
"dashboard.vocabularyCategories.card.mastered": "Mastered:",
"dashboard.vocabularyCategories.card.recentlyStudied": "Recently Studied:",
// ==========================================
// VOCAB BREAKDOWN - ENGLISH TRANSLATIONS
// Add these to your en: { translation: { ... } } object in src/i18n/index.js
// ==========================================

// Main Header
"dashboard.vocabBreakdown.title": "Vocabulary Progress",
"dashboard.vocabBreakdown.totalWords": "{{count}} total words",

// Stat Card Labels
"dashboard.vocabBreakdown.stats.learning": "Learning",
"dashboard.vocabBreakdown.stats.mastered": "Mastered",
"dashboard.vocabBreakdown.stats.dueToday": "Due Today",

// Insight Message
"dashboard.vocabBreakdown.insight.reviewTime": "Review time!",
"dashboard.vocabBreakdown.insight.wordsNeedPractice": "{{count}} words need practice to stay fresh.",


// Main Header
"gamification.streakManager.title": "Streak Manager",

// Current Streak Display
"gamification.streakManager.currentStreak.days": "days",
"gamification.streakManager.currentStreak.longestStreak": "Longest Streak",

// Milestone Names
"gamification.streakManager.milestones.yearLegend": "Year Legend",
"gamification.streakManager.milestones.centuryClub": "Century Club",
"gamification.streakManager.milestones.monthlyMaster": "Monthly Master",
"gamification.streakManager.milestones.twoWeekChampion": "Two Week Champion",
"gamification.streakManager.milestones.weekWarrior": "Week Warrior",
"gamification.streakManager.milestones.gettingStarted": "Getting Started",
"gamification.streakManager.milestones.startYourJourney": "Start Your Journey",

// Progress to Next Milestone
"gamification.streakManager.progress.next": "Next:",
"gamification.streakManager.progress.currentOfTotal": "{{current}} / {{total}}",

// Streak Protection Tools
"gamification.streakManager.freeze.title": "Streak Freeze",
"gamification.streakManager.freeze.description": "Protects your streak if you miss a day",

"gamification.streakManager.repair.title": "Streak Repair",
"gamification.streakManager.repair.description": "Free repair per month (restore lost streak)",

// Streak Calendar
"gamification.streakManager.calendar.title": "Last 7 Days",
// ==========================================
// SKILL MASTERY RINGS - ENGLISH TRANSLATIONS
// Add these to your en: { translation: { ... } } object in src/i18n/index.js
// ==========================================

// Main Header
"dashboard.skillMastery.title": "Skill Mastery Overview",

// Overall Score
"dashboard.skillMastery.overall.label": "Overall",
"dashboard.skillMastery.overall.proficiencyScore": "Proficiency Score",

// Individual Skills
"dashboard.skillMastery.skills.vocabulary": "Vocabulary",
"dashboard.skillMastery.skills.grammar": "Grammar",
"dashboard.skillMastery.skills.retention": "Retention",
"dashboard.skillMastery.skills.retentionAvg": "{{rate}}% avg",

// Level Labels
"dashboard.skillMastery.levels.expert": "Expert (C1+)",
"dashboard.skillMastery.levels.advanced": "Advanced (B2-C1)",
"dashboard.skillMastery.levels.upperIntermediate": "Upper Intermediate (B2)",
"dashboard.skillMastery.levels.intermediate": "Intermediate (B1-B2)",
"dashboard.skillMastery.levels.preIntermediate": "Pre-Intermediate (A2-B1)",
"dashboard.skillMastery.levels.beginner": "Beginner (A1-A2)",

// Progress Messages
"dashboard.skillMastery.message.keepItUp": "Keep it up!",
"dashboard.skillMastery.message.youreAt": "You're at {{level}} level.",
"dashboard.skillMastery.message.doingAmazing": "You're doing amazing!",
"dashboard.skillMastery.message.keepPracticing": "Keep practicing to reach Advanced!",
"dashboard.skillMastery.message.consistentPractice": "Consistent practice will boost your score quickly.",
// ==========================================
// PRACTICE DASHBOARD - ENGLISH TRANSLATIONS
// Add these to your en: { translation: { ... } } object in src/i18n/index.js
// ==========================================

// Greeting Messages
"dashboard.greeting.goodMorning": "Good Morning",
"dashboard.greeting.goodAfternoon": "Good Afternoon",
"dashboard.greeting.goodEvening": "Good Evening",
"dashboard.greeting.subtitle": "Continue your German learning journey",

// Streak Section
"dashboard.hero.dayStreak": "Day Streak",
"dashboard.hero.streakFreeze": "Streak Freeze",
"dashboard.hero.equipped": "{{count}} equipped",

// Streak Milestone Badges (these duplicate StreakManager - consider using same keys)
"dashboard.hero.milestones.yearLegend": "🏆 Year Legend",
"dashboard.hero.milestones.centuryClub": "💎 Century Club",
"dashboard.hero.milestones.monthlyMaster": "🏅 Monthly Master",
"dashboard.hero.milestones.twoWeekChampion": "⚡ Two Week Champion",
"dashboard.hero.milestones.weekWarrior": "🎯 Week Warrior",
"dashboard.hero.milestones.gettingStarted": "🚀 Getting Started",

// Daily Progress Section
"dashboard.hero.todaysProgress": "Today's Progress",
"dashboard.hero.goalSmashed": "✓ Goal smashed!",
"dashboard.hero.lessonsToGoal": "{{count}} lessons to goal",
"dashboard.hero.lessonsToGoal_plural": "{{count}} lessons to goal",
"dashboard.hero.of": "of",

// Core Stats Cards
"dashboard.hero.vocabulary.title": "Vocabulary",
"dashboard.hero.vocabulary.mastered": "Words Mastered",

"dashboard.hero.grammar.title": "Grammar",
"dashboard.hero.grammar.completed": "Topics Completed",

"dashboard.studyPlan.title": "Your Personalized Study Plan",
"dashboard.studyPlan.subtitle": "Your path to passing the exam.",
"dashboard.studyPlan.startNow": "Start Now",
"dashboard.studyPlan.continue": "Continue Learning",
"dashboard.studyPlan.completed": "Completed",
"dashboard.studyPlan.remaining": "Remaining",

"dashboard.zeroState.todaysProgress.activities": "Activities",
"dashboard.zeroState.todaysProgress.tooltip": "Based on your daily goal of {{dailyGoal}} activities",

"dashboard.vocabulary.unlockDeck": "Unlock {{level}} Deck",
"dashboard.redemittel.title": "Redemittel",
"dashboard.redemittel.subtitle": "Exam-relevant phrases for writing and speaking",
"dashboard.redemittel.cta": "Practice Redemittel",

"dashboard.examRequired.title": "Select your exam",
"dashboard.examRequired.subtitle": "Please choose an exam provider and level before proceeding.",
"dashboard.examRequired.continue": "Continue to dashboard",
"dashboard.examRequired.saving": "Saving…",

"dashboard.personalizedPlan.title": "Personalized Plan",
"dashboard.personalizedPlan.focus": "Focus",

"onboarding.ariaLabel": "Onboarding",
"onboarding.back": "Back",
"onboarding.next": "Next",
"onboarding.progress.start": "Let's get started, just a few questions.",
"onboarding.progress.almost": "Almost there! Just a few more questions...",
"onboarding.progress.quick": "Quick step, 2 minutes.",
"onboarding.welcome.title": "Welcome to Logami",
"onboarding.welcome.subtitle": "We'll tailor your experience in under two minutes.",
"onboarding.welcome.subtitleV2": "Complete your profile to get one step closer to passing your exam.",
"onboarding.welcome.cta": "Continue",
"onboarding.purpose.title": "What is your primary focus?",
"onboarding.purpose.exam": "Exam Preparation",
"onboarding.purpose.examSub": "Exam mocks and video lessons",
"onboarding.purpose.training": "German training",
"onboarding.purpose.trainingSub": "Improve your speaking, listening, and grammar",
"onboarding.purpose.both": "Both",
"onboarding.purpose.bothSub": "Exam + general",
"onboarding.fork.title": "Don't waste a second on the basics",
"onboarding.fork.subtitle": "Complete 15 quick questions to help us identify your strengths.",
"onboarding.fork.takeTest": "Start Assessment (5 min)",
"onboarding.fork.skip": "Skip placement exam",
"onboarding.diagnostic.progress": "Question {{current}} of {{total}}",
"onboarding.diagnostic.correct": "Correct! Keep going.",
"onboarding.diagnostic.correct.1": "Correct! Keep going.",
"onboarding.diagnostic.correct.2": "Well done!",
"onboarding.diagnostic.correct.3": "That's right!",
"onboarding.diagnostic.correct.4": "Nice one!",
"onboarding.diagnostic.correct.5": "Spot on!",
"onboarding.diagnostic.incorrect": "Not quite, we'll focus on that.",
"onboarding.diagnostic.incorrect.1": "Not quite, we'll focus on that.",
"onboarding.diagnostic.incorrect.2": "Good try, we'll work on this.",
"onboarding.diagnostic.incorrect.3": "Almost, check the feedback below.",
"onboarding.diagnostic.incorrect.4": "Not this time, see the correct answer below.",
"onboarding.diagnostic.incorrect.5": "We'll get there, have a look at the feedback.",
"onboarding.diagnostic.feedbackLabel": "Feedback",
"onboarding.diagnostic.correctAnswer": "Correct answer",
"onboarding.diagnostic.check": "Check",
"onboarding.diagnostic.expand": "Tap to expand",
"onboarding.diagnostic.collapse": "Collapse",
"onboarding.diagnostic.nextToExam": "Next",
"onboarding.diagnosticComplete.title": "Test Complete!",
"onboarding.diagnosticComplete.subtitle": "Awesome work. We've analyzed your skills and estimated your current level at ",
"onboarding.diagnosticComplete.subtitle2": " Now, let's set your goals.",
"onboarding.diagnosticComplete.cta": "Set My Goals",
"onboarding.types.grammar": "Grammar",
"onboarding.types.styling": "Styling",
"onboarding.types.listening": "Hören",
"onboarding.exam.title": "What exam are you taking?",
"onboarding.exam.providerTitle": "Select exam provider",
"onboarding.exam.levelTitle": "Select level",
"onboarding.exam.modeTitle": "Paper or digital?",
"onboarding.timeline.title": "When is test day?",
"onboarding.timeline.question": "Do you have a test date?",
"onboarding.timeline.yes": "Yes",
"onboarding.timeline.notYet": "Not yet",
"onboarding.timeline.pickDate": "Pick a date",
"onboarding.timeline.tapToSelect": "Tap to select your exam date",
"onboarding.timeline.statusTap": "Tap",
"onboarding.timeline.statusReady": "Ready",
"onboarding.timeline.tapHint": "On mobile: tap the date field to open the calendar picker.",
"onboarding.timeline.selectedHint": "Date selected. You can still change it anytime.",
"onboarding.history.title": "Have you taken this exam before?",
"onboarding.history.titleWithExam": "Have you taken the {{examName}} exam before?",
"onboarding.history.yes": "Yes",
"onboarding.history.no": "No",
"onboarding.history.result": "Result",
"onboarding.history.resultPlaceholder": "e.g. Pass / 75%",
"onboarding.history.date": "Date",
"onboarding.focus.title": "Focus areas",
"onboarding.focus.subtitle": "Select all that apply.",
"onboarding.focus.writing": "Writing",
"onboarding.focus.speaking": "Speaking",
"onboarding.focus.reading": "Reading",
"onboarding.focus.listening": "Listening",
"onboarding.focus.grammar": "Grammar",
"onboarding.focus.vocabulary": "Vocabulary",
"onboarding.referral.title": "Where did you hear about us?",
"onboarding.referral.subtitle": "You can pick more than one.",
"onboarding.referral.google": "Google",
"onboarding.referral.friends": "Friends / Word of Mouth",
"onboarding.referral.youtube": "YouTube",
"onboarding.referral.social": "Social media (Instagram / TikTok)",
"onboarding.referral.flyers": "Flyers / Posters",
"onboarding.progress.stage1": "Personalizing your profile...",
"onboarding.progress.stage2": "Finding your level...",
"onboarding.progress.stage3": "Finalizing your custom plan...",
"onboarding.diagnostic.skipAdvanced": "Impressive! Skipping to advanced questions to save you time.",
"onboarding.illusion.status1": "Pinpointing your unique strengths..",
"onboarding.illusion.status2": "Matching your skills to {{examName}} requirements..",
"onboarding.illusion.status3": "Finalizing your personalized study plan",
"onboarding.aha.title": "Your plan is ready",
"onboarding.aha.focus": "We'll focus on",
"onboarding.aha.startPlan": "Let's Begin",
"onboarding.pricing.title": "Choose your plan",
"onboarding.pricing.subtitle": "Start free or unlock full access to pass your exam.",
"onboarding.pricing.selected": "Selected",
"onboarding.pricing.continue": "Continue",
"onboarding.pricing.recommended": "Recommended",
"onboarding.pricing.limitedTime": "Limited Time",
  "onboarding.confirm.title": "Just to confirm",
  "onboarding.confirm.prepareFor": "You said you want to prepare for",
  "onboarding.confirm.yourExam": "your exam",
  "onboarding.confirm.yes": "Yes, that's right",
  "onboarding.confirm.change": "No, I want to change it",
  "onboarding.loading": "Loading...",
  "onboarding.saving": "Saving your plan...",

  "dashboard.examPerformance.title": "Exam Performance",
"dashboard.examPerformance.latestScore": "Latest Exam Score",
"dashboard.examPerformance.lastAttempts": "Last 5 Attempts",
"dashboard.examPerformance.examsCompleted": "exams completed",
"dashboard.examPerformance.noExams": "Take a mock exam to see your performance",
"dashboard.mockExamCard.titleLine1": "Take Your",
"dashboard.mockExamCard.titleLine2": "Mock Exam",
"dashboard.mockExamCard.subtitle": "Ready for the real thing? Take a timed mock exam to test your readiness.",
"dashboard.mockExamCard.cta": "Start Exam",
"dashboard.mockExamCard.badge": "Full Assessment",
"dashboard.examSkills.reading": "Reading",
"dashboard.examSkills.listening": "Listening",
"dashboard.examSkills.writing": "Writing",
"dashboard.toggles.hideExamFeatures": "Hide exam features",
"dashboard.toggles.showExamFeatures": "Show exam features",
"dashboard.toggles.hideGeneralTraining": "Hide General Training",
"dashboard.toggles.generalTraining": "General Training",
"dashboard.examPerformance.viewAnalytics": "View Analytics →",

"dashboard.examAnalytics.title": "Exam Analytics",
"dashboard.examAnalytics.exams": "exams",
"dashboard.examAnalytics.viewStats": "View Stats →",
"dashboard.examAnalytics.noData": "Take exams to see analytics",
"dashboard.examAnalytics.analytics": "Analytics",

"dashboard.examModeHub.title": "Pick a Skill and Practice Task by Task",
"dashboard.examModeHub.reading.title": "Reading Practice",
"dashboard.examModeHub.reading.subtitle": "Practice reading tasks one by one and understand why each answer is correct.",
"dashboard.examModeHub.listening.title": "Listening Practice",
"dashboard.examModeHub.listening.subtitle": "Practice listening at your own pace: pause, go back, and play again anytime.",
"dashboard.examModeHub.writing.title": "Writing Practice",
"dashboard.examModeHub.writing.subtitle": "Write answers with Redemittel support by your side, one task at a time.",

"dashboard.nextLesson.title": "NEXT LESSON",
"dashboard.nextLesson.createPlan": "GET STARTED",
"dashboard.nextLesson.createTitle": "Create Your Personalized Plan",
"dashboard.nextLesson.createSubtitle": "Get a customized study plan tailored to your exam date and goals.",
"dashboard.nextLesson.startPlan": "Start Your Plan →",
"dashboard.nextLesson.allCompleted": "All Lessons Completed!",
"dashboard.nextLesson.review": "Review your progress or take a practice exam.",
"dashboard.nextLesson.progress": "Study Plan Progress",
"dashboard.nextLesson.minutes": "min",

// Loading State
"dashboard.loading.loadingVocabulary": "Loading vocabulary data...",
// ==========================================
// SETTINGS PAGE - ENGLISH TRANSLATIONS
// Add these to your en: { translation: { ... } } object in src/i18n/index.js
// ==========================================

// Page Header
"settings.header.title": "Settings",
"settings.header.subtitle": "Manage your profile and account preferences",

// Tab Labels
"settings.tabs.profile": "Profile",
"settings.tabs.account": "Account",
"settings.tabs.notifications": "Notifications",
"settings.tabs.streak": "Streak & Goals",

// Common Buttons
"settings.buttons.saveChanges": "Save Changes",
"settings.buttons.saving": "Saving...",

// ==========================================
// PROFILE TAB
// ==========================================
"settings.profile.title": "Edit Profile",
"settings.profile.profilePicture": "Profile Picture",
"settings.profile.uploadCustomPhoto": "Upload custom photo",
"settings.profile.chooseAvatar": "Choose Avatar",
"settings.profile.uploadPhoto": "Upload Photo",
"settings.profile.imageFormat": "JPG, PNG or GIF (max. 5MB)",

"settings.profile.firstName": "First Name",
"settings.profile.lastName": "Last Name",
"settings.profile.email": "Email Address",
"settings.profile.emailCannotChange": "Email address cannot be changed",
"settings.profile.language": "Language",

// ==========================================
// ACCOUNT TAB
// ==========================================
"settings.account.title": "Account Settings",
"settings.account.accountInfo": "Account Information",
"settings.account.user": "User:",
"settings.account.email": "Email:",
"settings.account.verified": "Verified:",
"settings.account.verifiedYes": "✅ Yes",
"settings.account.verifiedNo": "❌ No",
"settings.account.verificationChip.verified": "Verified",
"settings.account.verificationChip.unverified": "Not verified",
"settings.account.memberSince": "Member since:",
"settings.account.unknown": "Unknown",

// Password Section
"settings.account.changePassword": "Change Password",
"settings.account.currentPassword": "Current Password",
"settings.account.newPassword": "New Password",
"settings.account.confirmPassword": "Confirm New Password",

// Data & Privacy
"settings.account.dataPrivacy": "Data & Privacy",
"settings.account.exportData": "Export Data",
"settings.account.deleteAccount": "Delete Account",

// ==========================================
// DELETE ACCOUNT MODAL
// ==========================================
"settings.deleteModal.title": "Delete Account?",
"settings.deleteModal.warning": "This action cannot be undone. All your data will be permanently deleted.",
"settings.deleteModal.willDelete": "This will delete:",
"settings.deleteModal.item1": "• Your profile and account settings",
"settings.deleteModal.item2": "• All exam results and progress",
"settings.deleteModal.item3": "• Study sessions and vocabulary",
"settings.deleteModal.item4": "• Achievements and streak data",
"settings.deleteModal.typeDelete": "Type DELETE to confirm",
"settings.deleteModal.typeDeletePlaceholder": "Type DELETE",
"settings.deleteModal.enterPassword": "Enter your password",
"settings.deleteModal.passwordPlaceholder": "Your password",
"settings.deleteModal.cancel": "Cancel",
"settings.deleteModal.deleteForever": "Delete Forever",
"settings.deleteModal.deleting": "Deleting...",

// ==========================================
// NOTIFICATIONS TAB
// ==========================================
"settings.notifications.title": "Notification Settings",
"settings.notifications.enabled": "✅ Notifications Enabled",
"settings.notifications.enableTitle": "🔔 Enable Notifications",
"settings.notifications.enabledDescription": "You'll receive study reminders and updates",
"settings.notifications.disabledDescription": "Get reminders to maintain your study streak and review vocabulary",
"settings.notifications.enableNow": "Enable Now",

// Master Toggle
"settings.notifications.master": "Master Notifications",
"settings.notifications.masterDescription": "Turn all notifications on or off",

// Reminder Types
"settings.notifications.reminderTypes": "Reminder Types",
"settings.notifications.studyReminders": "Daily Study Reminders",
"settings.notifications.studyDescription": "Remind me to practice every day",
"settings.notifications.streakReminders": "Streak Reminders",
"settings.notifications.streakDescription": "Alert me if my streak is about to break",
"settings.notifications.reviewReminders": "Review Reminders",
"settings.notifications.reviewDescription": "Notify me when vocabulary cards are due for review",
"settings.notifications.achievementAlerts": "Achievement Alerts",
"settings.notifications.achievementDescription": "Celebrate when I unlock achievements",

// Timing
"settings.notifications.dailyReminderTime": "Daily Reminder Time",
"settings.notifications.quietHours": "Quiet Hours",
"settings.notifications.quietHoursDescription": "No notifications during these hours",
"settings.notifications.start": "Start",
"settings.notifications.end": "End",

// Test
"settings.notifications.sendTest": "Send Test Notification",
"settings.notifications.testSent": "Test notification sent!",
"settings.notifications.testTitle": "Test Notification 🧪",
"settings.notifications.testBody": "This is how your notifications will look!",

// Browser Support
"settings.notifications.notSupported": "Your browser doesn't support notifications. Please use a modern browser like Chrome, Firefox, or Safari.",

// Notification Messages
"settings.notifications.welcomeTitle": "Notifications Enabled! 🎉",
"settings.notifications.welcomeBody": "You'll now receive study reminders and updates.",

// ==========================================
// STREAK & GOALS TAB
// ==========================================
"settings.streak.title": "Streak & Goals",
"settings.streak.dailyGoal": "Daily Goal",
"settings.streak.lessonsPerDay": "Lessons per day:",
"settings.streak.lessonOptions.1": "1 lesson",
"settings.streak.lessonOptions.3": "3 lessons",
"settings.streak.lessonOptions.5": "5 lessons",
"settings.streak.lessonOptions.10": "10 lessons",
"settings.streak.lessonOptions.15": "15 lessons",
"settings.streak.lessonOptions.20": "20 lessons",
"settings.streak.current": "Current: {{count}} lesson per day",
"settings.streak.current_plural": "Current: {{count}} lessons per day",

// Streak Protection
"settings.streak.protection": "Streak Protection",
"settings.streak.excludeWeekends": "Exclude Weekends",
"settings.streak.excludeWeekendsDescription": "Weekends don't count toward or against your streak",
"settings.streak.reminders": "Streak Reminders",
"settings.streak.remindersDescription": "Get notified to maintain your daily streak",

// ==========================================
// STATUS MESSAGES
// ==========================================
"settings.status.avatarUpdated": "Avatar updated successfully!",
"settings.status.avatarUploading": "Avatar uploading...",
"settings.status.profileUpdated": "Profile updated successfully!",
"settings.status.updatingProfile": "Updating profile...",
"settings.status.passwordUpdated": "Password updated successfully!",
"settings.status.changingPassword": "Changing password...",
"settings.status.passwordsNoMatch": "Passwords do not match",
"settings.status.passwordTooShort": "Password must be at least 6 characters",
"settings.status.incorrectPassword": "Current password is incorrect",
"settings.status.errorChangingPassword": "Error changing password",
"settings.status.errorUpdatingProfile": "Error updating profile",
"settings.status.notificationsSaved": "Notification settings saved!",
"settings.status.notificationsEnabled": "Notifications enabled!",
"settings.status.notificationsDenied": "Notification permission denied",
"settings.status.errorEnablingNotifications": "Error enabling notifications",
"settings.status.dailyGoalUpdated": "Daily goal updated!",
"settings.status.errorUpdatingGoal": "Error updating goal",
"settings.status.dataExporting": "Exporting data...",
"settings.status.dataExported": "Data exported successfully!",
"settings.status.errorExportingData": "Error exporting data",
"settings.status.noChanges": "No changes to save",
"settings.status.deletingAccount": "Deleting account...",
"settings.status.accountDeleted": "Account deleted successfully. Redirecting...",
"settings.status.deletePasswordIncorrect": "Incorrect password",
"settings.status.deleteRecentLoginRequired": "Please log out and log back in before deleting account",
"settings.status.deleteError": "Error deleting account. Please try again.",
"settings.status.deleteTypeDelete": "Please type DELETE to confirm",
"settings.status.deletePasswordRequired": "Password is required",

// ==========================================
// ALERTS & VALIDATION
// ==========================================
"settings.alerts.selectImage": "Please select an image file.",
"settings.alerts.imageTooLarge": "Image file is too large. Maximum 5MB allowed.",
        "settings.profile.firstNamePlaceholder": "First Name",
"settings.profile.lastNamePlaceholder": "Last Name",
// TRANSLATION KEYS TO ADD TO YOUR INDEX.JS FILE
// Copy these into your English translation object

// === FAQ PAGE TRANSLATIONS ===

"faq.badge": "Help Center",
"faq.searchPlaceholder": "Search questions...",
"faq.noResults": "No questions found",
"faq.noResultsDesc": "Try adjusting your search terms or browse all questions above.",
"faq.cta.title": "Still have questions?",
"faq.cta.button": "Contact Support",
"auth.verification.emailSent": "Verification email sent!",
"auth.verification.checkSpam": "📧 Didn't receive it? Check your spam/junk folder",
"auth.verification.spamTip": "Emails from Logami might be in your spam folder. Please check there if you don't see it in your inbox within 2-3 minutes.",
"auth.verification.waitTime": "Delivery can take 1-5 minutes depending on your email provider",
"auth.verification.checkInbox": "Check your inbox",
"auth.verification.checkSpamFolder": "Check your spam/junk folder",
"auth.verification.emailDelay": "Email may take a few minutes to arrive",
"auth.verification.spamWarning": "⚠️ Important: Check your spam folder!",
"auth.verification.spamDescription": "Verification emails from Logami may sometimes be marked as spam by your email provider.",

// EmailVerificationFlow Component
"emailVerification.title.verified": "Email Verified!",
"emailVerification.title.checkEmail": "Check Your Email",
"emailVerification.description.verified": "Your account has been successfully verified.",
"emailVerification.description.sent": "We sent a verification link to {{email}}",
"emailVerification.status.sent": "Verification email sent!",
"emailVerification.status.sentDescription": "Check your inbox and click the verification link to activate your account.",
"emailVerification.status.checking": "Checking verification status...",
"emailVerification.status.waiting": "Still waiting for verification...",
"emailVerification.status.checked": "Checked {{count}}vtime",
"emailVerification.status.checked_plural": "Checked {{count}} times",

// Instructions
"emailVerification.instructions.title": "What to do next:",
"emailVerification.instructions.step1": "Check your inbox for an email from Logami",
"emailVerification.instructions.step2": "Look in your spam/junk folder if you don't see it",
"emailVerification.instructions.step3": "Click the verification link in the email",
"emailVerification.instructions.step4": "Return here - we'll detect it automatically!",

// Email Provider
"emailVerification.openEmail": "Open {{provider}}",

// Resend Section
"emailVerification.resend.title": "Didn't receive the email?",
"emailVerification.resend.button.sending": "Sending...",
"emailVerification.resend.button.cooldown": "Resend in {seconds}s",
"emailVerification.resend.button.ready": "Resend verification email",

// Error Messages
"emailVerification.error.tooManyRequests": "Too many requests. Please wait before requesting another email.",
"emailVerification.error.sendFailed": "Failed to send verification email. Please try again.",

// Action Buttons
"emailVerification.button.continue": "Continue to Logami",
"emailVerification.button.checkStatus": "Check verification status",
"emailVerification.button.checking": "Checking...",
"emailVerification.button.backToLogin": "Back to login",

// Auto-refresh
"emailVerification.autoCheck": "⟳ Auto-checking every 3 seconds...",

// === AUTH PAGE ===
// Headers
"auth.welcome.login": "Welcome Back",
"auth.welcome.signup": "Create Account",
"auth.subtitle.login": "Sign in to your account",
"auth.subtitle.signup": "Join us today",

// Form Labels
"auth.form.firstName": "First Name",
"auth.form.lastName": "Last Name",
"auth.form.email": "Email Address",
"auth.form.password": "Password",
"auth.form.confirmPassword": "Confirm Password",

// Placeholders
"auth.placeholder.firstName": "John",
"auth.placeholder.lastName": "Doe",
"auth.placeholder.email": "your.email@example.com",
"auth.placeholder.password.login": "Enter your password",
"auth.placeholder.password.signup": "At least 6 characters",
"auth.placeholder.confirmPassword": "Confirm your password",

// Buttons
"auth.button.signIn": "Sign In",
"auth.button.signUp": "Create Account",
"auth.button.signingIn": "Signing In...",
"auth.button.creatingAccount": "Creating Account...",

// Toggle
"auth.toggle.toSignup": "Don't have an account? Sign up",
"auth.toggle.toLogin": "Already have an account? Sign in",

"auth.google.signIn": "Sign in with Google",
"auth.divider.orContinueWith": "Or continue with",
"auth.error.googlePopupClosed": "Sign-in cancelled.",
"auth.error.googleAccountExists": "An account with this email already exists. Please sign in with email and password.",
"auth.error.googleFailed": "Google sign-in failed. Please try again.",

// Validation Errors
"auth.error.nameRequired": "Please enter your first and last name.",
"auth.error.invalidEmail": "Please enter a valid email address.",
"auth.error.passwordTooShort": "Password must be at least 6 characters long.",
"auth.error.passwordMismatch": "Passwords do not match.",
"auth.error.emailInUse": "This email is already in use.",
"auth.error.weakPassword": "Password is too weak. Please choose a stronger password.",
"auth.error.operationNotAllowed": "Email/password accounts are not enabled. Please contact support.",
"auth.error.signupFailed": "Signup failed: {message}",

// Login Errors
"auth.error.emailNotVerified": "Please verify your email before logging in. Check your inbox for a verification link.",
"auth.error.userNotFound": "No account found with this email address.",
"auth.error.wrongPassword": "Invalid email or password.",
"auth.error.tooManyRequests": "Too many failed login attempts. Please try again later.",
"auth.error.loginFailed": "An error occurred during login. Please try again.",

// Email Verification Checker (on Login Page)
"auth.checker.title": "Check Email Verification",
"auth.checker.button": "Check Status",
"auth.checker.checking": "Checking...",
"auth.checker.description": "If you just clicked the verification link, use this to check if your email is verified.",
"auth.checker.success": "✅ Email is verified! You can now log in.",
"auth.checker.warning": "⚠️ Email not yet verified. Please check your inbox and click the verification link.",
"auth.checker.error": "Error checking verification status. Please check your credentials.",
"auth.checker.missingCredentials": "Please enter your email and password first",
"auth.backToHome": "Back to Home",

// Password Reset
"auth.resetPassword.title": "Reset Password",
"auth.resetPassword.subtitle": "Enter your email address and we'll send you a link to reset your password.",
"auth.resetPassword.emailSent": "Password reset email sent!",
"auth.resetPassword.emailSentDescription": "Check your inbox for a password reset link. If you don't see it, check your spam folder.",
"auth.resetPassword.backToLogin": "Back to Login",
"auth.resetPassword.sendResetLink": "Send Reset Link",
"auth.resetPassword.sending": "Sending...",
"auth.resetPassword.forgotPassword": "Forgot Password?",
"auth.resetPassword.error.invalidEmail": "Please enter a valid email address.",
"auth.resetPassword.error.userNotFound": "No account found with this email address.",
"auth.resetPassword.error.failed": "Failed to send reset email. Please try again.",
"auth.resetPassword.error.passwordTooShort": "Password must be at least 6 characters long.",
"auth.resetPassword.error.expiredLink": "This password reset link has expired. Please request a new one.",
"auth.resetPassword.error.invalidLink": "This password reset link is invalid. Please request a new one.",
"auth.resetPassword.confirm.title": "Set New Password",
"auth.resetPassword.confirm.subtitle": "Enter your new password",
"auth.resetPassword.confirm.description": "Enter your new password below.",
"auth.resetPassword.confirm.newPassword": "New Password",
"auth.resetPassword.confirm.submit": "Reset Password",
"auth.resetPassword.confirm.resetting": "Resetting...",
"auth.resetPassword.confirm.success": "Password Reset Successful!",
"auth.resetPassword.confirm.successDescription": "Your password has been reset. You can now log in with your new password.",

// Auth Page Hero Section
"auth.hero.badge.login": "Welcome Back",
"auth.hero.badge.signup": "Join Us Today",
"auth.hero.title.login": "Continue Your",
"auth.hero.title.signup": "Start Your",
"auth.hero.titleHighlight": "Learning Journey",
"auth.hero.description.login": "Master German exams with personalized practice and expert guidance.",
"auth.hero.description.signup": "Join thousands of successful learners achieving their German language goals.",

// Auth Page Features
"auth.features.plan.title.login": "Plan Your Success",
"auth.features.plan.title.signup": "Personalized Learning",
"auth.features.plan.desc.login": "Set clear goals and track your progress",
"auth.features.plan.desc.signup": "Logami's AI study plans tailored for you",
"auth.features.practice.title.login": "Practice Effectively",
"auth.features.practice.title.signup": "Comprehensive Content",
"auth.features.practice.desc.login": "Access thousands of practice questions",
"auth.features.practice.desc.signup": "Complete exam preparation materials",
"auth.features.pass.title.login": "Pass with Confidence",
"auth.features.pass.title.signup": "Guaranteed Success",
"auth.features.pass.desc.login": "Join thousands of successful learners",
"auth.features.pass.desc.signup": "Join 1,000+ successful students",

// Auth Page Stats
"auth.stats.activeUsers": "Active Learners",
"auth.stats.successRate": "Success Rate",
"auth.stats.userRating": "User Rating",

// Auth Page Reset Password Hero
"auth.resetPassword.hero.badge": "🔐 Reset Password",
"auth.resetPassword.hero.title": "Reset Your",
"auth.resetPassword.hero.titleHighlight": "Password",
"auth.resetPassword.hero.description": "Enter your email address and we'll send you a secure link to reset your password.",

// Auth Page Exam Selection
"auth.examSelection.provider": "Select Exam Provider",
"auth.examSelection.level": "Select Level",
"auth.examSelection.required": "Please select an exam provider and level",

// Header/UI
"header.focusMode": "Focus Mode",
"header.adminExamSwitch.label": "Switch exam (admin)",
"header.adminExamSwitch.title": "Switch exam",
"header.adminExamSwitch.hint": "Admin only. The page reloads with the new exam.",
"header.adminExamSwitch.switching": "Switching…",
"header.adminExamSwitch.error": "Could not switch exam. Please try again.",

// Speaking Section
"speaking.comingSoon.title": "Speaking - Coming Soon",
"speaking.comingSoon.description": "The speaking tasks are currently in development and will be available soon.",
"speaking.comingSoon.badge": "Available Soon",

// Lesson Status
"lesson.locked": "Locked",

// === CONTACT PAGE TRANSLATIONS ===
"contact.title": "Contact Us",
"contact.subtitle": "Have a question about our platform? Need help with your German exam preparation? We'd love to hear from you.",
"contact.badge": "Get in Touch",

// Contact Information
"contact.info.title": "Get in Touch",
"contact.info.description": "Choose the best way to reach us. We're here to help with any questions about German exam preparation.",
"contact.info.email.title": "Email",
"contact.info.email.desc": "Send us an email anytime",
"contact.info.phone.title": "Phone",
"contact.info.phone.desc": "Call us during business hours",
"contact.info.address.title": "Address",
"contact.info.address.desc": "Visit our office",
"contact.info.hours.title": "Business Hours",
"contact.info.hours.value": "Mon-Fri: 9AM-6PM",
"contact.info.hours.desc": "We respond within 24 hours",

// Contact Stats
"contact.stats.response": "Response Time",
"contact.stats.satisfaction": "Satisfaction Rate",

// Contact Form
"contact.form.title": "Send us a Message",
"contact.form.description": "Fill out the form below and we'll get back to you as soon as possible.",
"contact.form.type.label": "Inquiry Type",
"contact.form.types.general": "General Inquiry",
"contact.form.types.technical": "Technical Support",
"contact.form.types.exam": "Exam Questions",
"contact.form.types.partnership": "Partnership",
"contact.form.types.feedback": "Feedback",
"contact.form.name.label": "Full Name",
"contact.form.name.placeholder": "John Doe",
"contact.form.email.label": "Email Address",
"contact.form.email.placeholder": "john@example.com",
"contact.form.subject.label": "Subject",
"contact.form.subject.placeholder": "How can we help you?",
"contact.form.message.label": "Message",
"contact.form.message.placeholder": "Please provide as much detail as possible...",
"contact.form.submit": "Send Message",
"contact.form.submitting": "Sending...",
"contact.form.privacy": "By submitting this form, you agree to our privacy policy. We will never share your information with third parties.",

// Contact Success
"contact.success.title": "Message Sent!",
"contact.success.message": "Thank you for reaching out. We'll get back to you within 24 hours.",
"lesson.tabs.overview": "Overview",
"lesson.tabs.strategy": "Strategy",
"lesson.tabs.tips": "Tips & Tricks",
"lesson.tabs.warnings": "Warnings & Traps",
"lesson.tabs.examples": "Examples & Scenarios",
"lesson.tabs.practice": "Practice",
"lesson.tabs.reference": "Reference",
// ==========================================
// COMPLETE ENGLISH TRANSLATIONS FOR LEGAL PAGES
// Add these to your src/i18n/index.js under en: { translation: { ... } }
// ==========================================

// === FOOTER COMPONENT ===
"footer.terms": "Terms of Service",
"footer.privacy": "Privacy Policy",
"footer.cookies": "Cookie Policy",
"footer.about": "About",
"footer.contact": "Contact",
"footer.faq": "FAQ",
"footer.blog": "Blog",
"footer.grammar": "German grammar",
"footer.tagline": "Your trusted platform for German exam preparation",
"footer.madeWith": "Made with",
"footer.inGermany": "in Germany",
"footer.quickLinks": "Quick Links",

// ── SEO internal-linking + FAQ copy (added 2026-08-18) ──
// The marketing pages navigated entirely through onClick buttons, so Googlebot found
// one <a href> on the homepage and none on /try. These label the crawlable links added
// in MarketingFooter / HomePageB. See doc/SEO_MOCK_EXAM_RANKING_DIAGNOSIS_2026-08.md.
"footer.mockExams": "Mock exams",
"footer.allMockExams": "All mock exams",
"footer.tryFree": "Free mock exam",
"footer.telcB1": "TELC B1 prep",
"footer.telcB2": "TELC B2 prep",
"homeB.nav.mockExams": "Mock exams",
"homeB.nav.blog": "Exam guides",
"homeB.faq.title": "German exam questions, answered",
"homeB.faq.subtitle": "The things candidates ask us most about telc, Goethe and \u00d6SD.",
"mockExam.cta.pricing": "See pricing",

// 404 page. Replaces a silent redirect-to-homepage that made every bogus URL a
// 200 OK duplicate of the homepage.
"notFound.badge": "Error 404",
"notFound.title": "This page does not exist",
"notFound.body": "The link may be broken or the page may have moved. Here is where everything else lives.",
"notFound.navLabel": "Site sections",
"notFound.linkHome": "Home",
"notFound.linkMockExams": "German mock exams",
"notFound.linkBlog": "Exam guides & blog",
"notFound.linkPricing": "Pricing",
"notFound.linkFaq": "FAQ",
"notFound.linkContact": "Contact",
"footer.legal": "Legal",
"footer.contactUs": "Contact Us",
"footer.location": "Berlin, Germany",
"footer.rights": "All rights reserved.",
"footer.gdprCompliant": "GDPR Compliant",
"footer.disclaimer": "This platform is not affiliated with telc, the Goethe-Institut, or ÖSD.",
"footer.followUs": "Follow us",
"footer.followTiktok": "Follow Logami on TikTok (@logami.app)",
"footer.followInstagram": "Follow Logami on Instagram (@logami.app)",
"footer.followYoutube": "Subscribe to Logami on YouTube",

// === GENERAL LEGAL ===
"legal.back": "Back",
"legal.lastUpdated": "Last Updated",

// === TERMS OF SERVICE ===
"legal.terms.title": "Terms of Service",

"legal.terms.intro.title": "Introduction",
"legal.terms.intro.text1": "Welcome to Logami. These Terms of Service govern your use of our German language exam preparation platform and services.",
"legal.terms.intro.text2": "By accessing or using Logami, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you may not use our services.",

"legal.terms.acceptance.title": "Acceptance of Terms",
"legal.terms.acceptance.text": "By creating an account or using our services, you acknowledge that you have read, understood, and agree to:",
"legal.terms.acceptance.item1": "These Terms of Service",
"legal.terms.acceptance.item2": "Our Privacy Policy",
"legal.terms.acceptance.item3": "Our Cookie Policy",

"legal.terms.service.title": "Service Description",
"legal.terms.service.text": "Logami provides:",
"legal.terms.service.item1": "Practice materials for German language exams (Goethe, telc, TestDaF, DSH)",
"legal.terms.service.item2": "Study plans and progress tracking",
"legal.terms.service.item3": "Vocabulary and grammar exercises",
"legal.terms.service.item4": "Mock exams and performance analytics",

"legal.terms.accounts.title": "User Accounts",
"legal.terms.accounts.text": "To use our services, you must:",
"legal.terms.accounts.item1": "Provide accurate and complete registration information",
"legal.terms.accounts.item2": "Maintain the security of your password",
"legal.terms.accounts.item3": "Be at least 16 years old",
"legal.terms.accounts.item4": "Notify us immediately of any unauthorized use of your account",

"legal.terms.conduct.title": "User Conduct",
"legal.terms.conduct.text": "You agree not to:",
"legal.terms.conduct.item1": "Use the service for any illegal purpose",
"legal.terms.conduct.item2": "Share your account credentials with others",
"legal.terms.conduct.item3": "Attempt to reverse engineer or copy our materials",
"legal.terms.conduct.item4": "Upload malicious code or viruses",
"legal.terms.conduct.item5": "Harass or harm other users",

"legal.terms.ip.title": "Intellectual Property",
"legal.terms.ip.text": "All content, materials, and features on Logami are the property of Logami and protected by German and international copyright laws. You may not copy, modify, distribute, or create derivative works without our express written permission.",

"legal.terms.payments.title": "Payments",
"legal.terms.payments.text": "If you make a purchase:",
"legal.terms.payments.item1": "Payments are processed securely through third-party payment processors",
"legal.terms.payments.item2": "Access is granted immediately upon successful payment",
"legal.terms.payments.item3": "Refunds are available if a technical issue prevents access for more than 48 hours",

"legal.terms.liability.title": "Limitation of Liability",
"legal.terms.liability.text": "Logami provides services 'as is' and makes no warranties regarding the accuracy, completeness, or reliability of content. We are not liable for any indirect, incidental, or consequential damages arising from your use of our services.",

"legal.terms.jurisdiction.title": "Governing Law",
"legal.terms.jurisdiction.text": "These Terms are governed by the laws of Germany. Any disputes shall be resolved in the courts of Berlin, Germany.",

"legal.terms.changes.title": "Changes to Terms",
"legal.terms.changes.text": "We reserve the right to modify these Terms at any time. We will notify users of significant changes via email or platform notification. Continued use of the service after changes constitutes acceptance of the new Terms.",

"legal.terms.contact.title": "Contact Information",
"legal.terms.contact.text": "If you have questions about these Terms, please contact us:",

"legal.terms.footer.text": "Have questions about our Terms of Service?",
"legal.terms.footer.button": "Contact Us",

// === PRIVACY POLICY ===
"legal.privacy.title": "Privacy Policy",

"legal.privacy.intro.title": "Introduction",
"legal.privacy.intro.text1": "This Privacy Policy explains how Logami collects, uses, stores, and protects your personal data in compliance with the General Data Protection Regulation (GDPR) and German data protection laws.",
"legal.privacy.intro.text2": "We are committed to protecting your privacy and ensuring transparency in how we handle your information.",

"legal.privacy.controller.title": "Data Controller",
"legal.privacy.controller.location": "Location: Berlin, Germany",

"legal.privacy.dataCollected.title": "Data We Collect",
"legal.privacy.dataCollected.account.title": "Account Information",
"legal.privacy.dataCollected.account.item1": "Email address",
"legal.privacy.dataCollected.account.item2": "Name (first and last)",
"legal.privacy.dataCollected.account.item3": "Password (encrypted)",

"legal.privacy.dataCollected.usage.title": "Usage Data",
"legal.privacy.dataCollected.usage.item1": "Practice session results and scores",
"legal.privacy.dataCollected.usage.item2": "Study progress and learning patterns",
"legal.privacy.dataCollected.usage.item3": "Time spent on exercises",
"legal.privacy.dataCollected.usage.item4": "Vocabulary and grammar progress",

"legal.privacy.dataCollected.technical.title": "Technical Data",
"legal.privacy.dataCollected.technical.item1": "IP address",
"legal.privacy.dataCollected.technical.item2": "Browser type and version",
"legal.privacy.dataCollected.technical.item3": "Device information",

"legal.privacy.legalBasis.title": "Legal Basis for Processing (GDPR)",
"legal.privacy.legalBasis.text": "We process your personal data based on:",
"legal.privacy.legalBasis.consent.title": "Consent",
"legal.privacy.legalBasis.consent.text": "You provide explicit consent when creating an account",
"legal.privacy.legalBasis.contract.title": "Contract Performance",
"legal.privacy.legalBasis.contract.text": "Processing necessary to provide our services",
"legal.privacy.legalBasis.legitimate.title": "Legitimate Interests",
"legal.privacy.legalBasis.legitimate.text": "Improving our services and preventing fraud",

"legal.privacy.usage.title": "How We Use Your Data",
"legal.privacy.usage.item1": "To provide and improve our language learning services",
"legal.privacy.usage.item2": "To personalize your learning experience",
"legal.privacy.usage.item3": "To track your progress and generate study recommendations",
"legal.privacy.usage.item4": "To communicate with you about your account and services",
"legal.privacy.usage.item5": "To ensure platform security and prevent fraud",

"legal.privacy.sharing.title": "Data Sharing and Third Parties",
"legal.privacy.sharing.text": "We share your data only with trusted service providers:",
"legal.privacy.sharing.firebase": "For authentication, database, and cloud storage (Google Cloud Platform - GDPR compliant)",
"legal.privacy.sharing.resend": "For transactional emails (verification, notifications)",

"legal.privacy.retention.title": "Data Retention",
"legal.privacy.retention.text": "We retain your personal data for as long as your account is active or as needed to provide services. You may request deletion of your data at any time through your account settings.",

"legal.privacy.rights.title": "Your Rights Under GDPR",
"legal.privacy.rights.text": "As an EU resident, you have the following rights:",
"legal.privacy.rights.access": "Right to Access",
"legal.privacy.rights.accessDesc": "Request a copy of your personal data",
"legal.privacy.rights.rectification": "Right to Rectification",
"legal.privacy.rights.rectificationDesc": "Correct inaccurate data",
"legal.privacy.rights.erasure": "Right to Erasure",
"legal.privacy.rights.erasureDesc": "Delete your personal data ('right to be forgotten')",
"legal.privacy.rights.portability": "Right to Data Portability",
"legal.privacy.rights.portabilityDesc": "Receive your data in a structured format",
"legal.privacy.rights.objection": "Right to Object",
"legal.privacy.rights.objectionDesc": "Object to certain data processing",
"legal.privacy.rights.withdraw": "Right to Withdraw Consent",
"legal.privacy.rights.withdrawDesc": "Withdraw consent at any time",
"legal.privacy.rights.exercise": "To exercise these rights, please contact us at team@logami.app",

"legal.privacy.security.title": "Data Security",
"legal.privacy.security.text": "We implement appropriate technical and organizational measures to protect your data:",
"legal.privacy.security.item1": "Encryption of data in transit and at rest",
"legal.privacy.security.item2": "Regular security audits",
"legal.privacy.security.item3": "Access controls and authentication",

"legal.privacy.cookies.title": "Cookies and Tracking",
"legal.privacy.cookies.text": "We use cookies and similar technologies to improve your experience. For more information, please see our Cookie Policy.",

"legal.privacy.children.title": "Children's Privacy",
"legal.privacy.children.text": "Our services are intended for users aged 16 and above. We do not knowingly collect data from children under 16. If you believe we have collected data from a child, please contact us immediately.",

"legal.privacy.international.title": "International Data Transfers",
"legal.privacy.international.text": "Your data may be processed outside the EU through our service providers (Firebase/Google Cloud). These transfers comply with GDPR through Standard Contractual Clauses and adequacy decisions.",

"legal.privacy.changes.title": "Changes to This Policy",
"legal.privacy.changes.text": "We may update this Privacy Policy from time to time. We will notify you of significant changes via email or platform notification.",

"legal.privacy.contact.title": "Contact and Complaints",
"legal.privacy.contact.text": "For privacy-related questions or to exercise your rights, contact us:",
"legal.privacy.contact.authority": "You also have the right to lodge a complaint with the German data protection authority (Bundesbeauftragter für den Datenschutz und die Informationsfreiheit).",

"legal.privacy.footer.text": "Want to review or delete your personal data?",
"legal.privacy.footer.button": "Manage Data in Settings",

// === COOKIE POLICY ===
"legal.cookies.title": "Cookie Policy",

"legal.cookies.intro.title": "Introduction",
"legal.cookies.intro.text": "This Cookie Policy explains how Logami uses cookies and similar technologies to provide, improve, and protect our services.",

"legal.cookies.what.title": "What Are Cookies",
"legal.cookies.what.text": "Cookies are small text files stored on your device that help us recognize you and remember your preferences. They enable features like keeping you logged in and remembering your language settings.",

"legal.cookies.types.title": "Types of Cookies We Use",

"legal.cookies.types.essential.title": "Essential Cookies (Required)",
"legal.cookies.types.essential.text": "These cookies are necessary for the platform to function:",
"legal.cookies.types.essential.item1": "Authentication cookies (keep you logged in)",
"legal.cookies.types.essential.item2": "Security cookies (prevent fraud)",
"legal.cookies.types.essential.item3": "Session cookies (maintain your session)",

"legal.cookies.types.functional.title": "Functional Cookies (Optional)",
"legal.cookies.types.functional.text": "These cookies enhance your experience:",
"legal.cookies.types.functional.item1": "Language preference",
"legal.cookies.types.functional.item2": "Theme settings (dark/light mode)",
"legal.cookies.types.functional.item3": "Study preferences",

"legal.cookies.types.analytics.title": "Analytics Cookies (Optional)",
"legal.cookies.types.analytics.text": "These help us understand how you use Logami:",
"legal.cookies.types.analytics.item1": "Page views and navigation patterns",
"legal.cookies.types.analytics.item2": "Feature usage statistics",

"legal.cookies.thirdParty.title": "Third-Party Cookies",
"legal.cookies.thirdParty.text": "We use cookies from trusted third parties:",
"legal.cookies.thirdParty.firebase": "For authentication and data storage",
"legal.cookies.thirdParty.analytics": "For usage statistics (if enabled)",

"legal.cookies.control.title": "How to Control Cookies",
"legal.cookies.control.text": "You can control cookies through:",
"legal.cookies.control.item1": "Your browser settings (see instructions below)",
"legal.cookies.control.item2": "Our cookie preferences in Settings",
"legal.cookies.control.item3": "Opting out of non-essential cookies",

"legal.cookies.browser.title": "Browser Settings",
"legal.cookies.browser.text": "Most browsers allow you to manage cookies. Here's how:",

"legal.cookies.localStorage.title": "Local Storage",
"legal.cookies.localStorage.text": "In addition to cookies, we use browser local storage to save your study progress, exam data, and preferences locally on your device. This data is not transmitted to our servers unless you explicitly sync it.",

"legal.cookies.updates.title": "Updates to This Policy",
"legal.cookies.updates.text": "We may update this Cookie Policy periodically. We will notify you of significant changes.",

"legal.cookies.contact.title": "Contact Us",
"legal.cookies.contact.text": "For questions about our use of cookies, please contact us:",

"legal.cookies.table.title": "Cookie Details",
"legal.cookies.table.name": "Cookie Name",
"legal.cookies.table.purpose": "Purpose",
"legal.cookies.table.duration": "Duration",
"legal.cookies.table.type": "Type",
"legal.cookies.table.firebase": "Authentication and user session",
"legal.cookies.table.language": "Store language preference",
"legal.cookies.table.preferences": "Store user preferences",
"legal.cookies.table.session": "Session",
"legal.cookies.table.persistent": "Persistent",
"legal.cookies.table.essential": "Essential",
"legal.cookies.table.functional": "Functional",

"legal.cookies.footer.text": "Want to manage your cookie preferences?",
"legal.cookies.footer.button": "Cookie Settings",

// === AUTH PAGE CONSENT ===
"auth.consent.text": "By signing up, you agree to our",
"auth.consent.terms": "Terms of Service",
"auth.consent.and": "and",
"auth.consent.privacy": "Privacy Policy",
"auth.variantB.badge": "Your Free Course",
"auth.variantB.heading.signup": "Everything you need to pass",
"auth.variantB.heading.highlight": "your German exam",
"auth.variantB.heading.login": "Welcome back to",
"auth.variantB.description.signup": "Join 1,000+ students preparing for TELC, Goethe and OSD with structured lessons, mock exams and AI feedback.",
"auth.variantB.description.login": "Continue your personalized study plan and keep building toward exam success.",
"auth.variantB.feature1.title": "Full Mock Exams",
"auth.variantB.feature1.desc": "Timed simulations for every TELC, Goethe & OSD format",
"auth.variantB.feature2.title": "Expert Lessons",
"auth.variantB.feature2.desc": "Grammar, vocabulary and Redemittel for B1–C1",
"auth.variantB.feature3.title": "AI Writing Feedback",
"auth.variantB.feature3.desc": "Personalized corrections on every written answer",
"auth.variantB.teacherLabel": "Created by language experts",
"auth.variantB.stats.students": "students",
"auth.variantB.stats.passRate": "pass rate",
"auth.variantB.stats.rating": "avg. rating",
"auth.variantB.testimonial.quote": "Passed B2 on my first attempt. The mock exams were incredibly accurate, exactly what appeared on the real test.",
"auth.variantB.testimonial.author": "Sarah M.",
"auth.variantB.testimonial.details": "TELC B2 · Frankfurt",
"auth.variantB.formTitle.signup": "Start your free course",
"auth.variantB.formTitle.login": "Continue your course",
"auth.variantB.formSubtitle": "Free to start · No credit card required",
"auth.variantB.googleButton": "Continue with Google",
"auth.variantB.trust.ssl": "SSL encrypted",
"auth.variantB.trust.gdpr": "GDPR compliant",
"auth.variantB.trust.free": "Free to start",
"auth.variantB.trust.privacy": "Your data is private and secure",
        "dashboard.stats.daysInRow": "days in a row",
"dashboard.stats.accuracyRate": "accuracy rate",
"dashboard.stats.overallScore": "Overall Score",
"dashboard.stats.progress": "Progress",
"dashboard.vocabBreakdown.wordsLearned": "words learned",
"dashboard.vocabBreakdown.categories": "categories",
"dashboard.mistakes.topicsNeedReview": "topics need review",
"dashboard.mistakes.topicsAffected": "Topics Affected",
"dashboard.mistakes.focusOnWeak": "Focus on Weak Topics",
"dashboard.mistakes.mixedReview": "Practice Mixed Review",
"dashboard.quickActions.viewGrammar": "View All Grammar Topics",
"dashboard.quickActions.practiceVocabulary": "Practice Vocabulary",
        "dashboard.lastLesson.continueGrammar": "Continue Grammar",
"dashboard.lastLesson.newGrammar": "Start Grammar",
"dashboard.lastLesson.continueExam": "Continue Exam",
"dashboard.lastLesson.newExam": "Start Exam",

// ==========================================
// STREAK CELEBRATION MODAL
// ==========================================
"streak.celebration.dayStreak": "Day Streak",
"streak.celebration.cta": "Continue Learning",
"streak.celebration.milestone.default.headline": "Keep the flame alive.",
"streak.celebration.milestone.default.sub": "Show up every day and watch it grow.",
"streak.celebration.milestone.3.headline": "You're on a roll!",
"streak.celebration.milestone.3.sub": "Every session counts. Keep going.",
"streak.celebration.milestone.7.headline": "Week Warrior!",
"streak.celebration.milestone.7.sub": "One full week. German is becoming a habit.",
"streak.celebration.milestone.14.headline": "Two-Week Champion!",
"streak.celebration.milestone.14.sub": "Consistency is building something real.",
"streak.celebration.milestone.30.headline": "Monthly Master!",
"streak.celebration.milestone.30.sub": "30 days of daily German. Remarkable.",
"streak.celebration.milestone.100.headline": "Century Club!",
"streak.celebration.milestone.100.sub": "100 days in. You're in rare company.",
"streak.celebration.milestone.365.headline": "Year Legend!",
"streak.celebration.milestone.365.sub": "A full year of German. Extraordinary.",

// === BLOG PAGE ===
"blog.title": "Blog",
"blog.hero.badge": "Blog",
"blog.hero.heading": "Our Blog",
"blog.hero.subtitle": "Tips, tricks, and insights into the world of German language exams.",
"blog.featured.label": "Latest Article",
"blog.card.read": "Read",
"blog.empty": "More articles coming soon.",
"blog.showMore": "Show more articles",
"blog.showingCount": "Showing {{shown}} of {{total}} articles",

// Reading Practice Word Tools
"readingTools.toolbarLabel": "Reading word tools",
"readingTools.close": "Close",
"readingTools.markerToggle": "Toggle marker mode",
"readingTools.markerOn": "Marker on",
"readingTools.markerOff": "Marker",
"readingTools.markerHint": "Tap Marker, then select text to highlight, save, or translate.",
"readingTools.highlight": "Highlight",
"readingTools.removeHighlight": "Remove",
"readingTools.save": "Save",
"readingTools.translate": "Translate",
"readingTools.translating": "Translating...",
"readingTools.translation": "Translation:",
"readingTools.highlighted": "Word highlighted",
"readingTools.removed": "Highlight removed",
"readingTools.saved": "Saved to vocabulary",
"readingTools.saveError": "Could not save word",
"readingTools.translationError": "Translation failed",
"readingTools.loginRequired": "Please sign in to save words",
"readingTools.singleWordOnly": "Please select text from the reading passage",

// ==========================================
// TELC B1 CAMPAIGN LANDING PAGE
// ==========================================
// Hero
"telcB1.hero.badgeSub": "Complete Prep Course",
"telcB1.hero.headlineBold": "Pass Your TELC B1",
"telcB1.hero.headlineAccent": "with real video lessons.",
"telcB1.hero.subheadline": "The complete TELC B1 prep course: video lessons taught by certified examiners, AI mock exams, and targeted grammar practice.",
"telcB1.hero.point1": "Full video lessons for every TELC B1 module",
"telcB1.hero.point2": "Lots of realistic mock exams with instant scoring",
"telcB1.hero.point3": "Grammar & vocabulary built for B1 level",
"telcB1.hero.cta": "Start Free. No Card Needed",
"telcB1.hero.tryFree": "Try a free exam",
"telcB1.hero.chipExams": "TELC B1 certified",
"telcB1.hero.chipLevels": "All 4 exam modules covered",
// Course bento section
"telcB1.course.titleBefore": "Everything you need to",
"telcB1.course.titleHighlight": "pass TELC B1",
"telcB1.course.titleAfter": "in one place.",
"telcB1.course.video.label": "Video Lessons",
"telcB1.course.video.title": "Full Video Lessons for Every Module",
"telcB1.course.video.desc": "Structured video lessons covering Lesen, Hören, Schreiben, and Sprechen, taught by certified German examiners, not just AI.",
// Lesson section
"telcB1.lessonSection.badge": "Real Lesson Preview",
"telcB1.lessonSection.title": "Watch a real TELC B1 lesson",
"telcB1.lessonSection.subtitle": "This is exactly what you get, structured, exam-focused lessons made by certified teachers.",
"telcB1.lessonSection.cta": "Start with this lesson for free",
// Social proof
"telcB1.proof.testimonialQuote": "The video lessons finally made the Schreiben section click for me. I passed B1 on my first attempt.",
"telcB1.proof.testimonialInitial": "M",
"telcB1.proof.testimonialName": "Marta K.",
"telcB1.proof.testimonialExam": "TELC B1, passed first attempt",
// Final CTA
"telcB1.finalCta.title": "Ready to pass TELC B1?",
"telcB1.finalCta.subtitle": "Join students who prepared with real video lessons and AI practice. Start for free, no credit card needed.",

// ==========================================
// TELC B2 CAMPAIGN LANDING PAGE
// ==========================================
// Hero
"telcB2.hero.badgeSub": "Complete Prep Platform",
"telcB2.hero.headlineBold": "Pass TELC B2",
"telcB2.hero.headlineAccent": "on the first try.",
"telcB2.hero.subheadline": "The complete TELC B2 prep platform: full mock exams, targeted grammar training, and Redemittel, built by certified German examiners.",
"telcB2.hero.point1": "Full TELC B2 mock exams with instant scoring",
"telcB2.hero.point2": "Targeted Lesen, Hören, Schreiben & Sprechen practice",
"telcB2.hero.point3": "Grammar & Redemittel built for B2 level",
"telcB2.hero.cta": "Start Free. No Card Needed",
"telcB2.hero.tryFree": "Try a free exam",
"telcB2.hero.chipExams": "TELC B2 certified",
"telcB2.hero.chipLevels": "All 4 exam modules covered",
// Course bento section
"telcB2.course.titleBefore": "Everything you need to",
"telcB2.course.titleHighlight": "pass TELC B2",
"telcB2.course.titleAfter": "in one place.",
"telcB2.course.mock.label": "Mock Exams",
"telcB2.course.mock.title": "Full TELC B2 Mock Exams",
"telcB2.course.mock.desc": "Authentic B2-level simulations covering all four modules. Timed, scored, with detailed feedback on every task.",
// Social proof
"telcB2.proof.testimonialQuote": "Logami's mock exams are exactly what I needed for B2. The Schreiben section feedback helped me understand my mistakes before the real exam.",
"telcB2.proof.testimonialInitial": "A",
"telcB2.proof.testimonialName": "Andreas M.",
"telcB2.proof.testimonialExam": "TELC B2, passed first attempt",
// Final CTA
"telcB2.finalCta.title": "Ready to pass TELC B2?",
"telcB2.finalCta.subtitle": "Join students who prepared smarter with full mock exams and AI-powered practice. Start for free, no credit card needed.",

// Public mock-exam landing pages (/mock-exams, /mock-exams/:examSlug).
// {{examName}}, {{level}}, {{provider}}, {{duration}}, {{points}}, {{variants}},
// {{count}} and {{pass}} are interpolated from src/data/mockExamCatalog.js.
"mockExam.meta.title": "{{seoName}} Modelltest Online: Free Mock Exam with Answers | Logami",
"mockExam.meta.description": "{{variants}} complete {{seoName}} Modelltests in the official format: all sections, {{minutes}} minutes of working time, with the correct answers shown the moment you submit.",
"mockExam.breadcrumb": "Mock exams",
"mockExam.hero.accent": "Modelltest Online",
"mockExam.hero.intro": "Sit the complete {{examName}} in the official format: all {{count}} sections, {{duration}} of working time, against a live clock. {{variants}} full papers are available, each with different texts and questions, and every marked question shows you the correct answer at the end.",
"mockExam.stats.heading": "{{seoName}} at a glance",
"mockExam.stats.duration": "Minutes",
"mockExam.stats.durationSub": "Working time across all sections.",
"mockExam.stats.points": "Total points",
"mockExam.stats.pointsSub": "You need {{pass}}% of them to pass.",
"mockExam.stats.sections": "Sections",
"mockExam.stats.sectionsSub": "Each on its own official clock.",
"mockExam.stats.papers": "Modelltests",
"mockExam.stats.papersSub": "Every one a complete paper, not an extract.",
"mockExam.format.heading": "{{seoName}} exam format",
"mockExam.format.caption": "Sections, duration and points for the {{examName}} exam",
"mockExam.format.section": "Section",
"mockExam.format.english": "English",
"mockExam.format.time": "Time",
"mockExam.format.points": "Points",
"mockExam.format.total": "Total",
"mockExam.format.shared": "shared clock",
"mockExam.format.guide": "Read the {{seoName}} exam guide",
"mockExam.format.redemittel": "{{seoName}} Redemittel for Schreiben and Sprechen (free PDF)",
"mockExam.format.sprechen": "{{seoName}} Sprechen: sample oral exams with model dialogues",
"mockExam.format.noteModular": "Pass mark: {{pass}}%. Each module is scored independently and can be retaken on its own.",
"mockExam.format.noteSeparate": "Pass mark: {{pass}}%. The written and oral parts are graded separately and each must reach {{pass}}%.",
"mockExam.papers.heading": "Inside the {{seoName}} Modelltests",
"mockExam.papers.intro": "Each paper carries its own texts, recordings and tasks. Here are the first few of the {{variants}}.",
"mockExam.papers.more": "Another {{count}} {{seoName}} papers are waiting inside.",
"mockExam.papers.cta": "Sit the first one free",
"mockExam.terms.headingGeneric": "Modelltest or Prüfung?",
"mockExam.terms.officialGeneric": "The Prüfung is the real exam, sat at a licensed centre. {{provider}} publishes one official Modelltest so you can see the format for yourself, free to download from their own site. Logami’s {{variants}} {{seoName}} papers are built to that same format, with their own texts and tasks.",
"mockExam.terms.heading": "Modelltest, {{paperTerm}} or Prüfung?",
"mockExam.terms.official": "The Prüfung is the real exam, sat at a licensed centre. The {{paperTerm}} is the official sample paper {{provider}} publishes so you can see the format for yourself, free to download from their own site. A Modelltest is any full-length paper built to that same format, which is what Logami’s {{variants}} {{seoName}} papers are.",
"mockExam.terms.pdf": "Logami’s papers are not PDFs. They run in the browser on the official clock, mark themselves, and put the correct answer next to yours when you submit. That is the part a printed Modelltest mit Lösungen cannot do.",
"mockExam.included.heading": "What you get for {{level}}",
"mockExam.included.papers": "{{variants}} complete papers, each with different texts and questions",
"mockExam.included.timed": "Timed simulator matching the official section structure",
"mockExam.included.writing": "Schreiben feedback scored against the examiner rubric",
"mockExam.included.drills": "Separate Lesen, Hören and Schreiben drills for one weak section",
"mockExam.included.redemittel": "Redemittel phrase guides for writing and speaking",
"mockExam.included.plan": "A study plan built backwards from your exam date",
"mockExam.faq.heading": "{{seoName}} questions, answered",
"mockExam.faq.duration.q": "How long does the {{seoName}} exam take?",
"mockExam.faq.duration.a": "The {{examName}} takes {{duration}} of working time in total across all sections, excluding breaks and the preparation time before the oral exam.",
"mockExam.faq.pass.q": "What score do I need to pass the {{seoName}}?",
"mockExam.faq.pass.a.modular": "You need {{pass}}% to pass. Each of the four modules is scored independently out of 100 points, so you can pass, and retake, modules one at a time.",
"mockExam.faq.pass.a.separate": "You need {{pass}}% overall, out of {{points}} points. The written and oral parts are graded separately and you must reach {{pass}}% in each. Passing one does not compensate for failing the other.",
"mockExam.faq.free.q": "Can I take a {{seoName}} mock exam for free?",
"mockExam.faq.free.a": "Yes. You can start a full mock exam on Logami without creating an account. You only need a free account to see the full scored breakdown of your answers.",
"mockExam.faq.count.q": "How many {{seoName}} practice tests are there?",
"mockExam.faq.count.a": "Logami has {{variants}} complete {{examName}} papers. Each follows the same official format but uses different reading texts, listening recordings and questions, so you can sit the exam repeatedly without repeating content.",
"mockExam.faq.pdf.q": "Is there a {{seoName}} Modelltest PDF with answers?",
"mockExam.faq.pdf.a": "Logami’s papers are not PDFs. They run in the browser, mark themselves, and show the correct answer beside yours as soon as you submit, so there is nothing to print or check by hand. If you specifically want a paper to print, {{provider}} publishes a free official {{paperTerm}} on its own website.",
"mockExam.faq.difference.q": "What is the difference between a Modelltest and the real Prüfung?",
"mockExam.faq.difference.a": "The Prüfung is the exam you sit at a licensed centre for a certificate. A Modelltest is a full-length practice paper in exactly that format: the same sections in the same order, the same timing and the same point split. Logami has {{variants}} {{seoName}} Modelltests, so nothing about the format is new to you on the day.",
"mockExam.faq.realistic.q": "Are these mock exams like the real exam?",
"mockExam.faq.realistic.a": "They follow the official section structure, timing, task types and scoring shown in the table above, and run against a live clock. They are full-length simulations rather than shortened practice exercises. Logami is independent and not affiliated with {{provider}}.",
"mockExam.faq.writing.q": "Is my writing corrected?",
"mockExam.faq.writing.a": "Yes. Submit your Schreiben response and you receive a score and feedback modelled on the official examiner rubric for {{level}}. This is AI-generated feedback, not a human examiner.",
"mockExam.cta.heading": "Sit a full {{seoName}} Modelltest",
"mockExam.cta.body": "Start now without creating an account. You only need a free account to see your full scored breakdown.",
"mockExam.cta.button": "Start a free mock exam",
"mockExam.related.heading": "Other exams",
"mockExam.related.papers": "{{count}} Modelltests",
"mockExam.notFound.title": "Exam not found",
"mockExam.notFound.cta": "See all mock exams",
"mockExamIndex.meta.title": "German Modelltest Online: telc, Goethe & ÖSD Mock Exams B1–C1 | Logami",
"mockExamIndex.meta.description": "Full-length Modelltests for telc, Goethe-Zertifikat and ÖSD at B1, B2 and C1. Official format, real timing, and the correct answers the moment you submit. Free to start.",
"mockExamIndex.title": "German mock exams",
"mockExamIndex.intro": "Full-length mock exams for telc, Goethe-Zertifikat and ÖSD at B1, B2 and C1. Official format, real timing, and writing feedback scored against the examiner rubric. Pick your exam to see its structure, timing and scoring.",
"mockExamIndex.card.cta": "See format",
"footer.mockExams": "Mock exams",

// ==========================================
// END OF TRANSLATIONS
// ==========================================

    // ── Mock exam hub (/:lang/mock-exams) ──
    "mockExamIndex.hero.before": "Sit the real thing",
    "mockExamIndex.hero.accent": "before you sit the real thing.",
    "mockExamIndex.hero.sub": "Full-length telc Übungstests, Goethe Modellsätze and ÖSD Modelltests at B1, B2 and C1. Official format, official timing, marked with the correct answers the moment you finish. No account needed to start.",
    "mockExamIndex.hero.cta": "Take a free mock exam",
    "mockExamIndex.scale.heading": "How big the library is",
    "mockExamIndex.scale.papers": "Mock exams",
    "mockExamIndex.scale.papersSub": "Every one a complete exam, not an extract.",
    "mockExamIndex.scale.exams": "Exam formats",
    "mockExamIndex.scale.examsSub": "telc, Goethe-Zertifikat and ÖSD at B1, B2 and C1.",
    "mockExamIndex.scale.skills": "Skills in each",
    "mockExamIndex.scale.skillsSub": "Lesen, Hören, Schreiben and Sprechen, on the official clock.",
    "mockExamIndex.scale.hours": "Of exam time",
    "mockExamIndex.scale.hoursSub": "One full sitting of every format we cover.",
    "mockExamIndex.inside.heading": "What you get in every mock exam",
    "mockExamIndex.inside.format.title": "The exact format",
    "mockExamIndex.inside.format.body": "The official section order, question types and point split for that exam, not an approximation.",
    "mockExamIndex.inside.timing.title": "Real timing",
    "mockExamIndex.inside.timing.body": "The real clock. Each section runs for exactly as long as it does on the day.",
    "mockExamIndex.inside.scoring.title": "Scored instantly",
    "mockExamIndex.inside.scoring.body": "A score the moment you finish, with your writing marked against the examiner rubric.",
    "mockExamIndex.pick.heading": "Pick your exam",
    "mockExamIndex.pick.paperCount": "{{count}} mock exams",
    "mockExamIndex.card.papers": "{{count}} mock exams",
    "mockExamIndex.card.points": "{{count}} points",
    "mockExamIndex.card.guide": "Read the {{seoName}} guide",
    "paperExam.viewer.back": "Back",
    "paperExam.viewer.pageOf": "{{current}} / {{total}}",
    "paperExam.viewer.zoom": "Zoom",
    "paperExam.viewer.zoomIn": "Zoom in",
    "paperExam.viewer.zoomOut": "Zoom out",
    "paperExam.viewer.fitWidth": "Fit to width",
    "paperExam.viewer.narrowHint": "The paper exam works best on a tablet or computer. Use + to zoom in.",
    "paperExam.viewer.dismiss": "Got it",
    "paperExam.viewer.choosePaper": "Choose paper",
    "paperExam.viewer.chooseExam": "Choose exam",
    "paperExam.viewer.loadError": "Could not load this paper ({{error}}).",
    "paperExam.viewer.showSheet": "Answer sheet",
    "paperExam.viewer.showBooklet": "Booklet",
    "paperExam.session.clockLabel": "Time remaining",
    "paperExam.session.handIn": "Hand in",
    "paperExam.session.handInTitle": "Hand in your answer sheet?",
    "paperExam.session.keepWorking": "Keep working",
    "paperExam.session.unanswered": "{{count}} of {{total}} questions are still unanswered. Only the answer sheet is marked.",
    "paperExam.session.allAnswered": "All {{total}} questions are answered. Only the answer sheet is marked.",
    "paperExam.session.listeningEarly": "The recording is still playing. If you hand in now, it stops and you cannot go back to {{name}}.",
    "paperExam.session.timeUpTitle": "Time is up",
    "paperExam.session.timeUpBody": "The 90 minutes are over and your answer sheet has been collected.",
    "paperExam.session.resultTitle": "Your result",
    "paperExam.session.resultCorrect": "{{correct}} of {{total}} answers correct",
    "paperExam.session.resultSection": "{{name}}: {{score}} of {{max}} points",
    "paperExam.session.viewSheet": "See the marked answer sheet",
    "paperExam.session.tryAgain": "Start again",
    "paperExam.session.handInBlockTitle": "Hand in {{name}}?",
    "paperExam.session.collectedTitle": "{{name}}: handed in",
    "paperExam.session.collectedBody": "Page {{page}} of your answer sheet has been collected.",
    "paperExam.session.collectedSheet": "Your {{name}} answer sheet has been collected.",
    "paperExam.session.nextListeningNamed": "Next is {{name}} (page {{page}}). The recording starts as soon as you continue and runs without stopping, like in the exam.",
    "paperExam.session.transferLabel": "Time left to transfer your answers",
    "paperExam.session.goethePassMark": "Each module is marked out of 100 points and passed with 60.",
    "paperExam.session.nextListening": "Next is Hörverstehen (page {{page}}). The recording starts as soon as you continue and runs without stopping, like in the exam.",
    "paperExam.session.nextTimed": "Next is {{name}}: {{minutes}} minutes, starting on page {{page}} of the booklet.",
    "paperExam.session.continueTo": "Continue to {{name}}",
    "paperExam.audio.loading": "Loading the recording…",
    "paperExam.audio.error": "The recording could not be loaded. Sign in on this browser, then reload.",
    "paperExam.audio.start": "Start the recording",
    "paperExam.audio.resume": "Continue",
    "examSimulator.confirm.abortTitle": "Abort the exam?",
    "examSimulator.confirm.abortBody": "All your answers in this exam will be lost.",
    "examSimulator.confirm.abort": "Abort exam",
    "examSimulator.confirm.finishTitle": "Finish the exam?",
    "examSimulator.confirm.finishBody": "Your answers will be handed in and scored. You can't change them afterwards.",
    "examSimulator.confirm.finish": "Finish exam",
    "examSimulator.confirm.keepGoing": "Keep going",
    "paperExam.leave.title": "Leave the paper exam?",
    "paperExam.leave.body": "Your sitting stays saved on this device, so you can continue where you left off.",
    "paperExam.leave.stay": "Stay",
    "paperExam.leave.go": "Leave",
    "paperExam.nav.title": "Exam parts",
    "paperExam.nav.open": "Show exam parts",
    "paperExam.nav.close": "Close",
    "examMode.title": "How do you want to sit the exam?",
    "examMode.recommended": "Recommended",
    "examMode.paper.title": "Paper",
    "examMode.paper.body": "Just like the printed exam: you read the tasks in the booklet and mark your answers on a separate answer sheet, the way you will on exam day.",
    "examMode.digital.title": "Digital",
    "examMode.digital.body": "One part at a time on screen, with your answers right next to the questions. Quick and easy on any device.",
    "examMode.notes.title": "How the paper exam works",
    "examMode.notes.booklet": "The tasks are in the booklet; you mark your answers on the answer sheet beside it, as in the real exam.",
    "examMode.notes.blocks": "The exam runs in blocks with their own time: Reading and Language Elements together, then Listening (the recording plays once), then Writing.",
    "examMode.notes.blocksGoethe": "The exam runs module by module, each with its own time: Reading, then Listening (the recording plays through, then you have a few minutes to finish your answer sheet), then Writing.",
    "examMode.notes.handIn": "When you hand in a block, its answer sheet is collected and you can't change it any more.",
    "examMode.notes.results": "At the end you get your score, your answers checked against the key and an AI correction of your text.",
    "examMode.notes.speaking": "The oral exam (Speaking) is coming soon.",
    "examMode.formatTitle": "The exam at a glance",
    "paperExam.nav.short": "Parts",
    "paperExam.nav.barLabel": "Exam navigation",
    "paperExam.nav.collapse": "Collapse the exam parts",
    "paperExam.nav.pin": "Keep the exam parts open",
    "paperExam.nav.page": "p. {{page}}",
    "paperExam.nav.status.current": "Now",
    "paperExam.nav.status.done": "Handed in",
    "paperExam.nav.status.locked": "Not yet open",
    "paperExam.nav.status.open": "Open",
    "paperExam.nav.minutes": "{{minutes}} min",
    "paperExam.nav.recording": "about {{minutes}} min, recording",
    "paperExam.nav.afterExam": "after the written exam",
    "paperExam.nav.shared": "within the same 90 min",
    "paperExam.nav.solutions": "Answer key & transcripts",
    "paperExam.session.showResult": "Result",
    "paperExam.session.handInBlock": "Hand in {{name}}",
    "paperExam.ready.answersTitle": "All {{total}} answers are marked.",
    "paperExam.ready.wordsTitle": "{{count}} words written, enough for the task.",
    "paperExam.ready.body": "Check anything you like, then hand in to continue.",
    "paperExam.session.writtenPassed": "Written exam: {{score}} of {{max}} points. Passed (you need {{needed}}).",
    "paperExam.session.writtenFailed": "Written exam: {{score}} of {{max}} points. Not passed yet (you need {{needed}}).",
    "paperExam.session.osdGrade": "Grade: {{grade}}",
    "paperExam.session.osdMinimum": "Every part has a minimum too, and you are below it in: {{parts}}.",
    "paperExam.session.osdSubtest.lesen": "Lesen (needs 10 of 20)",
    "paperExam.session.osdSubtest.hoeren": "Hören (needs 10 of 20)",
    "paperExam.session.osdSubtest.schreiben": "Schreiben (needs 15 of 30)",
    "paperExam.session.osdSubtest.schreiben1": "Schreiben Aufgabe 1 (needs 7 of 15)",
    "paperExam.session.osdSubtest.schreiben2": "Schreiben Aufgabe 2 (needs 7 of 15)",
    "paperExam.session.osdSubtest.schreibenTasks": "Schreiben (needs 7 of 15 in each task)",
    "paperExam.writing.seeCorrection": "See the correction",
    "paperExam.writing.correctionTitle": "Your text, corrected",
    "paperExam.writing.status.pending": "{{name}}: being marked by the AI…",
    "paperExam.writing.status.empty": "{{name}}: nothing written, 0 points.",
    "paperExam.writing.status.signin": "{{name}}: sign in to have your text marked.",
    "paperExam.writing.status.limit": "{{name}}: your free AI correction has been used. Upgrade to have this text marked.",
    "paperExam.writing.status.error": "{{name}}: the correction did not work. Please try again later.",
    "paperExam.writing.status.idle": "{{name}}: waiting to be marked.",
    "paperExam.writing.pageLabel": "Answer sheet page {{page}}: write your text here",
    "paperExam.writing.boxLabel": "Answer sheet, {{name}}: write your text here",
    "paperExam.writing.taskWords": "{{name}}: {{count}} words (the task asks for about {{target}}).",
    "paperExam.writing.wordCount": "You have written {{count}} words. The task asks for at least {{min}}.",
    "paperExam.writing.themaMissing": "You haven't marked which Thema you wrote. Mark Thema 1 or 2 at the top of answer sheet page 5 so your letter is corrected against the right task.",
    "paperExam.notes.label": "Answer sheet page 4: note {{number}}",
    "paperExam.notes.status.pending": "Hörverstehen, notes 65–74: being marked by the AI…",
    "paperExam.notes.status.signin": "Hörverstehen, notes 65–74: sign in to have your notes marked. Until then only notes that match the key word for word count.",
    "paperExam.notes.status.error": "Hörverstehen, notes 65–74: the notes could not be marked right now. Until then only notes that match the key word for word count.",
    "paperExam.notes.status.idle": "Hörverstehen, notes 65–74: not marked yet.",
    // Win-back survey (/:lang/survey/:token)
    "survey.pageTitle": "Help us make Logami better | Logami",
    "survey.loading": "Loading the survey",
    "survey.badge": "5-minute survey · 50% thank-you",
    "survey.title": "Hi {{name}}, help us make Logami better",
    "survey.titleNoName": "Help us make Logami better",
    "survey.intro": "Ten quick questions, about 5 minutes. Honest answers help us most, and when you're done you get a personal 50% code as a thank-you.",
    "survey.pickAll": "Pick all that apply",
    "survey.pickUpTo": "Pick up to {{count}}",
    "survey.optional": "Optional",
    "survey.followUp": "Anna may email me with one or two follow-up questions.",
    "survey.progress": "{{done}} of {{total}} answered",
    "survey.submit": "Get my 50% code",
    "survey.errors.submit": "Something went wrong while sending your answers. Please try again.",
    "survey.notFound.title": "This survey link doesn't work",
    "survey.notFound.body": "Please open the link straight from Anna's email. If it still doesn't work, write to us and we'll sort it out.",
    "survey.error.title": "We couldn't load the survey",
    "survey.error.body": "Please check your connection and reload the page. If it keeps happening, write to us.",
    "survey.contact": "Contact us",
    "survey.done.title": "Thank you, {{name}}!",
    "survey.done.titleNoName": "Thank you!",
    "survey.done.body": "Your answers are in. Here is your personal code for 50% off any plan.",
    "survey.done.codeLabel": "Your code",
    "survey.done.copy": "Copy code",
    "survey.done.copied": "Copied",
    "survey.done.validity": "Valid once, until {{date}}. Enter it at checkout.",
    "survey.done.cta": "See plans",
    "survey.done.emailed": "We've also sent the code to your email.",
    "survey.q.progress.label": "How far did you get with Logami?",
    "survey.q.progress.options.looked": "I only looked around",
    "survey.q.progress.options.startedExam": "I started a mock exam but stopped",
    "survey.q.progress.options.finishedExam": "I finished a full mock exam",
    "survey.q.progress.options.otherFeatures": "I used lessons, vocabulary or grammar only",
    "survey.q.reasons.label": "What stopped you from buying full access?",
    "survey.q.reasons.options.justTrying": "I just wanted to try it",
    "survey.q.reasons.options.tooExpensive": "Too expensive",
    "survey.q.reasons.options.bugs": "Bugs or technical problems",
    "survey.q.reasons.options.quality": "The exam quality wasn't convincing",
    "survey.q.reasons.options.tooEasy": "The exams felt too easy",
    "survey.q.reasons.options.tooHard": "The exams felt too hard",
    "survey.q.reasons.options.notCovered": "My exam or level isn't covered well",
    "survey.q.reasons.options.examFar": "My exam is still far away",
    "survey.q.reasons.options.otherResource": "I use something else",
    "survey.q.reasons.options.other": "Something else",
    "survey.q.reasons.textPlaceholder": "Tell us more (optional)",
    "survey.q.overall.label": "How would you rate your overall experience?",
    "survey.q.overall.star": "{{count}} stars",
    "survey.q.realism.label": "How close did the mock exam feel to the real exam?",
    "survey.q.realism.labelExam": "How close did the mock exam feel to the real {{exam}}?",
    "survey.q.realism.low": "Not at all",
    "survey.q.realism.high": "Very close",
    "survey.q.realism.options.none": "I didn't do a mock exam",
    "survey.q.difficulty.label": "How difficult did the exam feel?",
    "survey.q.difficulty.options.muchEasy": "Much too easy",
    "survey.q.difficulty.options.bitEasy": "A bit easy",
    "survey.q.difficulty.options.right": "About right",
    "survey.q.difficulty.options.bitHard": "A bit hard",
    "survey.q.difficulty.options.muchHard": "Much too hard",
    "survey.q.difficulty.options.none": "I didn't try an exam",
    "survey.q.bugs.label": "Did anything break or feel buggy?",
    "survey.q.bugs.options.no": "No, everything worked",
    "survey.q.bugs.options.small": "Small issues",
    "survey.q.bugs.options.blocking": "Yes, it stopped me",
    "survey.q.bugs.textPlaceholder": "What happened? (optional)",
    "survey.q.price.label": "Full access costs {{monthly}} for 1 month or {{quarterly}} for 3 months. How does that feel?",
    "survey.q.price.options.tooCheap": "Too cheap",
    "survey.q.price.options.fair": "Fair",
    "survey.q.price.options.bitHigh": "A bit high",
    "survey.q.price.options.muchHigh": "Much too high",
    "survey.q.features.label": "Which features would you use most?",
    "survey.q.features.options.paper": "Paper exam mode",
    "survey.q.features.options.digital": "Digital exam simulator",
    "survey.q.features.options.writingAi": "AI writing correction",
    "survey.q.features.options.vocabulary": "Vocabulary",
    "survey.q.features.options.grammar": "Grammar",
    "survey.q.features.options.redemittel": "Redemittel",
    "survey.q.examDate.label": "When is your exam?",
    "survey.q.examDate.options.lt1": "Within 1 month",
    "survey.q.examDate.options.m1to3": "In 1–3 months",
    "survey.q.examDate.options.m3to6": "In 3–6 months",
    "survey.q.examDate.options.gt6": "In more than 6 months",
    "survey.q.examDate.options.notBooked": "Not booked yet",
    "survey.q.comments.label": "Anything else you'd like to tell us?",
    "survey.q.comments.placeholder": "What would make Logami worth it for you?",
    // Plan line-up since Oct 2026: Free / 3 months / Premium (see src/config/plans.js).
    "pricing.lineup.free.name": "Free",
    "pricing.lineup.free.headline": "See if Logami is right for you",
    "pricing.lineup.free.description": "No credit card. No time limit.",
    "pricing.lineup.free.benefits": ["1 full mock exam (one attempt)", "1 AI writing correction", "Lesson and grammar overviews"],
    "pricing.lineup.free.trustLine": "No credit card required",
    "pricing.lineup.quarterly.name": "3 Months",
    "pricing.lineup.quarterly.headline": "Everything you need to pass.",
    "pricing.lineup.quarterly.description": "Full access for 90 days",
    "pricing.lineup.quarterly.benefits": ["All mock exams for your exam, in digital and paper mode", "Unlimited AI writing correction with scores", "Hören, lessons, grammar, vocabulary and Redemittel", "A study plan up to your exam day"],
    "pricing.lineup.quarterly.trustLine": "One-time payment · 90 days · no subscription",
    "pricing.lineup.premium.name": "Premium",
    "pricing.lineup.premium.headline": "Prepare with a real German teacher.",
    "pricing.lineup.premium.description": "Everything in 3 Months for twice as long, plus your teacher",
    "pricing.lineup.premium.benefits": ["6 months of full access (instead of 3)", "5 personal 20-minute Zoom sessions: strategy and Sprechen practice", "10 texts corrected personally by your teacher", "Priority support"],
    "pricing.lineup.premium.trustLine": "One-time payment · 6 months · no subscription",
    "pricing.lineup.premium.cycle": "6 months",
    "pricing.lineup.premium.badge": "Limited places",
    "aha.lineup.quarterly.cycle": "for 3 months",
    "aha.lineup.quarterly.features": ["All mock exams and variants", "Unlimited AI writing correction with scores", "All Hören, lessons, grammar and vocabulary", "90 days, one-time payment"],
    "aha.lineup.premium.cycle": "for 6 months",
    "aha.lineup.premium.features": ["6 months of full access", "5 Zoom sessions with your teacher", "10 texts corrected by your teacher", "Priority support"],
    "home.pricing.planPremium": "Premium",
    "home.pricing.lineup.free1": "1 full mock exam",
    "home.pricing.lineup.free2": "1 AI writing correction",
    "home.pricing.lineup.free3": "Lesson and grammar overviews",
    "home.pricing.lineup.quarterly1": "All mock exams, digital and paper mode",
    "home.pricing.lineup.quarterly2": "Unlimited AI writing correction",
    "home.pricing.lineup.quarterly3": "Hören, grammar, vocabulary, Redemittel",
    "home.pricing.lineup.quarterly4": "One-time payment, 90 days",
    "home.pricing.lineup.premium1": "6 months of full access",
    "home.pricing.lineup.premium2": "5 Zoom sessions with your teacher",
    "home.pricing.lineup.premium3": "10 texts corrected by your teacher",
    "home.pricing.lineup.premium4": "Limited places each month",
    "home.comparison.costLogamiV2": "€39,99 for 3 months",
    "faq.answers.paymentAccessV2": "The 3-month plan gives you 90 days of access, Premium gives you 6 months. When it ends, you can simply buy again. Nothing renews automatically.",
    "consultation.premiumOnly": "Personal Zoom sessions with your teacher are part of Premium.",
    "checkout.accessLabel": "{{days}} days of access · one-time payment",
    "survey.q.price.labelV2": "Full access costs {{quarterly}} for 3 months. How does that feel?",
    // Premium "Ask my teacher" (src/components/practice/writing/AskTeacherPanel.jsx)
    "teacherCorrection.title": "Your teacher",
    "teacherCorrection.ask": "Ask my teacher",
    "teacherCorrection.remaining": "{{remaining}} of {{allowance}} left",
    "teacherCorrection.askHint": "Your teacher corrects this text personally. You get an email when the feedback is ready.",
    "teacherCorrection.requested": "Sent to your teacher. You'll get an email when the feedback is ready.",
    "teacherCorrection.feedback": "Feedback from your teacher",
    "teacherCorrection.corrected": "Your text, corrected",
    "teacherCorrection.noneLeft": "You have used all your teacher corrections.",
    "teacherCorrection.error": "Couldn't send the text. Please try again.",
    "teacherCorrection.upsell": "Want a real teacher to correct this? Premium includes 10 personal corrections.",
    "teacherCorrection.upsellLink": "See Premium",
  }
  };
